import React, { Component } from "react";
import { Link, withRouter } from "react-router-dom";
import _, { times } from "lodash";
import "font-awesome/css/font-awesome.min.css";
import Fuse from "fuse.js";
import SelectDropDown from "./shared/drop-down/drop-down";
import SendLinkMerchant from "./modals/send-link-merchant";
import AddApplicationModal from "./modals/add-new-application-modal/add-applications-modal";
import AddPricingEquipmentModal from "./modals/add-pricing-equipment-modal/add-pricing-equipment-modal";

import ShowDocsModal from "./modals/show-docs-modal/show-docs-modal";
import DOMPurify from "dompurify";
import AlertForSendSignature from "./alerts/AlertForSendSignature";
import ProgressApproval from "./modals/progress-approval/index";
import { getAlertPopUp } from "./helper/helper";
import imgCancelapp from "../../images/Cancelapp.png";
import imgNcheck from "../../images/ncheck.svg";
import { MentionsInput, Mention } from "react-mentions";
import axios from "axios";
import AssignBankModal from "./modals/assign-bank-modal/assign-bank-modal";
import {
    getPreapp,
    UserData,
    Uploads,
    getPreappById,
    starApp,
    Logout,
    OrganisationData,
    getUser,
    addNotes,
    deleteNote,
    addTodo,
    getTodo,
    updateTodo,
    deleteTodo,
    updateImportant,
    updateProgression,
    resendSignature,
    getFiles,
    getMerchantInfo,
    getNotes,
    bankList,
    runPdf,
    sendSignature,
    cancelApp,
    copyApp,
    changeOwner,
    cancelSignature,
    DeleteFile,
    GetOrganizationById,
    GetAllOrganizationsSingleCall,
    reviveApplication,
    getExportCSVLink,
    ChangePrevetApplicationStatus,
    getBanks,
    undoNote,
    getUserToMention,
    getAppFileData,
    getProgressionList,
    cancelMultipleApp,
    changeMultipleOwner,
    deleteBulkApps,
} from "../api/index";
import "../../sass/applications.scss";
import imgAvatarDefault from "../../images/avatar-default.png";
import imgUpload from "../../images/upload.png";
import imgFilter from "../../images/filter.png";
import moment from "moment";
import Dropzone from "react-dropzone";
import ReactModal from "react-modal";
import InfiniteScroll from "react-infinite-scroll-component";
import ConfirmModal from "./modals/ConfirmModal";
import ReactMultiSelectCheckboxes from "react-multiselect-checkboxes";
import MobileAppDetailHeader from "./preapps/MobileAppDetailHeader";
import BanksModal from "./modals/BanksModal";
import EditZoho from "./modals/edit-zoho/EditZoho";
import UwModal from "./modals/uw-modal";
import ColumnResizer from "react-column-resizer";
import StatusBar from "./preapps/StatusBar";
import config from "../config";
import PreappArow from "./preapp-rows/preapp-rows";
import ReactTooltip from "react-tooltip";
import StatusRightContent from "./preapp-rows/status-bar/right-info-status";
import Pusher from "pusher-js";
import ExportCSVModal from "./modals/export-csv-modal";
import SendToService from "./sendservice";
import Accordion from "react-bootstrap/Accordion";
import Card from "react-bootstrap/Card";
import { Button } from "react-bootstrap";
import CopyApplicationModal from "./modals/copy-application-modal";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import EditMobileNumberModal from "./modals/EditMobileNumberModal";
import EditEmailModal from "./modals/EditEmailModal";
import ShowGenerateModal from "./modals/show-generate-modal/ShowGenerateModal";
import AssignTemplateModal from "./modals/AssignTemplateModal";
import VarSheetModal from "./modals/var-sheet/var-sheet-modal";
import Loader from "./loader/loader";
import Pricing from "./preapps/Pricing";
import EmsBootEquipments from "./preapps/EmsBootEquipments";
import BulkActions from "./preapps/BulkActions";
import { titlesOptions } from "../constants";

const MySwal = withReactContent(Swal);

const fileDownload = require("js-file-download");
const STRATUS_URL = config.paymentcloud.STRATUS_URL;
let MAIN_URL = config.paymentcloud.MAIN_URL;
const default_bank = 1;
const default_index = 1;
const signature_ids = [7];
const awaiting_signature_request = 6;
const app_pending_pc_approval = 15;
const Prevet_Application = 19;
const Cancelled_Application = 14;
const awaiting_signature = 7;
const hide_progression = [
    awaiting_signature_request,
    app_pending_pc_approval,
    awaiting_signature,
    Prevet_Application,
];
const cancelled = 14;

const MOBILE_SCREEN_WIDTH = 767;

const GatewayTypes = [
    {
        value: "authorize_net",
        label: "Authorize.net",
    },
    {
        value: "nmi",
        label: "NMI",
    },
    {
        value: "usa_e_pay",
        label: "USAePay",
    },
    {
        value: "paysley",
        label: "Paysley",
    },
    {
        value: "VAR",
        label: "VAR",
    },
];

const TerminalTypes = [
    {
        value: "pax-a920",
        label: "Pax A920",
    },
    {
        value: "pax-a80",
        label: "Pax A80",
    },
    {
        value: "dejavoo-z9",
        label: "Dejavoo z9",
    },
    {
        value: "dejavoo-qd4",
        label: "Dejavoo QD4",
    },
    {
        value: "dejavoo-qd2",
        label: "Dejavoo QD2",
    },
    {
        value: "dejavoo-z8",
        label: "Dejavoo z8",
    },
    {
        value: "bbpos",
        label: "BBPOS 3-in-1 Bluetooth Card Reader",
    },
    {
        value: "payanywhere-smart-terminal-mini",
        label: "Payanywhere Smart Terminal Mini",
    },
    {
        value: "payanywhere-smart-flex",
        label: "Payanywhere Smart Flex",
    },
    {
        value: "payanywhere-smart-pos",
        label: "Payanywhere Smart POS+",
    },
    {
        value: "payanywhere-smart-terminal",
        label: "PayAnywhere Smart Terminal",
    },
    {
        value: "payanywhere-smart-keypad",
        label: "PayAnywhere Smart Keypad",
    },
    {
        value: "payanywhere-mobile-card-reader",
        label: "PayAnywhere 3-in-1 Mobile Card Reader",
    },
    {
        value: "VAR",
        label: "VAR",
    },
    {
        value: "VL100",
        label: "VL100 (Standard Terminal)",
    },
    {
        value: "VL110",
        label: "VL110 (Wireless Terminal)",
    },
    {
        value: "VL500",
        label: "VL500 (Pro Terminal)",
    },
    {
        value: "VL300",
        label: "VL300 (Pin Pad)",
    },
];

const optionsPremiseType = [
    { value: 1, label: "Commercial/Industrial" },
    { value: 2, label: "Kiosk" },
    { value: 3, label: "Mailbox" },
    { value: 4, label: "Office Building" },
    { value: 5, label: "Residential/Home Office" },
    { value: 6, label: "Retail Store Front" },
    { value: 7, label: "Mobile/On-the-Go" },
    { value: 8, label: "Website" },
];
const progressionList = [
    {
        value: "",
        label: "Reset Filters - Stratus ",
    },
    {
        value: "working_lead",
        label: "Working Lead",
    },
    {
        value: "app_in_progress",
        label: "App in Process",
    },
    {
        value: "underwriting",
        label: "Underwriting",
    },
    {
        value: "approved",
        label: "Approved",
    },
    {
        value: "declined",
        label: "Declined",
    },
    {
        value: "unworkable",
        label: "Unworkable",
    },
];

const sales_lead_progressions = [
    { value: 1, label: "Back to Edit" },
    { value: 1, label: "New Lead" },
    { value: 2, label: "Contacting" },
    { value: 3, label: "No Response - Left Voicemail & Emailed" },
    { value: 4, label: "Interested" },
    { value: 5, label: "Sent Pre-Qualification to Merchant" },
    { value: 6, label: "Pre-Qualification Received" },
    { value: 7, label: "Sent for Signature" },
    { value: 8, label: "Signed" },
    { value: 9, label: "Pending Docs" },
    { value: 10, label: "App in Bank" },
    { value: 11, label: "Never Signed App" },
    { value: 12, label: "Unworkable" },
    { value: 13, label: "Junk Leads" },
    { value: 14, label: "Unresponsive" },
    { value: 15, label: "Not Interested" },
    { value: 16, label: "Underwriting" },
    { value: 17, label: "UW / Stips Needed" },
    { value: 18, label: "Reserve Sent to Merchant" },
    { value: 19, label: "Reserve Sent to Bank" },
    { value: 20, label: "Conditionally Approved" },
    { value: 21, label: "Auto Approved" },
    { value: 22, label: "Approved" },
    { value: 23, label: "Deployed" },
    { value: 24, label: "Processing" },
    { value: 25, label: "Declined" },
];

ReactModal.setAppElement("#root");
class Preapps extends Component {
    constructor(props) {
        super(props);
        this.state = {
            filterToggle: true,
            windowWidth: window.innerWidth,
            windowHeight: window.innerHeight,
            preapp: [],
            appData: {},
            user: {},
            showModal: false,
            showOwnerModal: false,
            file: "",
            activeId: null,
            check: [],
            action: "",
            tab: "tab2",
            detailsAccordion: [true, false, false, false, false, false],
            mobileMenu: true,
            organization_user: [],
            users_in_organization: [],
            organization_options: [],
            user_options: [],
            owner_selected_organization: null,
            selectedApp: [],
            selected_owner: "",
            search: "",
            searchInputShow: false,
            note: "",
            noteMentionUser: [],
            agent_text: "Send Agent Note",
            pci_text: "Send PCI Note",
            merchant_text: "Send Merchat Note",
            todo: false,
            add_todo: false,
            todo_text: "",
            todo_id: "",
            todo_list: {},
            FilterMenu: false,
            sortBy: "id",
            sortValue: "DESC",
            page: 1,
            hasMore: true,
            filterBy: "no",
            pci_admin: false,
            showFilters: false,
            update: false,
            update_id: "",
            appkey: "",
            important: {},
            important_id: [],
            confirm: false,
            new_progression: "",
            relation_manager: [],
            selected_manager: "",
            selected_uw: "",
            progression_data: [
                {
                    value: 1,
                    label: "Back to Edit",
                },
                {
                    value: 7,
                    label: "Sent for Signature",
                },
                {
                    value: 8,
                    label: "Signed - PC Review",
                },
                {
                    value: 9,
                    label: "Underwriting Review",
                },
                {
                    value: 10,
                    label: "Pended",
                },
                {
                    value: 11,
                    label: "Awaiting Reserve",
                },
                {
                    value: 12,
                    label: "Approved",
                },
                {
                    value: 13,
                    label: "Denied",
                },
                {
                    value: 14,
                    label: "Cancelled",
                },
                {
                    value: 15,
                    label: "App pending PC approval",
                },
                {
                    value: 17,
                    label: "PDF requested",
                },
                {
                    value: 18,
                    label: "Awaiting wet signature",
                },
                {
                    value: 21,
                    label: "Terminated",
                },
                {
                    value: 22,
                    label: "Support",
                },
            ],
            selected_progression: null,
            resend_sign: "",
            show_info: true,
            showExpandedInfo: false,
            row_info: false,
            banks: {},
            selected_bank: "",
            show_banks: false,
            createChildApp: true,
            defaultBank: {
                id: "",
                name: "",
            },
            activeBank: "",
            note_app_id: "",
            bank_name: "",
            parent_id: "",
            selectedOption: "",
            confirmText: "",
            bank_id: "",
            app_id: null,
            is_parent: true,
            header_user_name: "",
            loggedInUser: {},
            options: {
                chart: {
                    type: "pie",
                    className: "pie-chart",
                    backgroundColor: "#fff",
                    height: "120px",
                },
                credits: {
                    enabled: false,
                },
                tooltip: {
                    enabled: true,
                    formatter: function () {
                        return "<b></b> <b>" + this.y + " %</b>";
                    },
                },
                crisp: true,
                plotOptions: {
                    pie: {
                        allowPointSelect: false,
                        minSize: 80,
                        dataLabels: { enabled: false },
                    },
                },
                title: {
                    text: "",
                },
                hoverData: null,
                series: [
                    {
                        data: [
                            {
                                name: "Completed",
                                y: 0,
                                color: "green",
                            },
                            {
                                name: "In-Completed",
                                y: 100,
                                color: "red",
                            },
                        ],
                    },
                ],
            },
            showButtons: false,
            accordionNumber: 0,
            show_spinner: false,
            show_right_spinner: false,
            totalCount: 0,
            childParentID: "",
            showLoader: false,
            uploadFileTypeError: "",
            Searching: false,
            showAlert: false,
            showAlertApplist: false,
            alertHeader: "",
            alertMessage: "",
            showCreatedAppModel: false,
            selectedAppBankName: "",
            showExportCSVModal: false,
            showExportSpinner: false,
            showSendLinkModal: false,
            noteErrorMessage: "",
            uploadFileError: null,
            docModal: false,
            docModalFile: null,
            disable_rerun_btn: false,
            prevetStatusMessage: "",
            editPrevetId: null,
            userListForFilterApp: [],
            appSearchByUser: "",
            appSearchByOrg: "",
            showMerchantInfoLoader: false,
            upload_id: null,
            note_id: null,
            error_message: "",
            preAppCalled: 0,
            editZohoModal: false,
            editUwModal: false,
            zohoIdType: "",
            bankList: [],
            selectedBank: null,
            error_message: "",
            listed_apps: "",
            usersToMeation: [],
            totalOwner: 0,
            signedOwner: 0,
            leadProgressionList: [],
            showOtpModel: false,
            showEmailModel: false,
            pusher: new Pusher(config.paymentcloud.PUSHER_KEY, {
                cluster: config.paymentcloud.PUSHER_CLUSTER,
                encrypted: true,
                authEndpoint: '/broadcasting/auth',
                auth: {
                    headers: {
                        'STRATUS-XSRF-TOKEN': document.querySelector('meta[name="stratus-csrf-token"]')?.getAttribute('content'),
                    },
                },
            }),
            changeBankPopUp: "",
            copyApplicationModal: {
                isOpen: false,
            },
            assign_pe_template: false,
            assign_pricing_equipment_template: false,
            reRender: false,
            var_sheet_modal: false,
            selected_powerapps: [],
            showPowerAppsAction: false,
            selected_powerapps_keys: [],
            showMultipleOwnerModal: false,
            bulkDataIds: [],
        };
        this.uploads = [];
        this.TitleArrray = [];
        window.cancelToken;
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (this.props.preAppCalled != this.state.preAppCalled) {
            this.setState({ preAppCalled: this.props.preAppCalled });
            this.getPreappData();
        }
    }
    componentDidMount() {
        var user = {};
        UserData()
            .then((response) => {
                user = response;
                if (this.state.header_user_name.length === 0) {
                    if (
                        user?.channel == "sales_channel" &&
                        user?.role == "admin"
                    ) {
                        if (user.organization_id) {
                            this.handleUserListByOrg(user.organization_id);
                        }
                    }
                    this.setState(
                        {
                            header_user_name: user.name,
                            loggedInUser: user,
                        },
                        () => {
                            this.pusherSubscribe(user);
                        },
                    );
                }
                OrganisationData().then((response) => {
                    this.state.user = user;
                    this.state.user.organization = response;
                    this.getallUser(response.id);
                    this.setState({});
                });
                getProgressionList()
                    .then((res) => {
                        if (res.status) {
                            let leadProgressionList = res.data.reduce(
                                (obj, item) => {
                                    obj[item.id] = item.status;
                                    return obj;
                                },
                                {},
                            );
                            this.setState({
                                leadProgressionList: leadProgressionList,
                            });
                        }
                    })
                    .catch((error) => { });
            })
            .catch((error) => {
                if (error.status == 401) {
                    this.props.history.push("/");
                }
            });

        this.getPreappData();
        this.getTodoList();
        this.getOwnerOptions();
        this.userToMention();

        window.addEventListener("resize", this.handleResize);
        let text_name = this.props.match.params.text
            ? this.props.match.params.text
            : null;
        if (text_name != null && typeof text_name !== "undefined") {
            let text_data = this.decrypt("salt", text_name);
            if (!localStorage.getItem(text_data)) {
                const popup = {
                    title: "Signature Sent",
                    html: text_data,
                };
                getAlertPopUp(popup);
                localStorage.setItem(text_data, true);
            }
        }
    }
    decrypt = (salt, encoded) => {
        const textToChars = (text) =>
            text.split("").map((c) => c.charCodeAt(0));
        const applySaltToChar = (code) =>
            textToChars(salt).reduce((a, b) => a ^ b, code);
        return encoded
            .match(/.{1,2}/g)
            .map((hex) => parseInt(hex, 16))
            .map(applySaltToChar)
            .map((charCode) => String.fromCharCode(charCode))
            .join("");
    };
    pusherSubscribe = (user) => {
        let channel_name = "";
        if (user.organization_id == 1 && user.role == "admin") {
            channel_name = "organization_" + user.channel + "_all";
        } else {
            if (user.role == "admin") {
                channel_name =
                    "organization_" +
                    user.organization_id +
                    "_admin_" +
                    user.channel;
            } else {
                channel_name =
                    "organization_" +
                    user.organization_id +
                    "_agent" +
                    "_" +
                    user.id +
                    "_" +
                    user.channel;
            }
        }
        var channel = this.state.pusher.subscribe('private-' + channel_name);
        channel.bind("App\\Events\\PowerappBackgroundUpdate", (data) => {
            if (
                data.message.event == "update_preapp" &&
                this.state.activeId == null &&
                (typeof this.state.left_progression_filter === "undefined" ||
                    this.state.left_progression_filter == "") &&
                this.state.search == "" &&
                this.state.sortBy == "created_at" &&
                this.state.sortValue == "DESC" &&
                typeof this.state.progression_id === "undefined" &&
                typeof this.state.manager_id === "undefined"
            ) {
                this.getPreappData();
            } else {
                let message_to_show = data.message.msgToShow
                    ? data.message.msgToShow
                    : "There are new apps on your account";
                MySwal.fire({
                    title: <p>{message_to_show}</p>,
                    iconHtml: `<img src=${imgNcheck} />`,
                    toast: true,
                    position: "center",
                    showConfirmButton: true,
                    confirmButtonText: '<i class="fa fa-refresh"></i>',
                    timer: 4000,
                    timerProgressBar: true,
                    customClass: "custom-alert-popup alert-success",
                    cancelButtonText: `<img src=${imgCancelapp} />`,
                    cancelButtonColor: "#ffff",
                    showCancelButton: true,
                    didOpen: (toast) => {
                        toast.addEventListener("mouseenter", Swal.stopTimer);
                        toast.addEventListener("mouseleave", Swal.resumeTimer);
                    },
                }).then((result) => {
                    if (result.isConfirmed) {
                        this.getPreappData();
                    }
                });
            }
        });
    };
    handleShowPrevetAppModel = () => {
        this.setState({
            editPrevet: true,
            showCreatedAppModel: true,
            editPrevetId: this.state.editslug,
        });
    };
    componentWillUnmount() {
        window.removeEventListener("resize", this.handleResize);
    }

    fuzzySearch(options) {
        const fuse = new Fuse(options, {
            keys: ["name"],
            includeScore: true,
        });

        return (value) => {
            if (!value.length) {
                return options;
            }
            let result = fuse.search(value);
            let new_options = [];
            result.forEach((data) => new_options.push(data.item));
            return new_options;
        };
    }
    handleResize = () => {
        this.setState({
            windowWidth: window.innerWidth,
            windowHeight: window.innerHeight,
        });
    };
    getOwnerOptions() {
        GetAllOrganizationsSingleCall()
            .then((response) => {
                let organization_options = [];
                if (response.organization && response.organization.length > 0) {
                    response.organization.forEach((organization) => {
                        organization_options.push({
                            label: organization.name,
                            value: organization.id,
                        });
                    });
                }
                this.setState({ organization_options: organization_options });
            })
            .catch((error) => { });
    }
    LeftProgressionFilter = (type) => {
        if (type == "reset_filters") {
            this.setState(
                {
                    left_progression_filter: "",
                    selected_manager: [],
                    selected_uw: [],
                    selected_progression: [],
                    search: "",
                    sortBy: "created_at",
                    sortValue: "DESC",
                    progression_id: undefined,
                    manager_id: undefined,
                    appSearchByUser: "",
                    appSearchByOrg: "",
                },
                function () {
                    this.getPreappData();
                },
            );
        } else {
            this.setState(
                {
                    left_progression_filter: type,
                },
                function () {
                    this.getPreappData();
                },
            );
        }
        this.setState({ listed_apps: this.progressionFilter(type) });
    };
    SearchPreappData = () => {
        var query = {
            left_progression_filter: this.state.left_progression_filter || "",
            search: this.state.search || "",
            sortBy: this.state.sortBy || "",
            sortValue: this.state.sortValue || "",
            manager_id: this.state.selected_manager || [],
            uw_ids: this.state.selected_uw || [],
            progression_id: this.state.selected_progression || [],
            page: this.state.page,
            user_id: this.state.appSearchByUser,
            organization_id: this.state.appSearchByOrg,
            bank: this.state.selectedBank,
        };
        this.setState({ showLoader: true }, function () {
            if (typeof window.cancelToken != typeof undefined) {
                window.cancelToken.cancel(
                    "Operation canceled due to new request.",
                );
            }
            window.cancelToken = axios.CancelToken.source();
            axios
                .post("/preapp", query, {
                    headers: {
                        "Cache-Control": "no-cache",
                        "Content-Type": "application/json",
                        "X-Platform": "web",
                    },
                    xsrfCookieName: "STRATUS-XSRF-TOKEN",
                    xsrfHeaderName: "STRATUS-XSRF-TOKEN",
                    cancelToken: window.cancelToken.token,
                })
                .then((res) => {
                    let response = res.data;
                    let PreappDataTemp = this.state.preapp.concat(
                        response.data.data,
                    );
                    this.setState(
                        {
                            preapp: PreappDataTemp,
                            totalCount: response.total_count
                                ? response.total_count
                                : 0,
                            important: response.important,
                            important_id: [],
                            relationManager: response.relation_manager,
                            showFilters: false,
                            showLoader: false,
                            hasMore:
                                response.data.data.length < 50 ? false : true,
                        },
                        function () {
                            let ImportantIDTemp = [];
                            this.state.important.forEach((element) => {
                                ImportantIDTemp.push(element.id);
                            });
                            this.setState({
                                important_id: ImportantIDTemp,
                            });
                            if (response.default_bank) {
                                this.setState({
                                    defaultBank: response.default_bank,
                                });
                            }
                        },
                    );
                    return response;
                })
                .catch((error) => {
                    this.setState({
                        showFilters: false,
                        showLoader: false,
                    });
                    return response;
                })
                .catch((error) => {
                    this.setState({
                        showFilters: false,
                        showLoader: false,
                    });
                })
                .then((res) => {
                    const data = res?.data?.data;
                    // Find the prevet app i.e. in slug
                    const pathname = this.props.location.pathname;
                    const prevet_edit_slug =
                        pathname.split("/applications/").length == 2
                            ? pathname.split("/applications/")[1]
                            : null;
                    // Find the editslug data row
                    if (prevet_edit_slug) {
                        const row = data.find(
                            (res) => res.editslug == prevet_edit_slug,
                        );
                        if (!row && this.state.hasMore) {
                            this.fetchMoreData();
                        } else if (row) {
                            this.handleClick(row.id, 0, null);
                        }
                    }
                    if (this.state?.activeId == null) {
                        if (data?.length > 0) {
                            let blankActiveId = data[0]?.id;
                            this.handleClick(blankActiveId, 0, undefined);
                        }
                    }
                });
        });
    };
    getPreappData(ResetData = true) {
        if (ResetData == true) {
            this.setState(
                {
                    preapp: [],
                    page: 1,
                    activeId: null,
                    show_info: false,
                    showExpandedInfo: false,
                    showSpinner: false,
                    appkey: "",
                    note_app_id: "",
                    parent_id: "",
                    tab: "tab2",
                    row_info: true,
                    activeBank: "",
                    is_parent: true,
                    progression_id: undefined,
                },
                function () {
                    this.SearchPreappData();
                },
            );
        } else {
            this.SearchPreappData();
        }
    }

    getTodoList() {
        var query = "?";
        if (this.state.filterBy != "") {
            query += "is_completed=" + this.state.filterBy;
        }
        getTodo(query)
            .then((response) => {
                this.state.todo_list = response.data;
                this.setState({});
            })
            .catch((error) => { });
    }
    getallUser(organization_id) {
        getUser(organization_id)
            .then((response) => {
                this.setState({ pci_admin: response.is_pci });
                this.setState({ organization_user: response.user });
                if (this.state.pci_admin) {
                    getBanks().then((res) => {
                        if (res.status) {
                            let bankList = res.data.map((item) => {
                                return {
                                    label: item.name,
                                    value: item.id,
                                };
                            });
                            bankList.shift();
                            this.setState({
                                bankList: bankList,
                            });
                        }
                    });
                }
            })
            .catch((error) => { });
    }
    getUsersInOrganization() {
        getUser(this.state.appData.organization_id)
            .then((response) => {
                this.setState({ users_in_organization: response.user });
            })
            .catch((error) => { });
    }
    noteSubscribe = (appId, activeAppId = "") => {
        let oldChannelName = "";
        if (!isNaN(activeAppId)) {
            oldChannelName = "private-powerapp_" + activeAppId + "_notes";
            this.state.pusher.unsubscribe(oldChannelName);
        }
        let newChannelName = "private-powerapp_" + appId + "_notes";
        var channel = this.state.pusher.subscribe(newChannelName);
        channel.bind("App\\Events\\NoteAddedEvent", () => {
            this.getAppNotes();
        });
    };
    submissionPusherSubscribe = (active_app_id) => {
        var ems_submission_channel_name =
            "private-update_ems_submission" + "_" + active_app_id;
        var channel_ems = this.state.pusher.subscribe(
            ems_submission_channel_name,
        );
        channel_ems.bind("EMS-Event", (data) => {
            MySwal.fire({
                title: (
                    <p>{`Application Submitted to ${data.service?.toUpperCase()}!`}</p>
                ),
                iconHtml: `<img src=${imgNcheck} />`,
                toast: true,
                position: "center",
                showConfirmButton: false,
                confirmButtonText: '<i class="fa fa-arrow-right"></i>',
                timer: 10000,
                timerProgressBar: true,
                customClass: "custom-alert-popup alert-success",
                cancelButtonText: `<img src=${imgCancelapp} />`,
                cancelButtonColor: "#ffff",
                showCancelButton: true,
                didOpen: (toast) => {
                    toast.addEventListener("mouseenter", Swal.stopTimer);
                    toast.addEventListener("mouseleave", Swal.resumeTimer);
                },
            });
            if (this.state.tab == "tab5") {
                this.setState({ reRender: !this.state.reRender });
            } else {
                this.setState({ tab: "tab5" });
            }
        });
    };

    handleClick = (appId, key, important) => {

        if (isNaN(this.state.activeId)) {
            this.noteSubscribe(appId);
        } else {
            this.noteSubscribe(appId, this.state.activeId);
        }

        this.submissionPusherSubscribe(appId);

        let show_child = false;
        let info = false;

        if (this.state.preapp[key].child.length > 0) {
            show_child = true;
            if (appId === this.state.activeId) {
                show_child = !this.state.row_info;
                info = true;
            }
        } else {
            if (appId === this.state.activeId) {
                info = true;
            }
        }
        if (
            this.props?.user?.organization_id == config.paymentcloud.PAYCHEX_ORG_ID ||
            this.props?.user?.organization_id == config.paymentcloud.EMS_ORG_ID
        ) {
            MAIN_URL = 'https://application.stratusapp.io/';
        }
        this.setState(
            {
                activeId: appId,
                show_info: info,
                appkey: key,
                note_app_id: "",
                parent_id: "",
                tab: "tab2",
                row_info: show_child,
                activeBank: "",
                is_parent: true,
                bankNameOfselectedPreap: "",
            },
            () => {
                this.getAppData();
            },
        );
    };

    handleClickForMobileView = (appId, key, showExpandedInfo) => {
        this.setState({
            showSpinner: true,
            showExpandedInfo,
        });
        this.handleClick(appId, key);
    };

    handleChildAppClick = (appId, key, important) => {
        let info = false;
        this.setState(
            {
                activeId: appId,
                show_info: info,
                appkey: key,
                note_app_id: "",
                parent_id: "",
                tab: "tab2",
                row_info: true,
                activeBank: "",
                is_parent: true,
                bankNameOfselectedPreap: "",
            },
            () => {
                this.getAppData();
            },
        );
    };

    handleClickWithChild = (appId, key, important) => {
        let show_child = false;
        let info = false;
        if (this.state.preapp[key].child.length > 0) {
            if (this.state.childParentID === appId) {
                show_child = !this.state.row_info;
            } else {
                show_child = true;
            }
        }
        this.setState(
            {
                childParentID: appId,
                activeId: appId,
                show_info: info,
                appkey: key,
                note_app_id: "",
                parent_id: "",
                tab: "tab2",
                row_info: show_child,
                activeBank: "",
                is_parent: true,
                bankNameOfselectedPreap: "",
            },
            () => {
                if (
                    this.state.banks.length == undefined ||
                    this.state.banks.length <= 0
                ) {
                    this.getBankList();
                }
            },
        );
    };

    toggleSendLinkModal = (show) => {
        this.setState({ showSendLinkModal: show });
    };

    /*
     * Converts a Progression Id into a percentage value.
     */
    progression2Percentages(progressionId) {
        let completed = 0;
        let incomplete = 0;

        if (this.state?.appData?.user?.channel == "sales_channel" ||
            this.state?.appData?.user?.channel == "partner_channel") {
            if (progressionId < 5) {
                completed = 20;
                incomplete = 100 - completed;
            }
            if (progressionId > 4 && progressionId < 7) {
                completed = 30;
                incomplete = 100 - completed;
            }
            if (progressionId > 6 && progressionId < 11) {
                completed = 40;
                incomplete = 100 - completed;
            }
            if (progressionId > 10 && progressionId < 16) {
                completed = 60;
                incomplete = 100 - completed;
            }
            if (progressionId > 15 && progressionId < 19) {
                completed = 80;
                incomplete = 100 - completed;
            }
            if (progressionId > 18) {
                completed = 100;
                incomplete = 100 - completed;
            }
            if (progressionId == 27) {
                completed = 80;
                incomplete = 100 - completed;
            }
        } else {
            if (progressionId <= 6) {
                completed = 25;
                incomplete = 100 - completed;
            } else if (progressionId === 7 || progressionId === 18) {
                completed = 75;
                incomplete = 100 - completed;
            } else if (progressionId === 8 || progressionId === 15) {
                completed = 87.5;
                incomplete = 100 - completed;
            } else if (progressionId === 12 || progressionId === 14) {
                completed = 100;
                incomplete = 0;
            } else {
                completed = 75;
                incomplete = 100 - completed;
            }
        }
        return [completed, incomplete];
    }
    CurrentProgressionName = (progressionId) => {
        if (this.state?.appData?.user?.channel == "sales_channel" ||
            this.state?.appData?.user?.channel == "partner_channel"
        ) {
            if (progressionId < 5) {
                return "Working Lead";
            }
            if (progressionId > 4 && progressionId < 7) {
                return "App in Progress";
            }
            if (progressionId == 7) {
                return "Sent for Signature";
            }
            if (progressionId == 8) {
                return "Signed";
            }
            if (progressionId == 9) {
                return "Pending Docs";
            }
            if (
                progressionId == 10 ||
                (progressionId > 15 &&
                    progressionId < 19)
            ) {
                return "Underwriting";
            }
            if (progressionId > 10 && progressionId < 16) {
                return "Unworkable";
            }
            if (progressionId > 18 && progressionId < 25) {
                return "Approved";
            }
            if (progressionId > 24 && progressionId < 27) {
                return "Declined";
            }
            if (progressionId == 27) {
                return "Additional Signature Requested";
            }
            return "";
        } else {
            switch (progressionId) {
                case 0:
                    return "Awaiting Preapp";
                case 1:
                    return "Awaiting Preapp";
                case 2:
                    return "Awaiting Business Profile";
                case 3:
                    return "Awaiting Pricing";
                case 4:
                    return "Awaiting Pricing Confirmation";
                case 5:
                    return "Awaiting For Equipments";
                case 6:
                    return "Awaiting Signature Request";
                case 7:
                    return "Awaiting Signature";
                case 8:
                    return "Pre-Bank Review";
                case 9:
                    return "Underwriting Review";
                case 10:
                    return "Pended";
                case 11:
                    return "Awaiting Reserve";
                case 12:
                    return "Approved";
                case 13:
                    return "Denied";
                case 14:
                    return "Cancelled";
                case 15:
                    return "App pending PC approval";
                case 16:
                    return "Sent for Signature";
                case 17:
                    return "PDF requested";
                case 18:
                    return "Awaiting wet signature";
                case 19:
                    return "Pending Prevet";
                case 20:
                    return "Prevet Approved";
                case 21:
                    return "Terminated";
                case 22:
                    return "Support";
            }
        }
        return "";
    };
    currentStatus(progressionId) {
        let status = 0;
        let complete = 0;
        if (this.state?.appData?.user?.channel == "sales_channel" ||
            this.state?.appData?.user?.channel == "partner_channel") {
            if (progressionId < 5) {
                status = 1;
                complete = 20;
            }
            if (progressionId > 4 && progressionId < 7) {
                status = 2;
                complete = 30;
            }
            if (progressionId > 6 && progressionId < 11) {
                status = 3;
                complete = 40;
            }
            if (progressionId > 10 && progressionId < 16) {
                status = 4;
                complete = 60;
            }
            if (progressionId > 15 && progressionId < 19) {
                status = 5;
                complete = 80;
            }
            if (progressionId > 18) {
                status = 6;
                complete = 100;
            }
            if (progressionId == 27) {
                status = 5;
                complete = 80;
            }
        } else {
            if (progressionId == 0) {
                complete = 0;
            } else if (progressionId == 1 || progressionId === 2) {
                status = 2;
                complete = 25;
            } else if (progressionId === 3 || progressionId === 4) {
                status = 4;
                complete = 50;
            } else if (progressionId === 5) {
                status = 5;
                complete = 62.5;
            } else if (progressionId === 6) {
                status = 6;
                complete = 75;
            } else if (
                progressionId === 7 ||
                progressionId === 8 ||
                progressionId === 15 ||
                progressionId === 18
            ) {
                status = 7;
                complete = 87.5;
            } else if (progressionId === 12 || progressionId === 14) {
                status = 8;
                complete = 100;
            } else if (progressionId === 20) {
                status = 6;
                complete = 0;
            } else {
                status = 6;
                complete = 75;
            }
        }
        return [status, complete];
    }

    getAppData = (updateAppRow, typeUpdate) => {
        var app_id =
            this.state?.note_app_id.length != 0
                ? this.state?.note_app_id
                : this.state.activeId;
        this.setState({ showMerchantInfoLoader: true });
        getPreappById({ id: app_id })
            .then((response) => {
                const [completed, incomplete] = this.progression2Percentages(
                    response?.data?.user?.channel == "sales_channel"
                        ? response.data.lead_progression_id
                        : response.data.progression_id,
                );
                this.setSignedOwner(response.data);
                this.setState(
                    {
                        appData: response.data,
                        options: {
                            chart: {
                                type: "pie",
                                className: "pie-chart",
                                backgroundColor: "#fff",
                                height: "120px",
                            },
                            credits: {
                                enabled: false,
                            },
                            tooltip: {
                                enabled: true,
                                formatter: function () {
                                    return "<b></b> <b>" + this.y + " %</b>";
                                },
                            },
                            crisp: true,
                            plotOptions: {
                                pie: {
                                    allowPointSelect: false,
                                    minSize: 80,
                                    dataLabels: { enabled: false },
                                },
                            },
                            title: {
                                text: "",
                            },
                            hoverData: null,
                            series: [
                                {
                                    data: [
                                        {
                                            name: "Completed",
                                            y: completed,
                                            color: "green",
                                        },
                                        {
                                            name: "In- Completed",
                                            y: incomplete,
                                            color: "red",
                                        },
                                    ],
                                },
                            ],
                        },
                        show_info: true,
                        showSpinner: false,
                        selectedAppBankName: "",
                    },
                    () => {
                        this.updateList();
                        this.getAppInfo();
                        this.getAppNotes();
                        // this.getAppFiles();
                        this.getUsersInOrganization();
                        this.resetDetailsAccordion();
                    },
                );

                if (updateAppRow) {
                    this.updatePreappList(app_id, typeUpdate, response.data);
                }
            })
            .catch((error) => { });
    };
    setSignedOwner = (data) => {
        let totalOwner = data.owners.filter((item) => {
            if (item.active) {
                return true;
            }
        });
        let signedOwner = 0;
        if (totalOwner != undefined && totalOwner.length > 0) {
            let signedOwnerObj = totalOwner.filter((item) => {
                if (item.date_signed != null && item.active) {
                    return true;
                }
            });
            signedOwner = signedOwnerObj.length;
        }
        this.setState({
            totalOwner: totalOwner.length,
            signedOwner: signedOwner,
        });
    };

    updatePreappList = (app_id, typeUpdate, data) => {
        let preappList = this.state.preapp;
        const indexApp = preappList.findIndex((x) => x.id === app_id);
        if (typeUpdate === "organization") {
            preappList[indexApp].organization = data.organization;
            this.setState({ preapp: preappList });
        }
    };
    handleDrop = (event) => {
        this.uploads = event;
        this.setState({ file: 1 });
        this.handleOpenModal();
    };

    handleDropReject(event) {
        this.setState({
            uploadFileError: "File Is Too Large. Please choose less to 1MB",
        });
        this.handleCloseModal();
    }

    handlechange(event) {
        if (event.target.value != "") {
            this.uploadTitle = event.target.value;
        }
        this.setState({ uploadFileTypeError: "" });
    }

    handleShowOwnerModal() {
        this.setState({ showOwnerModal: true });
    }

    handleCloseOwnerModal = () => {
        this.setState({ showOwnerModal: false });
    };

    handleOwnerOrganizationChange(selected_org) {
        this.setState({ owner_selected_organization: selected_org });
        GetOrganizationById(selected_org).then((response) => {
            let user_options = [];
            if (response.users && response.users.length > 0) {
                response.users.forEach((user) => {
                    user_options.push({ label: user.name, value: user.id });
                });
            }
            this.setState({ user_options: user_options, selected_owner: "" });
        });
    }

    handleOwnerChange(selected_val) {
        this.setState({ selected_owner: selected_val });
    }

    handleUpdateOwner() {
        let data = {};
        data.change_ownership_user_id = parseInt(this.state.selected_owner);
        data.id = this.state.activeId;
        data.stratus = true;
        data.ajaxRequest = true;
        changeOwner(data)
            .then((response) => {
                if (response.status) {
                    this.setState(
                        {
                            showOwnerModal: false,
                            showAlert: true,
                            alertHeader: response.message,
                            users_in_organization: [],
                            owner_selected_organization: "",
                            selected_owner: "",
                        },
                        () => {
                            this.getAppData(true, "organization");
                        },
                    );
                }
            })
            .catch((error) => { });
    }

    handleEditApplication = () => {
        const EditAppUrl = `${MAIN_URL}${this.state.appData.organization.whitelabel_slug}/${this.state.appData.user.agent_url}/${this.state.appData.editslug}/`;
        window.open(EditAppUrl, "_blank"); // redirect to edit page
    };

    navigate(event) {
        var message = "";
        var link = "/";
        let editslug = "";
        this.state.preapp.forEach((element) => {
            if (element.id == this.state.check[0]) {
                editslug = element.editslug;
            }
        });
        if (event.target.name == "Copy Application") {
            message = "Are you sure you want to copy the application";
            link += "powerapps/" + this.state.check[0] + "/copy";
        } else if (event.target.name == "Re-run") {
            message = "Are you sure you want to rerun the application's PDF";
            link += "powerapps/" + this.state.check[0] + "/rerun";
        } else if (event.target.name == "ownership") {
            message =
                "Are you sure you want to change the ownership of the preapp";
            link +=
                this.state.user.username + "/" + editslug + "/change/ownership";
        } else if (event.target.name == "cancel") {
            message = "Are you sure you want to cancel the preapp";
            link +=
                this.state.user.username + "/" + editslug + "/archive/confirm";
        } else if (event.target.name == "prevet") {
            message = "Are you sure you want to  navigate to the new prevet";
            link =
                STRATUS_URL +
                "/" +
                this.state.appData.organization.name
                    .replace(/ /g, "")
                    .toLowerCase() +
                "/" +
                this.state.user.name +
                "/" +
                this.state.appData.editslug;
        } else if (event.target.name == "Re-Activate") {
            message = "Are you sure you want to reactivate the pre-app";
            link +=
                this.state.user.username + "/" + editslug + "/archive/revert";
        }
        if (confirm(message)) {
            window.location = link;
        }
    }

    handleOpenModal = () => {
        this.setState({ showModal: true });
    };

    handleCloseModal = () => {
        this.setState({ showModal: false });
    };
    handleUpload() {
        if (this.uploadTitle != "") {
            this.setState({ uploadFileError: null });
            this.TitleArrray.push(this.uploadTitle);
            this.handleCloseModal();
            this.checkUpload();
        }
    }
    checkUpload() {
        if (this.uploads.length != this.TitleArrray.length) {
            let count = this.state.file + 1;
            this.setState({ file: count });
            this.handleOpenModal();
        } else {
            const data = new FormData();
            this.uploads.forEach((file) => {
                data.append("files[]", file, file.name);
            });
            this.TitleArrray.forEach((element) => {
                data.append("title[]", element);
            });

            var app_id =
                this.state.note_app_id != ""
                    ? this.state.note_app_id
                    : this.state.appData.id;
            this.setState({ show_right_spinner: true });
            Uploads(app_id, data)
                .then((response) => {
                    if (response.status) {
                        this.getAppFiles("show_right_spinner");
                        this.setState({
                            show_right_spinner: false,
                            uploadFileError: null,
                        });
                    } else {
                        this.setState({
                            show_right_spinner: false,
                            uploadFileError: response.message,
                        });
                        this.refreshUploadError();
                    }
                })
                .catch((error) => {
                    let errorMessage =
                        error.status === 413
                            ? "File Is Too Large. Please try again"
                            : "Something went wrong. Please try again";
                    this.setState({
                        show_right_spinner: false,
                        uploadFileError: errorMessage,
                    });
                    this.refreshUploadError();
                });
            this.TitleArrray = [];
        }
    }

    refreshUploadError() {
        setTimeout(() => {
            this.setState({ uploadFileError: null });
        }, 3000);
    }

    handleCheckBox = (event) => {
        if (event.target.checked) {
            this.state.check.push(event.target.value);
        } else {
            if (this.state.check.includes(event.target.value)) {
                this.state.check.splice(
                    this.state.check.indexOf(event.target.value),
                    1,
                );
            }
        }
    };

    handleStar(app) {
        var data = {};
        if (app != undefined) {
            data.id = app[1].id;
            data.is_stared = event.target.checked ? 1 : 0;
            starApp(data)
                .then((response) => {
                    if (response.status) {
                        let change = this.state.preapp;
                        change[app[0]].stared = data.is_stared
                            ? response.data
                            : null;
                        this.setState(change);
                    }
                })
                .catch((error) => { });
        }
    }

    logout() {
        Logout()
            .then((response) => {
                window.location = "/";
            })
            .catch((error) => { });
    }

    handleTab(eventkey) {
        let change = {};
        change.tab = eventkey.target.name;
        this.setState(change);
    }
    handleMenu() {
        if (this.state.filterToggle) {
            this.setState({ filterToggle: false });
        } else {
            this.setState({ filterToggle: true });
        }
    }
    searchPreapp = (event) => {
        this.setState(
            {
                search: event.target.value,
            },
            () => {
                this.getPreappData();
            },
        );
    };

    handleNote(event, newValue, newPlainTextValue, mentions) {
        let change = {};
        change.note = newPlainTextValue;
        this.setState(change);
    }

    submit(event) {
        if (this.state.note != "") {
            let NoteData = {};
            NoteData["add-agentnote"] =
                event.target.name == "agent" ? "agent_note" : "";
            NoteData["add-pcinote"] =
                event.target.name == "pci" ? "add-pcinote" : "";
            NoteData["add-merchantnote"] =
                event.target.name == "merchant" ? "add-merchantnote" : "";
            NoteData["content"] = this.state.note;
            NoteData["stratus"] = true;
            NoteData["note_mention_user"] = this.state.noteMentionUser;
            this.setState({
                note: "",
            });
            if (event.target.name == "agent") {
                this.setState({
                    agent_text: "Sending...",
                });
            } else if (event.target.name == "pci") {
                this.setState({
                    pci_text: "Sending...",
                });
            } else {
                this.setState({
                    merchant_text: "Sending...",
                });
            }

            var app_id =
                this.state.note_app_id != ""
                    ? this.state.note_app_id
                    : this.state.appData.id;
            addNotes(app_id, NoteData)
                .then((response) => {
                    if (response.status) {
                        this.setState({
                            agent_text: "Send Agent Note",
                            pci_text: "Send PCI Note",
                            merchant_text: "Send Merchant Note",
                            noteErrorMessage: "",
                        });
                        this.getAppNotes();
                        if (NoteData["add-agentnote"] != "") {
                            if (
                                this.state.preapp[this.state.appkey]
                                    .important != null
                            ) {
                                this.state.preapp[this.state.appkey].important =
                                    response.important.data;
                                this.state.important.forEach((value, index) => {
                                    if (value.id == this.state.appData.id) {
                                        this.state.important[index].important =
                                            response.important.data;
                                    }
                                });
                            } else {
                                this.state.preapp[this.state.appkey].important =
                                    response.important.data;
                            }
                        }

                        let message_to_show = "Note added successfully";
                        MySwal.fire({
                            title: <p>{message_to_show}</p>,
                            icon: "info",
                            toast: true,
                            position: "top-end",
                            timer: 30000,
                            timerProgressBar: true,
                            showConfirmButton: true,
                            customClass: "margin-top-sweetalert note-swal",
                            showCancelButton: false,
                            confirmButtonText:
                                'Undo <i class="fa fa-undo" ></i>',
                        }).then((res) => {
                            if (res.isConfirmed) {
                                undoNote({
                                    note_id: response.notes.id,
                                })
                                    .then((res) => {
                                        MySwal.fire({
                                            title: <p>Undo Successful</p>,
                                            icon: "info",
                                            position: "top-end",
                                            timer: 1000,
                                            toast: true,
                                            customClass:
                                                "margin-top-sweetalert note-swal",
                                            showConfirmButton: false,
                                            showCancelButton: false,
                                        });
                                        this.getAppNotes();
                                        this.setState({
                                            note: NoteData.content,
                                        });
                                    })
                                    .catch((err) => { });
                            }
                        });
                    } else {
                        const popup = {
                            title: "Error!",
                            html: response.message,
                            timer: 4000,
                            timerProgressBar: true,
                            error: true,
                        };
                        getAlertPopUp(popup);
                    }
                })
                .catch((error) => {
                    if (error.status === 422) {
                        if (error.data && error.data.message) {
                            this.setState({
                                noteErrorMessage: error.data.message,
                            });
                            setTimeout(() => {
                                this.setState({
                                    noteErrorMessage: "",
                                });
                            }, 10000);
                        }
                    }
                    this.setState({
                        agent_text: "Send Agent Note",
                        pci_text: "Send PCI Note",
                        merchant_text: "Send Merchant Note",
                    });
                });
        }
    }

    openDrawer() {
        this.setState({ todo: true });
    }

    closeDrawer() {
        this.setState({ todo: false, add_todo: false });
    }

    addTasks() {
        this.setState({ add_todo: true });
    }
    todoChange(e) {
        let change = {};
        change.todo_text = event.target.value;
        this.setState(change);
    }
    todoSubmit() {
        let data = {};
        data.text = this.state.todo_text;
        addTodo(data)
            .then((response) => {
                this.getTodoList();
                this.setState({ todo_text: "" });
            })
            .catch((error) => { });
    }

    editTodo(id) {
        this.setState({ todo_id: id });
    }
    handleTodo(e, index) {
        let change = {};
        this.state.todo_list[index].text = event.target.value;
        this.setState(change);
    }

    todoUpdate(e, element) {
        updateTodo(element)
            .then((response) => {
                this.getTodoList();
                this.setState({ todo_id: "" });
            })
            .catch((error) => { });
    }

    removeTodo(id) {
        deleteTodo(id)
            .then((response) => {
                this.getTodoList();
                this.setState({ todo_id: "" });
            })
            .catch((error) => { });
    }
    completeTodo(e, data) {
        data.is_completed = event.target.checked ? "yes" : "no";
        updateTodo(data)
            .then((response) => {
                this.getTodoList();
                this.setState({ todo_id: "" });
            })
            .catch((error) => { });
    }
    handleFilterMenu() {
        let change = {};
        change.FilterMenu = this.state.FilterMenu ? false : true;
        this.setState(change);
    }

    changeFilter(e) {
        this.state.filterBy = event.target.name == "incompleted" ? "no" : "yes";
        this.setState({ FilterMenu: false });
        this.getTodoList();
    }

    fetchMoreData = () => {
        this.setState(
            {
                page: this.state.page + 1,
            },
            function () {
                this.getPreappData(false);
            },
        );
    };

    sortData(SortBy) {
        let SortValue = this.state.sortValue;
        if (this.state.sortBy == SortBy) {
            SortValue = SortValue == "DESC" ? "ASC" : "DESC";
        } else {
            SortValue = "ASC";
        }
        this.setState(
            {
                sortBy: SortBy,
                sortValue: SortValue,
            },
            function () {
                this.getPreappData();
            },
        );
    }
    showSearch(e) {
        e.stopPropagation();
        this.setState({ showFilters: !this.state.showFilters });
    }
    hideSearch() {
        this.setState({ showFilters: false });
    }
    updateImportantTag(data, key, isImportant) {
        updateImportant(data.important.id)
            .then((response) => {
                if (response.status) {
                    if (isImportant != null) {
                        this.state.important[key].important.is_important = 0;
                        this.setState({ update: true, update_id: data.id });
                    } else {
                        this.state.preapp[key].important.is_important = 0;
                    }
                }
            })
            .catch((error) => { });
    }
    updateList() {
        if (
            this.state.update_id != this.state.appData.id &&
            this.state.update
        ) {
            this.state.important_id.splice(
                this.state.important_id.indexOf(this.state.update_id),
                1,
            );
            this.getPreappData();
        }
    }
    handleProgression() {
        const progressionId = parseInt(event.target.value);
        switch (progressionId) {
            case 12:
                this.setState({
                    new_progression: event.target.value,
                    showProgressApprovalModel: true,
                    resend_sign: "status",
                });
                break;
            default:
                this.setState({
                    new_progression: event.target.value,
                    confirm: true,
                    resend_sign: "status",
                    confirmText: "Are you sure you want to change the status?",
                });
        }
    }

    handleSalesProgressionChange(event) {
        const progressionId = parseInt(event.target.value);
        if (progressionId == 22) {
            this.setState({
                new_progression: event.target.value,
                showProgressApprovalModel: true,
                resend_sign: "status",
            });
        } else {
            this.setState({
                new_progression: event.target.value,
                confirm: true,
                resend_sign: "status",
                confirmText: "Are you sure you want to change the status?",
            });
        }
    }

    handleClose() {
        this.setState({
            confirm: false,
            resend_sign: false,
            show_banks: false,
            error_message: "",
            showOtpModel: false,
            showEmailModel: false,
            showGenerateModal: false,
        });
    }

    progressionChanged() {
        if (this.state.resend_sign == "sign") {
            let data = {};
            data.id = this.state.appData.id;
            data.stratus = true;
            resendSignature(data)
                .then((response) => {
                    if (response.status) {
                        this.setState({
                            confirm: false,
                            resend_sign: false,
                            error_message: "",
                        });
                    } else {
                        this.setState({ error_message: response.message });
                    }
                })
                .catch((error) => {
                    this.setState({
                        error_message: "Something wrong please try again.",
                    });
                });
        } else if (this.state.resend_sign == "status") {
            let data = {};
            data.id = this.state.appData.id;
            data.progression_id = this.state.new_progression;
            data.channel = this.state.user.channel;
            updateProgression(data)
                .then((response) => {
                    if (response.status) {
                        this.getAppData();
                        this.getPreappData();
                        this.setState({
                            confirm: false,
                            showProgressApprovalModel: false,
                        });
                    }
                })
                .catch((error) => { });
        } else if (this.state.resend_sign == "rerun") {
            this.handleRerun();
        } else if (this.state.resend_sign == "sign_request") {
            this.submitSign();
        } else if (this.state.resend_sign == "confirm-sign") {
            this.submitConfirm();
        } else if (this.state.resend_sign == "revive-application") {
            this.submitRevive();
        } else if (this.state.resend_sign == "cancel-app") {
            this.submitCancel();
        } else if (this.state.resend_sign == "cancel-multiple-app") {
            this.submitMultipleCancel();
        } else if (this.state.resend_sign == "cancel-sign") {
            this.cancelSign();
        } else if (this.state.resend_sign == "copy-app") {
            // this.handleCopyApp();
        } else if (this.state.resend_sign == "delete_upload_file") {
            this.deleteUploadedFileAction(this.state.upload_id, "show_spinner");
        } else if (this.state.resend_sign == "delete_note") {
            this.deleteNoteAction(this.state.note_id);
        }
    }
    mobileUpdate() {
        this.setState({ showEmailModel: false });
        this.getPreappData();
    }
    emailUpdate() {
        this.setState({ showEmailModel: false });
        this.getPreappData();
    }
    editOtpMobileNumber = () => {
        this.setState({
            showOtpModel: true,
        });
    };
    editEmail = () => {
        this.setState({
            showEmailModel: true,
        });
    };
    handleShowGenerateModal = () => {
        this.setState({
            showGenerateModal: true,
        });
    };

    handleProgressionFilter = (val) => {
        let ids = [];
        if (val.length >= 1) {
            val.forEach((element) => {
                ids.push(element.value);
            });
        }
        this.setState({
            selected_progression: ids,
        });
    };
    handleRelationManager = (val) => {
        let manager_ids = [];
        if (val.length >= 1) {
            val.forEach((element) => {
                manager_ids.push(element.value);
            });
        }
        this.setState({
            selected_manager: manager_ids,
        });
    };

    handleUW = (val) => {
        let uw_ids = [];
        if (val.length > 0) {
            val.forEach((element) => {
                uw_ids.push(element.value);
            });
        }
        this.setState({
            selected_uw: uw_ids,
        });
    };

    clearSearch = () => {
        this.setState(
            {
                search: "",
            },
            function () {
                this.getPreappData();
            },
        );
    };

    toggleSearch = () => {
        this.setState({
            searchInputShow: true,
        });
    };

    resentSignature() {
        this.setState({
            confirm: true,
            resend_sign: "sign",
            confirmText: "Are you sure you want to resend signature?",
        });
    }
    getAppFiles(spinner) {
        let data = {};
        data.id =
            this.state.note_app_id != ""
                ? this.state.note_app_id
                : this.state.appData.id;
        data.parent_id = this.state.parent_id;
        const spinner_name = spinner ? spinner : "show_spinner";
        this.setState({ [spinner_name]: true });
        getFiles(data)
            .then((response) => {
                if (response.status) {
                    let change = this.state.appData;
                    change.files = response.files;
                    change.uploads = response.uploads;
                    this.setState(change);
                    this.setState({ [spinner_name]: false });
                }
            })
            .catch((error) => {
                this.setState({ [spinner_name]: false });
            });
    }

    deleteUploadedFileAction = (upload_id, spinner) => {
        let data = {};
        data.id =
            this.state.note_app_id != ""
                ? this.state.note_app_id
                : this.state.appData.id;
        data.upload_id = upload_id;
        const spinner_name = spinner ? spinner : "show_spinner";
        this.setState({ showLoader: true });
        DeleteFile(data)
            .then((response) => {
                if (response.success) {
                    this.setState({ [spinner_name]: true });
                    this.getAppFiles(spinner);
                    const popup = {
                        title: "Success!",
                        html: "Record removed successfully",
                    };
                    getAlertPopUp(popup);
                } else {
                    const popup = {
                        title: "Error!",
                        html: "Error while deleting file",
                        error: true,
                    };
                    getAlertPopUp(popup);
                }
            })
            .catch((error) => {
                this.setState({ [spinner_name]: false });
                const popup = {
                    title: "Error!",
                    html: "Error while deleting file",
                    error: true,
                };
                getAlertPopUp(popup);
            })
            .finally(() =>
                this.setState({
                    showLoader: false,
                    upload_id: null,
                    confirm: false,
                }),
            );
    };

    deleteUploadedFiles = (upload_id, spinner) => {
        this.setState({
            upload_id: upload_id,
            confirm: true,
            resend_sign: "delete_upload_file",
            confirmText: "Are you sure you want to delete this file?",
        });
    };

    getAppInfo() {
        let data = {};
        data.id = this.state.appData.id;
        getMerchantInfo(data)
            .then((response) => {
                if (response.status) {
                    let change = this.state.appData;

                    change.creditcardprocess = response.creditcardprocess;
                    change.bankinfo = response.bankinfo;
                    change.powerappequipment = response.powerappequipment;
                    change.powerappbusinessprofile =
                        response.powerappbusinessprofile;
                    change.prices = response.prices;
                    change.signers = response.signers ? response.signers : [];

                    this.setState(change, () =>
                        this.setState({ showMerchantInfoLoader: false }),
                    );
                    this.getBankList();
                }
            })
            .catch((error) => { });
    }

    bankChange() {
        this.setState({ show_banks: false, selected_bank: "" });
        this.getPreappData();
        this.getBankList();
    }

    showBanks = (appId, childApp) => {
        this.setState({ show_banks: true, createChildApp: childApp });
    };

    handleActiveBank(element) {
        const patent_id =
            element.id != undefined ? element.parent_id : this.state.activeId;
        const note_app_id =
            element.id != undefined ? element.id : this.state.activeId;
        this.setState(
            {
                activeBank:
                    element.bank != undefined ? element.bank.id : default_bank,
                bank_name: element.bank != undefined ? element.bank.name : "",
                tab: "tab2",
                is_parent: false,
                parent_id: patent_id,
                note_app_id: note_app_id,
            },
            function () {
                this.getAppData();
            },
        );
    }

    deleteNoteAction = (id) => {
        this.setState({ showLoader: true });
        deleteNote(id)
            .then((response) => {
                if (response.success) {
                    this.setState({
                        showLoader: false,
                        upload_id: null,
                        confirm: false,
                        error_message: "",
                    });
                    this.getAppNotes();
                } else {
                    this.setState({
                        showLoader: false,
                        upload_id: null,
                        error_message: response.message,
                    });
                }
            })
            .catch((error) => {
                this.setState({
                    showLoader: false,
                    upload_id: null,
                    error_message: "Something want wrong please try again.",
                });
            });
    };
    deleteNote = (id) => {
        this.setState({
            note_id: id,
            confirm: true,
            resend_sign: "delete_note",
            confirmText: "Are you sure you want to delete this note?",
        });
    };

    getAppNotes = () => {
        let data = {};
        data.id = Number.isInteger(this.state.note_app_id)
            ? this.state.note_app_id
            : this.state.appData.id;
        data.parent_id =
            this.state.activeBank == default_bank
                ? default_bank
                : this.state.parent_id;
        getNotes(data)
            .then((response) => {
                if (response.status) {
                    let change = this.state.appData;

                    change.latest = response.latest;
                    change.notes = response.notes;
                    change.ehawk = response.ehawk;
                    change.system_notes = response.system_notes;
                    this.setState(change);
                }
            })
            .catch((error) => { });
    };
    getBankList() {
        let data = {};
        data.id = this.state.activeId;
        bankList(data)
            .then((response) => {
                let bankNameOfselectedPreap = "";
                if (response.status) {
                    this.setState({ banks: response.bank_list });
                    const selectedAppBankID =
                        this.state.appData && this.state.appData.bank_id
                            ? this.state.appData.bank_id
                            : undefined;
                    if (selectedAppBankID) {
                        const bankInfo = response.bank_list.find(
                            (x) => x.value === parseInt(selectedAppBankID),
                        );
                        if (bankInfo) {
                            bankNameOfselectedPreap = bankInfo.label;
                        } else {
                            bankNameOfselectedPreap = "Default";
                        }
                    } else {
                        bankNameOfselectedPreap = "Default";
                    }
                }
                this.setState({ selectedAppBankName: bankNameOfselectedPreap });
            })
            .catch((error) => { });
    }
    handlePdfRun(id) {
        this.setState({
            bank_id: id,
            confirm: true,
            resend_sign: "rerun",
            confirmText:
                "Are you sure you want to re-run the application's PDF?",
        });
    }
    handleRerun() {
        this.setState({
            showLoader: true,
        });
        let data = {};
        data.id = this.state.activeId;
        data.stratus = true;
        runPdf(data)
            .then((response) => {
                this.setState({
                    bank_id: "",
                    confirm: false,
                    resend_sign: "",
                    confirmText: "",
                    showLoader: false,
                });
            })
            .catch((error) =>
                this.setState({
                    bank_id: "",
                    confirm: false,
                    resend_sign: "",
                    confirmText: "",
                    showLoader: false,
                }),
            )
            .finally(() => { });
    }

    handleAppCopy(id) {
        this.setState({
            copyApplicationModal: {
                isOpen: true,
                appId: id,
            },
        });
    }

    handleConfirmCopyApp(new_dba) {
        this.handleCopyApp(new_dba);
    }

    handleCloseCopyAppModal() {
        this.setState({
            copyApplicationModal: {
                isOpen: false,
            },
        });
    }

    handleCopyApp(new_dba) {
        let data = {};
        data.id = this.state.activeId;
        data.stratus = true;
        data.ajaxRequest = true;
        data.new_dba = new_dba;
        this.setState({ showLoader: true });
        copyApp(data)
            .then((response) => {
                if (response.status) {
                    this.setState({ confirm: false });
                    let url_name = this.getUrlName();
                    let redirect_url = `${MAIN_URL}${response.organization_slug}/${response.user_slug}/${response.data}/`;
                    if (this.state.user.channel == "sales_channel") {
                        redirect_url = `${MAIN_URL}${response.user_slug}/${response.data}/`;
                    }
                    window.location = redirect_url;
                }
            })
            .catch((error) => {
                this.setState({
                    showLoader: false,
                    showAlert: true,
                    alertHeader: "Something Went Wrong!",
                });
            });
    }

    handleToggleAccordion = (accordionNumber) => {
        if (accordionNumber === this.state.accordionNumber) {
            setTimeout(() => {
                this.setState({
                    accordionNumber: -1,
                });
            }, 300);
        } else {
            this.setState({
                accordionNumber: accordionNumber,
            });
        }
    };

    sendSign() {
        this.setState({
            confirm: true,
            resend_sign: "sign_request",
            confirmText:
                "Are you sure you want to send the application's for signature?",
        });
    }

    submitSign() {
        let data = {};
        data.id = this.state.appData.id;
        data.stratus = true;
        sendSignature(data)
            .then((response) => {
                if (response.status) {
                    let change = this.state.appData;
                    change.progression_id = awaiting_signature;
                    var new_progression = this.state.preapp;
                    new_progression[this.state.appkey].progression_id =
                        awaiting_signature;
                    new_progression[this.state.appkey].progression.status =
                        "Awaiting Signature";
                    this.setState([change, new_progression]);
                    this.setState({
                        bank_id: "",
                        confirm: false,
                        resend_sign: "",
                        confirmText: "",
                    });
                }
            })
            .catch((error) => { });
    }

    handleApprove() {
        this.setState({
            confirm: true,
            resend_sign: "confirm-sign",
            confirmText: "Are you sure you want to Approve and send e-sign ?",
        });
    }
    submitRevive() {
        let data = {};
        data.id = this.state.activeId;
        reviveApplication(data).then((response) => {
            if (response.success) {
                MySwal.fire({
                    title: <p>App Revived</p>,
                    icon: "success",
                    toast: true,
                    position: "top-end",
                    showConfirmButton: true,
                    confirmButtonText: '<i class="fa fa-refresh"></i>',
                    timer: 4000,
                    timerProgressBar: true,
                    customClass: "margin-top-sweetalert",
                    didOpen: (toast) => {
                        toast.addEventListener("mouseenter", Swal.stopTimer);
                        toast.addEventListener("mouseleave", Swal.resumeTimer);
                    },
                }).then((result) => {
                    if (result.isConfirmed) {
                        this.getPreappData();
                    }
                });
            } else {
                MySwal.fire({
                    title: <p>{response.message}</p>,
                    icon: "error",
                    toast: true,
                    position: "top-end",
                    timer: 4000,
                    timerProgressBar: true,
                    showConfirmButton: false,
                    customClass: "margin-top-sweetalert",
                    didOpen: (toast) => {
                        toast.addEventListener("mouseenter", Swal.stopTimer);
                        toast.addEventListener("mouseleave", Swal.resumeTimer);
                    },
                });
            }
            this.setState({
                confirm: false,
            });
        });
    }
    submitConfirm() {
        let data = {};
        data.id = this.state.appData.id;
        data.stratus = true;
        resendSignature(data)
            .then((response) => {
                if (response.status) {
                    let change = this.state.appData;
                    change.progression_id = awaiting_signature;
                    var new_progression = this.state.preapp;
                    new_progression[this.state.appkey].progression_id =
                        awaiting_signature;
                    new_progression[this.state.appkey].progression.status =
                        "Awaiting Signature";
                    this.setState([change, new_progression]);
                    this.setState({
                        bank_id: "",
                        confirm: false,
                        resend_sign: "",
                        confirmText: "",
                    });
                    this.setState({ confirm: false, resend_sign: false });
                } else {
                    this.setState({ error_message: response.message });
                }
            })
            .catch((error) => {
                this.setState({
                    error_message: "Something wrong please try again.",
                });
            });
    }

    handleCancle() {
        this.setState({
            confirm: true,
            resend_sign: "cancel-app",
            confirmText: "Are you sure you want Cancel Application ?",
        });
    }
    handleReviveApplication() {
        this.setState({
            confirm: true,
            resend_sign: "revive-application",
            confirmText:
                "Are you sure you want to revive this cancelled application ?",
        });
    }
    handleCancelSign() {
        this.setState({
            confirm: true,
            resend_sign: "cancel-sign",
            confirmText:
                " Canceling signature process will reset everything and return you to the editing. Are you sure you want Cancel signature ?",
        });
    }

    submitCancel() {
        this.setState({
            showLoader: true,
        });
        let data = {};
        data.id = this.state.appData.id;
        data.stratus = true;
        cancelApp(data)
            .then((response) => {
                if (response.status) {
                    let change = this.state.appData;
                    change.progression_id = response.data.progression_id;
                    var new_progression = this.state.preapp;
                    new_progression[this.state.appkey].progression_id =
                        response.data.progression_id;
                    new_progression[this.state.appkey].progression = {
                        ...new_progression[this.state.appkey].progression,
                        status: "Cancelled",
                    };
                    this.setState([change, new_progression]);
                    this.setState(
                        {
                            showLoader: false,
                            bank_id: "",
                            confirm: false,
                            resend_sign: "",
                            confirmText: "",
                        },
                        () => {
                            this.getAppData();
                        },
                    );
                }
            })
            .catch((error) => { });
    }
    cancelSign() {
        let data = {};
        data.id = this.state.appData.id;
        data.stratus = true;
        cancelSignature(data)
            .then((response) => {
                if (response.status) {
                    let change = this.state.appData;
                    change.progression_id = response.data.progression_id;
                    var new_progression = this.state.preapp;
                    new_progression[this.state.appkey].progression_id =
                        response.data.progression_id;
                    new_progression[this.state.appkey].progression.status =
                        "Awaiting Pricing";
                    this.setState([change, new_progression]);
                    this.setState({
                        bank_id: "",
                        confirm: false,
                        resend_sign: "",
                        confirmText: "",
                    });
                }
            })
            .catch((error) => { });
    }

    getScoreClass(data) {
        const score = data && data.score ? data.score : null;
        if (score != null) {
            if (score.total > 0) {
                return "ehawk-success";
            } else if (score.total === 0) {
                return "ehawk-primary";
            } else if (score.total < 0) {
                return "ehawk-danger";
            }
        } else {
            return "";
        }
    }

    resetDetailsAccordion() {
        this.setState({
            accordionNumber: 0,
        });
    }

    getUrlName() {
        let url_name = "";

        if (this.state.appData.user) {
            const name_arr = this.state.appData.user.name.split(" ");

            if (name_arr.length >= 2) {
                if (name_arr.length == 2) {
                    const agent = name_arr[0].charAt(0);
                    const lastname = name_arr.length > 1 ? name_arr[1] : "";
                    url_name = agent + lastname;
                }

                if (name_arr.length == 3) {
                    const agent = name_arr[0].charAt(0);
                    const lastname = name_arr.length > 1 ? name_arr[2] : "";
                    url_name = agent + lastname;
                }
            }
        }

        return url_name;
    }

    onExportCSVModalCloseHandler = () => {
        this.setState({ showExportCSVModal: false });
    };

    onExportCSVModalOpenHandler = () => {
        this.setState({ showExportCSVModal: true });
    };

    onExportCSVButtonClickHandler = (exportSize) => {
        this.setState({ showExportSpinner: true });
        var query = {
            left_progression_filter: this.state.left_progression_filter || "",
            search: this.state.search || "",
            sortBy: this.state.sortBy || "",
            sortValue: this.state.sortValue || "",
            manager_id: this.state.selected_manager || [],
            progression_id: this.state.selected_progression || [],
            page: this.state.page,
            exportSize: exportSize,
        };

        getExportCSVLink(query).then((response) => {
            fileDownload(response.data, "report.csv");
            this.setState({ showExportSpinner: false });
        });
    };
    PricingLabel = (type) => {
        switch (type) {
            case "icppt":
                return "IC Plus / Pass-Through";
                break;
            case "tiered":
                return "Tiered";
                break;
            case "sccd":
                return "Surcharge / Cash Discount";
                break;
            case "frate":
                return "Flat Rate";
                break;
            case "dual_pricing":
                return "Dual Pricing";
                break;
            case "surcharge":
                return "Surcharge";
                break;
            case "flat_rate":
                return "Flat Rate";
                break;
            case "ic_plus":
                return "IC Plus";
                break;
            default:
                return "";
                break;
        }
    };

    openDocModal = (element) => {
        if (element.id) {
            this.setState({ show_right_spinner: true });
            let fileToShow = ["pdf", "jpg", "jpeg", "png", "svg"];
            let fileNameLenght = element.pdf_converted
                ? element.pdf_converted.split(".")
                : element.file.split(".");
            let type =
                fileNameLenght.length > 1
                    ? fileNameLenght[fileNameLenght.length - 1]
                    : "";
            if (fileToShow.includes(type) === true) {
                let fileData = {
                    type: type,
                    title: element.file,
                    id: element.id,
                };
                this.setState({ docModalFile: fileData }, () => {
                    this.setState({
                        docModal: true,
                        show_right_spinner: false,
                    });
                });
            } else {
                getAppFileData(element.id)
                    .then((response) => {
                        if (response.success === true) {
                            let data = response.data;
                            let fileNameLenght = data.pdf_converted
                                ? data.pdf_converted.split(".")
                                : data.file.split(".");
                            let fileData = {
                                type:
                                    fileNameLenght.length > 1
                                        ? fileNameLenght[
                                        fileNameLenght.length - 1
                                        ]
                                        : "",
                                title: data.file,
                                id: data.id,
                            };
                            this.setState({ docModalFile: fileData }, () => {
                                this.setState({
                                    docModal: true,
                                    show_right_spinner: false,
                                });
                            });
                        } else {
                            const popup = {
                                title: "Error!",
                                html: response.message,
                                error: true,
                            };
                            getAlertPopUp(popup);
                            this.setState({ show_right_spinner: false });
                        }
                    })
                    .catch((error) => {
                        const popup = {
                            title: "Error!",
                            html: response.message,
                            error: true,
                        };
                        getAlertPopUp(popup);
                        this.setState({ show_right_spinner: false });
                    });
            }
        } else {
            if (element.name && element.path) {
                let file_path = element.path;
                file_path = file_path.replaceAll("/", "*");
                let fileData = {
                    type: "pdf",
                    title: element.name,
                    id: file_path,
                };
                this.setState({ docModalFile: fileData }, () => {
                    this.setState({ docModal: true });
                });
            }
        }
    };

    closeDocModal = () => {
        this.setState({
            docModal: false,
        });
    };
    handleUserListByOrg(selected_org) {
        GetOrganizationById(selected_org).then((response) => {
            let user_options = [];
            if (response.users && response.users.length > 0) {
                response.users.forEach((user) => {
                    user_options.push({ label: user.name, value: user.id });
                });
            }
            this.setState(
                {
                    appSearchByOrg: selected_org,
                    userListForFilterApp: [],
                    appSearchByUser: "",
                },
                () => {
                    this.setState({ userListForFilterApp: user_options });
                },
            );
        });
    }

    handleUserChange(selected_user) {
        if (selected_user) {
            this.setState({ appSearchByUser: selected_user });
        }
    }
    handleProgressionSearch = (val) => {
        this.setState({
            left_progression_filter: val,
        });
    };
    refreshApplicationList = () => {
        this.getAppData();
    };

    updateEditZohoModalState = (state, idType) => {
        this.setState({
            editZohoModal: state,
            zohoIdType: idType,
        });
    };

    updateEditUWModalState = (state) => {
        this.setState({
            editUwModal: state,
        });
    };

    hanldeBankChange = (val) => {
        this.setState({
            selectedBank: val,
        });
    };

    hanldeLetProgressionFilter = (val) => {
        this.setState({
            left_progression_filter: val,
        });
    };

    progressionFilter = (filter) => {
        switch (filter) {
            case "app_in_progress":
                return "In Progress";
            case "signedapp_prebank":
                return "Signed";
            case "underwriting_review":
                return "Underwriting Review";
            case "signature":
                return "Sent for Signature";
            case "underwriting_action":
                return "Pended";
            case "approved":
                return "Approved";
            case "awaiting_reserve":
                return "Awaiting Reserve";
            case "declined":
                return "Declined";
            case "pending_prevet":
                return "Pending Prevet";
            case "prevet_approved":
                return "Prevet Approved";
            case "cancelled":
                return "Cancelled";
        }
        return "";
    };

    getMentions(id, display, startPos, endPos) {
        let mention = this.state.noteMentionUser;
        let mentionExist = mention.find((x) => x.id == id);
        if (mentionExist == undefined || mentionExist == false) {
            mention.push({ id: id, display: "@" + display });
            this.setState({ noteMentionUser: mention });
        }
    }

    userToMention() {
        getUserToMention({}).then((response) => {
            if (response.success === true) {
                let mentionUserList = [];
                if (response.isPcAdmin === true) {
                    response.data.forEach((data) => {
                        let displayName =
                            data.display + " (" + data.organization.name + ")";
                        mentionUserList.push({
                            id: data.id,
                            display: displayName,
                        });
                    });
                } else {
                    response.data.forEach((data) => {
                        mentionUserList.push({
                            id: data.id,
                            display: data.display,
                        });
                    });
                }
                this.setState({ usersToMeation: mentionUserList });
            } else {
                this.setState({ usersToMeation: [] });
            }
        });
    }
    getGateway = (key) => {
        let gateway_name = null;
        GatewayTypes.forEach((item, index) => {
            if (item.value == key) {
                gateway_name = GatewayTypes[index].label;
            }
        });
        return gateway_name;
    };

    getTerminal = (key) => {
        let terminal_name = null;
        TerminalTypes.forEach((item, index) => {
            if (item.value == key) {
                terminal_name = TerminalTypes[index].label;
            }
        });
        return terminal_name;
    };

    getOwnershipPercent = () => {
        const { appData } = this.state;
        let ownership = 100;
        appData?.signers?.forEach(function (item) {
            ownership = ownership - item.ownership_percentage;
        });

        return ownership;
    };
    CurrentProgressionIcon = (progressionId) => {

        if (this.state?.appData?.user?.channel == "sales_channel"
            || this.state?.appData?.user?.channel == "partner_channel"
        ) {
            if (progressionId < 5) {
                return "#b6d7a8";
            }
            if (progressionId > 4 && progressionId < 7) {
                return "#a2c4c9";
            }
            if (progressionId == 7) {
                return "#a4c2f4";
            }
            if (progressionId == 8) {
                return "#b4a7d6";
            }
            if (progressionId == 9) {
                return "#ffe599";
            }
            if (progressionId > 10 && progressionId < 16) {
                return "#ff6d01";
            }
            if (
                progressionId == 10 ||
                (progressionId > 15 && progressionId < 19)
            ) {
                return "#ffff00";
            }
            if (progressionId > 18 && progressionId < 25) {
                return "#34a853";
            }
            if (progressionId > 24 && progressionId < 27) {
                return "#ea4335";
            }
            if (progressionId == 27) {
                return "#810173";
            }
            return "";
        }
    };

    checkedPowerApp = (e, id, index) => {
        let data = this.state.selected_powerapps;
        let multipleKeys = this.state.selected_powerapps_keys;
        if (event.target.checked) {
            data.push(id);
            multipleKeys.push(index);
        } else {
            data = data.filter((d) => d !== id);
            multipleKeys = multipleKeys.filter((d) => d !== index);
        }
        this.setState({ selected_powerapps: data });
        this.setState({ selected_powerapps_keys: multipleKeys });
        if (data.length) {
            this.setState({ showPowerAppsAction: true });
        } else {
            this.setState({ showPowerAppsAction: false });
        }
    };

    handleMultipleChangeOwnership() {
        this.setState({ showMultipleOwnerModal: true });
    }

    handleCloseMultipleOwnerModal = () => {
        this.setState({ showMultipleOwnerModal: false });
    };

    handleUpdateMultipleOwner() {
        let data = {};
        data.change_ownership_user_id = parseInt(this.state.selected_owner);
        data.ids = this.state.selected_powerapps;
        data.stratus = true;
        data.ajaxRequest = true;
        changeMultipleOwner(data)
            .then((response) => {
                if (response.status) {
                    this.state.selected_powerapps_keys.forEach((key) => {
                        document.querySelectorAll('[name="powerapp_selected"]')[
                            key
                        ].checked = false;
                    });
                    this.setState({
                        showMultipleOwnerModal: false,
                        showAlert: true,
                        alertHeader: response.message,
                        users_in_organization: [],
                        owner_selected_organization: "",
                        selected_owner: "",
                        selected_powerapps: [],
                        selected_powerapps_keys: [],
                        showPowerAppsAction: false,
                    });
                }
            })
            .catch((error) => { });
    }

    handleMultipleCancel() {
        this.setState({
            confirm: true,
            resend_sign: "cancel-multiple-app",
            confirmText: "Are you sure you want Cancel Applications ?",
        });
    }

    submitMultipleCancel() {
        this.setState({
            showLoader: true,
        });
        let data = {};
        data.ids = this.state.selected_powerapps;
        cancelMultipleApp(data)
            .then((response) => {
                response.data.forEach((element) => {
                    this.state.selected_powerapps_keys.forEach((key) => {
                        let change = element;
                        change.progression_id = element.progression_id;
                        var new_progression = this.state.preapp;
                        new_progression[key].progression_id =
                            element.progression_id;
                        new_progression[key].progression = {
                            ...new_progression[key].progression,
                            status: "Cancelled",
                        };
                        this.setState([change, new_progression]);
                        document.querySelectorAll('[name="powerapp_selected"]')[
                            key
                        ].checked = false;
                    });
                });
                this.setState({
                    selected_powerapps_keys: [],
                    selected_powerapps: [],
                    showPowerAppsAction: false,
                });
                if (response.status) {
                    this.setState({
                        showLoader: false,
                        confirm: false,
                        resend_sign: "",
                        confirmText: "",
                    });
                }
            })
            .catch((error) => { });
    }

    updateBulkDataArray = (data, checked) => {
        if (checked) {
            this.setState({
                bulkDataIds: [...this.state.bulkDataIds, data],
            });
        } else {
            let filtered = this.state.bulkDataIds.filter((id) => {
                return id !== data;
            });
            this.setState({
                bulkDataIds: filtered,
            });
        }
    };

    getDocumentLabel = (type) => {
        if (type == "PASSPORT") return "Passport";
        if (type == "STATE_ID") return "Driving License";
        if (type == "LOCAL_STATE_ID") return "State ID";
        if (type == "CITIZENSHIP_CARD") return "Citizenship Card";
        return null;
    };

    getDocumentTypeLabel = (type) => {
        if (type == "PASSPORT") return "Passport Number";
        if (type == "STATE_ID") return "Driving License Number";
        if (type == "LOCAL_STATE_ID") return "State ID Number";
        if (type == "CITIZENSHIP_CARD") return "Citizenship Card Number";
        return null;
    };
    generateAppLink = (appData) => {
        let channel = appData?.user?.channel;
        let organization_id = appData?.organization?.id;
        let editslug = appData?.editslug;
        let agent_url = appData?.user?.agent_url;
        let org_slug = appData?.organization?.whitelabel_slug;

        if (channel == 'sales_channel' || channel == 'partner_channel') {
            if (organization_id == config.paymentcloud.EMS_ORG_ID || organization_id == config.paymentcloud.PAYCHEX_ORG_ID) {
                return "https://application.stratusapp.io/" + agent_url + "/" + editslug;
            } else {
                return "https://apply.paymentcloudinc.com/" + agent_url + "/" + editslug;
            }
        } else {
            return "https://apply.paymentcloudinc.com/" + org_slug + "/" + agent_url + "/" + editslug;
        }
    }

    getTitleLabel = (title_id) => {
        return titlesOptions.find((t) => t.value == +title_id)?.label || "-";
    }

    render() {
        const {
            preapp,
            appData,
            user,
            file,
            check,
            action,
            tab,
            detailsAccordion,
            mobileMenu,
            activeId,
            organization_user,
            todo,
            add_todo,
            todo_list,
            todo_id,
            FilterMenu,
            filterBy,
            hasMore,
            sortBy,
            sortValue,
            pci_admin,
            showFilters,
            important,
            important_id,
            relationManager,
            selected_manager,
            progression_data,
            selected_progression,
            resend_sign,
            show_info,
            row_info,
            banks,
            selected_bank,
            defaultBank,
            activeBank,
            bank_name,
            confirmText,
            is_parent,
            header_user_name,
            showButtons,
            accordionNumber,
            show_spinner,
            totalCount,
            loggedInUser,
            show_right_spinner,
            showLoader,
            uploadFileTypeError,
            user_options,
            organization_options,
            owner_selected_organization,
            selected_owner,
            left_progression_filter,
            showAlert,
            alertHeader,
            alertMessage,
            selectedAppBankName,
            showAlertApplist,
            prevetStatusMessage,
            listed_apps,
            filterToggle,
            leadProgressionList,
            changeBankPopUp,
            showExpandedInfo,
            showSpinner,
            showPowerAppsAction,
            showGenerateModal,
        } = this.state;
        let url_name = "";
        let button_name = "";
        url_name = this.getUrlName();

        const isMobile = this.state.windowWidth <= MOBILE_SCREEN_WIDTH;
        // convert progression id into percentage
        const status2Percentage = (preapp) => {
            return this.currentStatus(
                preapp?.user?.channel == "sales_channel" 
                    || preapp?.user?.channel == "partner_channel"
                    ? preapp.lead_progression_id
                    : preapp.progression_id,
            )[1];
        };
        const currentStatus = (preapp) => {
            return this.currentStatus(
                preapp?.user?.channel == "sales_channel"
                    || preapp?.user?.channel == "partner_channel"
                    ? preapp.lead_progression_id
                    : preapp.progression_id,
            )[0];
        };
        const currentProgressName = (preapp) => {
            return this.CurrentProgressionName(
                preapp?.user?.channel == "sales_channel"
                    || preapp?.user?.channel == "partner_channel"
                    ? preapp.lead_progression_id
                    : preapp.progression_id,
            );
        };

        // get bank label for column
        const getBankLabel = (preapp) => {
            if (preapp.child.length > 0) {
                return (
                    <span className="has-more">{preapp.child.length + 1}</span>
                );
            }
            return defaultBank.name;
        };
        const ProgressionName = (appData) => {
            switch (appData.progression_id) {
                case 1:
                case 2:
                case 3:
                case 4:
                case 5:
                    return "Continue Application";
                case 6:
                case 7:
                    return "Continue Application";
                case 6:
                    return "Continue Application";

                default:
                    return "Continue Application";
            }
        };

        const bindUserName = (user_id) => {
            if (organization_user && organization_user.length > 0) {
            } else {
            }
        };

        const getPremiseType = (id) => {
            let premise = "";
            optionsPremiseType.forEach(function (item) {
                if (item.value == id) {
                    premise = item.label;
                }
            });
            return premise;
        };

        const appInfoContent = isMobile ? (
            showExpandedInfo && showSpinner ? (
                <div className="application-loader">
                    <Loader />
                </div>
            ) : (
                <div className="mobile-app-info">
                    <div className="mobile-app-info-header">
                        <h2>App ID: {appData.id}</h2>&nbsp;
                        <span className="separator">|</span>&nbsp;
                        {appData.progression_id <= 7 ? (
                            <>
                                <p>
                                    {this.CurrentProgressionName(
                                        appData.progression_id,
                                    ) +
                                        " (" +
                                        this.state.signedOwner +
                                        " of " +
                                        this.state.totalOwner +
                                        ")"}
                                </p>
                                {showExpandedInfo || (
                                    <StatusBar
                                        percentage={status2Percentage(appData)}
                                    />
                                )}
                            </>
                        ) : (
                            <StatusRightContent
                                t={appData}
                                status={this.CurrentProgressionName(
                                    appData.progression_id,
                                )}
                            />
                        )}
                    </div>
                    {appData.organization && appData.user && !appData.editslug?.includes("Imported") ? (
                        <div>
                                {appData?.user?.channel == "sales_channel" || appData?.user?.channel == "partner_channel" ? (
                                <div className="mobile-app-info-header">
                                    <a
                                        target="_blank"
                                        href={`${MAIN_URL}${appData?.user?.agent_url}/${appData.editslug}/`}
                                    >
                                        {" "}
                                            App Link{" "}
                                    </a>
                                </div>
                            ) : (
                                <div className="mobile-app-info-header">
                                    <a
                                        target="_blank"
                                        href={`${MAIN_URL}${appData.organization.whitelabel_slug}/${appData.user.agent_url}/${appData.editslug}/`}
                                    >
                                        {" "}
                                                App Link{" "}
                                    </a>
                                </div>
                            )}
                        </div>
                    ) : null}
                    <br />
                    {appData.power_app_submission != null && (
                        <div className="mobile-app-info-header">
                            <a>MID : {appData.power_app_submission.mid}</a>
                        </div>
                    )}
                    <div className="app-info">
                        <div
                            style={{
                                display: "flex",
                                justifyContent: "space-around",
                                alignItems: "center",
                                borderBottom: "#EAEBEF 1px solid",
                            }}
                        >
                            <div className="organization-test">
                                <div className="second-column">
                                    <div className="organization">
                                        <div className="avatar">
                                            <img
                                                src={
                                                    appData.organization
                                                        ? "/img/" +
                                                        appData.organization
                                                            .whitelabel_slug +
                                                        "/logo-trans.png"
                                                        : ""
                                                }
                                            />
                                        </div>
                                        <div className="organization-details">
                                            <p>
                                                {appData.organization ? (
                                                    <Link
                                                        to={
                                                            "/organization/" +
                                                            appData.organization
                                                                .id
                                                        }
                                                    >
                                                        {
                                                            appData.organization
                                                                .name
                                                        }
                                                    </Link>
                                                ) : (
                                                    <>&mdash;</>
                                                )}
                                                <br />
                                                <span>Organization</span>
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="organization_9">
                                <div className="organization">
                                    <div className="organization-details">
                                        <p>
                                            {appData.user ? (
                                                appData.user.name
                                            ) : (
                                                <>&mdash;</>
                                            )}
                                            <br />
                                            <span>Agent</span>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div
                            style={{
                                display: "flex",
                                justifyContent: "space-around",
                                alignItems: "center",
                                marginTop: "2rem",
                            }}
                        >
                            {showExpandedInfo || (
                                <div
                                    className="organization_10"
                                    style={{ width: "50%" }}
                                >
                                    <div className="organization">
                                        <div className="organization-details">
                                            <p>
                                                {appData.field_dba || (
                                                    <>&mdash;</>
                                                )}
                                                <br />
                                                <span>Merchant DBA</span>
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            )}
                            <div
                                className="organization_10"
                                style={{ width: "50%" }}
                            >
                                <div className="organization">
                                    <div className="organization-details">
                                        <p>
                                            {appData.field_legalname || (
                                                <>&mdash;</>
                                            )}
                                            <br />
                                            <span>Merchant Legal</span>
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <div
                                className="organization_10"
                                style={{ width: "50%" }}
                            >
                                <div className="organization">
                                    <div className="organization-details">
                                        <p>
                                            {selectedAppBankName !== "" ? (
                                                selectedAppBankName
                                            ) : (
                                                <>&mdash;</>
                                            )}
                                            <br />
                                            <span>Bank Name</span>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )
        ) : (
            <div className="app-info">
                <div className="row app-info-row1">
                    <div className="col-lg-4 col-md-12 col-sm-12 col-xs-12">
                            <div className="first-column">

                                <h2>
                                    App ID: {appData.id}
                                </h2>
                            {appData.ems_status !== null ? (
                                <p>EMS Status: {appData.ems_status} </p>
                            ) : (
                                ""
                                )}
                                {appData?.user?.channel ==
                                    "sales_channel" ||
                                    appData?.user?.channel ==
                                    "partner_channel" ? (
                                <div
                                    class="progression-container"
                                    style={{
                                        display: "flex",
                                        alignItems: "center",
                                    }}
                                >
                                    <i
                                        className="fa fa-circle reset_filters"
                                        aria-hidden="true"
                                        style={{
                                            color: this.CurrentProgressionIcon(
                                                appData.lead_progression_id,
                                            ),
                                        }}
                                    />
                                    <h2
                                        style={{
                                            color: this.CurrentProgressionIcon(
                                                appData.lead_progression_id,
                                            ),
                                            marginLeft: "5px",
                                        }}
                                        className="progressionStatus"
                                    >
                                        {this.CurrentProgressionName(
                                            appData.lead_progression_id,
                                        ) ?? <></>}
                                    </h2>
                                </div>
                            ) : (
                                <>
                                    {appData.progression_id > -1 &&
                                        appData.progression_id <= 7 ? (
                                        <>
                                            <p>
                                                {this.CurrentProgressionName(
                                                    appData.progression_id,
                                                ) +
                                                    " (" +
                                                    this.state.signedOwner +
                                                    " of " +
                                                    this.state.totalOwner +
                                                    ")"}
                                            </p>
                                            <StatusBar
                                                percentage={status2Percentage(
                                                    appData,
                                                )}
                                            />
                                        </>
                                    ) : (
                                        <StatusRightContent
                                            t={appData}
                                            status={this.CurrentProgressionName(
                                                appData.progression_id,
                                            )}
                                        />
                                    )}
                                </>
                            )}
                            <div>
                                {pci_admin ? (
                                    <div>
                                        <div>
                                            <>
                                                {appData.zoho_id && (
                                                    <a
                                                        className="zoho_link"
                                                        target="_blank"
                                                        href={`https://crm.zoho.com/crm/org49631815/tab/Leads/${appData.zoho_id}`}
                                                    >
                                                        Zoho ID
                                                    </a>
                                                    )}{" "}
                                                <a
                                                    onClick={() =>
                                                        this.updateEditZohoModalState(
                                                            true,
                                                            "zoho_id",
                                                        )
                                                    }
                                                >
                                                    ( EL )
                                                </a>
                                            </>
                                            <br></br>
                                            <>
                                                {appData.zoho_submission_id && (
                                                    <a
                                                        className="zoho_link"
                                                        target="_blank"
                                                        href={`https://crm.zoho.com/crm/org49631815/tab/Potentials/${appData.zoho_submission_id}`}
                                                    >
                                                        Submission
                                                    </a>
                                                )}
                                                <a
                                                    onClick={() =>
                                                        this.updateEditZohoModalState(
                                                            true,
                                                            "submission_id",
                                                        )
                                                    }
                                                >
                                                    ( ES )
                                                </a>
                                            </>
                                        </div>
                                    </div>
                                ) : null}

                                {/* <br /> */}
                                {appData.power_app_submission != null && (
                                    <div
                                        className="mobile-app-info-header"
                                        style={{ marginTop: "5px" }}
                                    >
                                        <a>
                                            MID :{" "}
                                            {appData.power_app_submission.mid}
                                        </a>
                                    </div>
                                )}
                                {pci_admin ? (
                                    <div
                                        className="mobile-app-info-header"
                                        style={{ marginTop: "5px" }}
                                    >
                                        <a
                                            onClick={() =>
                                                this.setState({
                                                    var_sheet_modal: true,
                                                })
                                            }
                                        >
                                            VAR Sheet
                                        </a>
                                    </div>
                                ) : (
                                    <></>
                                )}
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-4 col-md-12 col-sm-12 col-xs-12 chart">
                        <div className="second-column">
                            <div className="organization">
                                <div className="organization-details">
                                    <p>
                                        <Link to="" className="" type="button">
                                            {appData.organization ? (
                                                <Link
                                                    to={
                                                        "/organization/" +
                                                        appData.organization.id
                                                    }
                                                >
                                                    {appData.organization.name}
                                                </Link>
                                            ) : (
                                                <>&mdash;</>
                                            )}
                                        </Link>

                                        <br />
                                        <span>Organization</span>
                                    </p>
                                    <p>
                                        {appData.user ? (
                                            appData.user.name
                                        ) : (
                                            <>&mdash;</>
                                        )}
                                        <br />
                                        <span>Agent</span>
                                    </p>

                                    {loggedInUser.channel ==
                                        "partner_channel" ? (
                                        <>
                                            <p>
                                                {appData.primary_contact_user ? (
                                                    appData.primary_contact_user
                                                ) : (
                                                    <>&mdash;</>
                                                )}
                                                <br />
                                                <span>TL</span>
                                            </p>
                                            <p>
                                                {" "}
                                                {appData.uw_data ? (
                                                    appData.uw_data.name
                                                ) : (
                                                    <>&mdash;</>
                                                )}{" "}
                                                <br />
                                                {pci_admin ? (
                                                    <a
                                                        onClick={() =>
                                                            this.updateEditUWModalState(
                                                                true,
                                                            )
                                                        }
                                                    >
                                                        <span>UW</span>
                                                    </a>
                                                ) : (
                                                    <span>UW</span>
                                                )}
                                            </p>
                                        </>
                                    ) : (
                                        <p>
                                            {appData.sales_agent_name ? (
                                                appData.sales_agent_name
                                            ) : (
                                                <>&mdash;</>
                                            )}
                                            <br />
                                            <span>PC Agent</span>
                                        </p>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-4 col-md-12 col-sm-12 col-xs-12 org-info">
                        <div className="third-column">
                            <div className="organization-details">
                                <p>
                                    {appData.field_dba || <>&mdash;</>}
                                    <br />
                                    <span>Merchant DBA</span>
                                </p>
                                <p>
                                    {appData.field_legalname || <>&mdash;</>}
                                    <br />
                                    <span>Merchant Legal</span>
                                </p>
                                {this.state.loggedInUser?.channel ==
                                    "sales_channel" ? (
                                    <p>
                                        {appData.sales_bank_name}
                                        <br />
                                        <span>Processor Name</span>
                                    </p>
                                ) : (
                                    <p>
                                        {selectedAppBankName !== "" ? (
                                            selectedAppBankName
                                        ) : (
                                            <>&mdash;</>
                                        )}
                                        <br />
                                        <span>Bank Name</span>
                                    </p>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
                    {appData.organization && appData.user ? (
                        <>
                            <div>
                                {(pci_admin ||
                                    (appData?.user?.id == this.state?.loggedInUser?.id &&
                                        this.state?.loggedInUser?.organization?.id == 1))
                                    ?
                                    (
                                        <select
                                            className="form-control progression-select"
                                            value={appData.lead_progression_id}
                                            onChange={(e) =>
                                                this.handleSalesProgressionChange(
                                                    e,
                                                )
                                            }
                                        >
                                            {sales_lead_progressions.map(
                                                (value, k) => (
                                                    <option
                                                        value={value.value}
                                                        key={value.value}
                                                    >
                                                        {value.label}
                                                    </option>
                                                ),
                                            )}
                                        </select>
                                    ) : <></>}
                                {appData?.user?.channel == "sales_channel" ? (
                                    <></>
                                ) : (
                                    <div className="row app-info-row2 no-gutters">
                                        <div className="col-lg-12">
                                            {appData.progression_id == 19 &&
                                                pci_admin ? (
                                                <div className="prevet-column">
                                                    {prevetStatusMessage ? (
                                                        <div>
                                                            {" "}
                                                            {prevetStatusMessage}{" "}
                                                        </div>
                                                    ) : (
                                                        <>
                                                            <a
                                                                className="btn-danger btn btn-default btn-sm"
                                                                target="_blank"
                                                                onClick={(e) =>
                                                                    onPrevetApplicationStatusButtonClickHandler(
                                                                        appData.id,
                                                                        "declined",
                                                                    )
                                                                }
                                                            >
                                                                <span>Decline</span>
                                                            </a>
                                                            <a
                                                                className="btn-success btn btn-default btn-sm"
                                                                target="_blank"
                                                                onClick={(e) =>
                                                                    onPrevetApplicationStatusButtonClickHandler(
                                                                        appData.id,
                                                                        "accepted",
                                                                    )
                                                                }
                                                            >
                                                                <span>
                                                                    Move Forward
                                                                </span>
                                                            </a>
                                                        </>
                                                    )}
                                                </div>
                                            ) : null}
                                            {appData.progression_id == 0 &&
                                                !pci_admin ? (
                                                <div>Your Prevet is under review.</div>
                                            ) : null}
                                            <div className="review-application">
                                                {appData.progression_id == 20 ? (
                                                    <a
                                                        className="btn btn-default btn-sm btn-outline-primary"
                                                        target="_blank"
                                                        onClick={() =>
                                                            this.handleShowPrevetAppModel()
                                                        }
                                                    >
                                                        <span>
                                                            Continue Application
                                                        </span>
                                                    </a>
                                                ) : null}

                                                    {appData.organization &&
                                                        appData.user &&
                                                        appData.progression_id > 0 &&
                                                        appData.progression_id != 20 ? (
                                                        <>
                                                            {this.state
                                                                .showSendLinkModal ? (
                                                                <SendLinkMerchant
                                                                    showSendLinkModal={
                                                                        this.state
                                                                            .showSendLinkModal
                                                                    }
                                                                    toggleSendLinkModal={
                                                                        this
                                                                            .toggleSendLinkModal
                                                                    }
                                                                    link={`${MAIN_URL}${appData.organization
                                                                        .whitelabel_slug
                                                                        }/${appData.user.agent_url}/${appData.editslug}/`}
                                                                    editSlug={
                                                                        appData.editslug
                                                                    }
                                                                />
                                                            ) : null}
                                                            <button
                                                                className="btn btn-default btn-sm btn-outline-primary"
                                                                onClick={() =>
                                                                    this.toggleSendLinkModal(
                                                                        true,
                                                                    )
                                                                }
                                                            >
                                                                Send Link To Merchant{" "}
                                                            </button>
                                                        </>
                                                    ) : null}

                                                    {(appData.progression_id ==
                                                        awaiting_signature_request ||
                                                        (appData.price_equi_by_template ==
                                                            1 &&
                                                            appData.progression_id <=
                                                            awaiting_signature_request)) && (
                                                            <a
                                                                className="btn btn-default btn-sm btn-outline-primary"
                                                                target="_blank"
                                                            href={appData?.user?.channel == "partner_channel" ?
                                                                `${MAIN_URL}/${appData.user.agent_url}/${appData.editslug}/` :
                                                                `${MAIN_URL}${appData.organization.whitelabel_slug}/${appData.user.agent_url}/${appData.editslug}/`}
                                                            >
                                                                Send for signature
                                                            </a>
                                                        )}

                                                    {appData.id &&
                                                        signature_ids.includes(
                                                            appData.progression_id,
                                                        ) && (
                                                            <a
                                                                className="btn btn-default btn-sm btn-outline-primary"
                                                                onClick={(e) =>
                                                                    this.resentSignature(e)
                                                                }
                                                            >
                                                                Re-send for signature
                                                            </a>
                                                        )
                                                    }


                                                {appData.id &&
                                                    signature_ids.includes(
                                                        appData.progression_id,
                                                    ) && (
                                                        <a
                                                            className="btn btn-default btn-sm btn-outline-primary"
                                                            onClick={(e) =>
                                                                this.handleCancelSign(e)
                                                            }
                                                        >
                                                            Cancel signature
                                                        </a>
                                                    )}
                                                {appData.id &&
                                                    appData.progression_id ==
                                                    Cancelled_Application && (
                                                        <a
                                                            className="btn btn-default btn-sm btn-outline-primary"
                                                            onClick={(e) =>
                                                                this.handleReviveApplication(
                                                                    e,
                                                                )
                                                            }
                                                        >
                                                            Revive Application
                                                        </a>
                                                        )}

                                            </div>
                                        </div>
                                    </div>
                                )}
                            </div>
                        </>
                    ) : null}


                    <div className="review-application">
                        {appData.organization && appData.user ? (
                            <div>
                                {!appData.editslug?.includes("Imported") && (
                                    <a
                                        target="_blank"
                                        className="btn btn-default btn-sm btn-outline-primary"
                                        href={this.generateAppLink(appData)}
                                    >
                                                {" "}
                                        App Link{" "}
                                    </a>
                                )}       
                                {                                    
                                    this.state?.loggedInUser?.organization?.id == 1
                                        || pci_admin
                                        || this.props?.user?.is_ems_pc_admin ?
                                        <a
                                            className="btn btn-default btn-sm btn-outline-primary"
                                            target="_blank"
                                            onClick={(evt) =>
                                                this.handleShowGenerateModal(
                                                    appData.editslug,
                                                )
                                            }
                                        >
                                            <span>Generate and Download</span>
                                        </a>
                                        :
                                        <></>
                                }
                            </div>
                        ) : null}
                    <a
                        className="btn btn-default btn-sm btn-outline-primary"
                        target="_blank"
                        onClick={(evt) =>
                            this.editOtpMobileNumber(appData.editslug)
                        }
                    >
                        <span>Edit OTP Mobile number</span>
                    </a>
                    <a
                        className="btn btn-default btn-sm btn-outline-primary"
                        target="_blank"
                        onClick={(evt) => this.editEmail(appData.editslug)}
                    >
                        <span>Edit Email</span>
                        </a>
                        {appData?.user?.channel == "sales_channel"
                            &&
                            <>
                            {(
                                (appData?.organization_id == 1 && appData?.progression_id == 7)
                                ||
                                (appData?.organization_id != 1 && appData.lead_progression_id == 7)
                            ) &&
                                    < a
                                        className="btn btn-default btn-sm btn-outline-primary"
                                        onClick={(e) =>
                                            this.handleCancelSign(e)
                                        }
                                    >
                                        Cancel signature
                                    </a>
                            }
                            {(
                                (appData?.organization_id == 1 && (appData?.lead_progression_id > 3 && appData.lead_progression_id < 7))
                                ||
                                (appData?.organization_id != 1 && appData.lead_progression_id < 7)
                            ) &&
                                <a
                                        className="btn btn-default btn-sm btn-outline-primary"
                                        target="_blank"
                                        onClick={(evt) =>
                                            this.setState({ assign_pricing_equipment_template: true })
                                        }
                                    >
                                        <span>P&E Editing</span>
                                </a>
                            }
                            </>
                        } 
                </div>
            </div>
        );

        const leftContent = (
            <div className="content-area-left-col">
                <div className="content-area-left">
                    {isMobile ? (
                        <div className="mobile-content-area-left-header">
                            <div className="mobile-header-1">
                                <div className="mobile-header-title">
                                    <h1>
                                        {listed_apps ? listed_apps : "All"}{" "}
                                        Applications <span>({totalCount})</span>
                                    </h1>
                                </div>
                                <div className="mobile-header-search">
                                    <form
                                        onSubmit={(e) => {
                                            e.preventDefault();
                                            this.getPreappData();
                                        }}
                                    >
                                        <input
                                            type="text"
                                            value={this.state.search}
                                            placeholder="Search"
                                            name="search"
                                            className={
                                                this.state.searchInputShow
                                                    ? ""
                                                    : "search-box"
                                            }
                                            onChange={this.searchPreapp}
                                        />
                                        <button type="submit">
                                            <i
                                                className="fa fa-search"
                                                onClick={this.toggleSearch}
                                            ></i>
                                        </button>
                                        {this.state.search && (
                                            <a
                                                className="searchbar-close"
                                                onClick={this.clearSearch}
                                            >
                                                <i className="fa fa-close"></i>
                                            </a>
                                        )}
                                    </form>
                                </div>
                            </div>
                            <div className="mobile_app1">
                                {/* <div className="mobile_Customize">
                    <h5>Customize table</h5>
                </div> */}
                                <div className="mobile_Customize1">
                                    <button
                                        className="btn btn-default filter-button"
                                        onClick={(e) => this.showSearch(e)}
                                    >
                                        Filter <img src={imgFilter} />
                                    </button>
                                    <div
                                        className={
                                            showFilters
                                                ? "header-search-box-wrap   show-filter"
                                                : "header-search-box-wrap"
                                        }
                                    >
                                        <div
                                            className="row row-no-gutters"
                                            onClick={(e) => e.stopPropagation()}
                                        >
                                            <div className="col-lg-12">
                                                <div className="form-horizontal">
                                                    <>
                                                        <div className="form-group">
                                                            <div className="col-sm-12 realationMng ">
                                                                <ReactMultiSelectCheckboxes
                                                                    placeholderButtonLabel="Team Lead"
                                                                    onChange={
                                                                        this
                                                                            .handleRelationManager
                                                                    }
                                                                    className="multi-select"
                                                                    options={
                                                                        relationManager
                                                                    }
                                                                />
                                                            </div>
                                                        </div>
                                                        <div className="form-group">
                                                            <div className="col-sm-12 uwDropdown">
                                                                <ReactMultiSelectCheckboxes
                                                                    placeholderButtonLabel="Select UW"
                                                                    onChange={
                                                                        this
                                                                            .handleUW
                                                                    }
                                                                    className="multi-select"
                                                                    options={
                                                                        relationManager
                                                                    }
                                                                />
                                                            </div>
                                                        </div>
                                                    </>
                                                    {pci_admin && (
                                                        <div>
                                                            <div className="form-group">
                                                                <div className="col-sm-12 filter_manage_dropdown border-none">
                                                                    <SelectDropDown
                                                                        isSearchable={
                                                                            true
                                                                        }
                                                                        options={
                                                                            organization_options
                                                                        }
                                                                        name="filter_user_by_organization"
                                                                        placeholder="Select organization"
                                                                        value=""
                                                                        handleChange={(
                                                                            selected,
                                                                        ) => {
                                                                            this.handleUserListByOrg(
                                                                                selected.value,
                                                                            );
                                                                        }}
                                                                    />
                                                                </div>
                                                            </div>

                                                            <div className="form-group">
                                                                <div className="col-sm-12 filter_manage_dropdown border-none">
                                                                    {this.state
                                                                        .userListForFilterApp
                                                                        .length >
                                                                        0 && (
                                                                            <SelectDropDown
                                                                                isSearchable={
                                                                                    true
                                                                                }
                                                                                options={
                                                                                    this
                                                                                        .state
                                                                                        .userListForFilterApp
                                                                                }
                                                                                name="filter_app_by_users"
                                                                                placeholder="Select user"
                                                                                value={
                                                                                    this
                                                                                        .state
                                                                                        .appSearchByUser
                                                                                }
                                                                                handleChange={(
                                                                                    selected,
                                                                                ) => {
                                                                                    this.handleUserChange(
                                                                                        selected.value,
                                                                                    );
                                                                                }}
                                                                            />
                                                                        )}
                                                                    {this.state
                                                                        .userListForFilterApp
                                                                        .length <
                                                                        1 &&
                                                                        this
                                                                            .state
                                                                            .appSearchByOrg && (
                                                                            <p className="text-center">
                                                                                No
                                                                                User
                                                                                For
                                                                                this
                                                                                Organization
                                                                            </p>
                                                                        )}
                                                                </div>
                                                            </div>

                                                            <div className="form-group">
                                                                <div className="col-sm-12 filter_manage_dropdown border-none">
                                                                    <SelectDropDown
                                                                        isSearchable={
                                                                            true
                                                                        }
                                                                        options={
                                                                            this
                                                                                .state
                                                                                .bankList
                                                                        }
                                                                        name="filter_user_by_organization"
                                                                        placeholder="Select Processors"
                                                                        value={
                                                                            this
                                                                                .state
                                                                                .selectedBank
                                                                        }
                                                                        handleChange={(
                                                                            selected,
                                                                        ) => {
                                                                            this.hanldeBankChange(
                                                                                selected.value,
                                                                            );
                                                                        }}
                                                                    />
                                                                </div>
                                                            </div>

                                                            <div className="form-group">
                                                                <div className="col-sm-12 filter_manage_dropdown border-none">
                                                                    <SelectDropDown
                                                                        isSearchable={
                                                                            true
                                                                        }
                                                                        options={[
                                                                            {
                                                                                label: "Terminated",
                                                                                value: "terminated",
                                                                            },
                                                                            {
                                                                                label: "Support",
                                                                                value: "support",
                                                                            },
                                                                        ]}
                                                                        name="filter_progress_id"
                                                                        placeholder="Select Progress"
                                                                        value={
                                                                            this
                                                                                .state
                                                                                .left_progression_filter
                                                                        }
                                                                        handleChange={(
                                                                            selected,
                                                                        ) => {
                                                                            this.hanldeLetProgressionFilter(
                                                                                selected.value,
                                                                            );
                                                                        }}
                                                                    />
                                                                </div>
                                                            </div>
                                                        </div>
                                                    )}

                                                    <div className="form-group">
                                                        <div className="col-sm-12 text-right">
                                                            <button
                                                                type="button"
                                                                className="btn btn-primary 3"
                                                                onClick={(e) =>
                                                                    this.getPreappData()
                                                                }
                                                            >
                                                                Search
                                                            </button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    ) : (
                        <div className="content-area-left-header">
                            <div className="header-title">
                                <h1>
                                    {listed_apps ? listed_apps : "All"}{" "}
                                    Applications <span>({totalCount})</span>
                                </h1>
                            </div>
                            <div className="header-search">
                                <i
                                    className="fa fa-download pointer"
                                    style={{ marginRight: "1.5em" }}
                                    onClick={this.onExportCSVModalOpenHandler}
                                />
                                {this.state.showExportCSVModal ? (
                                    <ExportCSVModal
                                        onExportCSVButtonClickHandler={
                                            this.onExportCSVButtonClickHandler
                                        }
                                        show={this.state.showExportCSVModal}
                                        handleClose={
                                            this.onExportCSVModalCloseHandler
                                        }
                                        showExportSpinner={
                                            this.state.showExportSpinner
                                        }
                                    />
                                ) : null}
                                <form
                                    onSubmit={(e) => {
                                        e.preventDefault();
                                        this.getPreappData();
                                    }}
                                >
                                    <input
                                        type="text"
                                        value={this.state.search}
                                        placeholder="Search Apps"
                                        name="search"
                                        className="search-box"
                                        onChange={this.searchPreapp}
                                    />
                                    <button type="submit">
                                        <i className="fa fa-search"></i>
                                    </button>
                                    {this.state.search && (
                                        <a
                                            className="searchbar-close"
                                            onClick={this.clearSearch}
                                        >
                                            <i className="fa fa-close"></i>
                                        </a>
                                    )}
                                </form>
                                <button
                                    className="btn btn-default filter-button"
                                    onClick={(e) => this.showSearch(e)}
                                >
                                    Filter <img src={imgFilter} />
                                </button>
                                <div
                                    className={
                                        showFilters
                                            ? "header-search-box-wrap   show-filter"
                                            : "header-search-box-wrap"
                                    }
                                >
                                    <div
                                        className="row row-no-gutters"
                                        onClick={(e) => e.stopPropagation()}
                                    >
                                        <div className="col-lg-12">
                                            <div className="form-horizontal">
                                                <div className="form-group">
                                                    {this.state.loggedInUser
                                                        ?.channel ==
                                                        "sales_channel" ? (
                                                                <>
                                                        </>
                                                    ) : (
                                                        <>
                                                            <div className="col-sm-12 realationMng">
                                                                <ReactMultiSelectCheckboxes
                                                                    placeholderButtonLabel="Team Lead"
                                                                    onChange={
                                                                        this
                                                                            .handleRelationManager
                                                                    }
                                                                    className="multi-select"
                                                                    options={
                                                                        relationManager
                                                                    }
                                                                />
                                                            </div>

                                                            <div className="col-sm-12 uwDropdown">
                                                                <ReactMultiSelectCheckboxes
                                                                    placeholderButtonLabel="Select UW"
                                                                    onChange={
                                                                        this
                                                                            .handleUW
                                                                    }
                                                                    className="multi-select"
                                                                    options={
                                                                        relationManager
                                                                    }
                                                                />
                                                            </div>
                                                        </>
                                                    )}
                                                </div>

                                                {pci_admin ? (
                                                    <div>
                                                        <div className="form-group">
                                                            <div className="col-sm-12 filter_manage_dropdown border-none">
                                                                <SelectDropDown
                                                                    isSearchable={
                                                                        true
                                                                    }
                                                                    options={
                                                                        organization_options
                                                                    }
                                                                    name="filter_user_by_organization"
                                                                    placeholder="Select organization"
                                                                    value=""
                                                                    handleChange={(
                                                                        selected,
                                                                    ) => {
                                                                        this.handleUserListByOrg(
                                                                            selected.value,
                                                                        );
                                                                    }}
                                                                />
                                                            </div>
                                                        </div>
                                                        {this.state
                                                            .userListForFilterApp
                                                            .length > 0 && (
                                                                <div className="form-group">
                                                                    <div className="col-sm-12 filter_manage_dropdown border-none">
                                                                        {this.state
                                                                            .userListForFilterApp
                                                                            .length >
                                                                            0 && (
                                                                                <SelectDropDown
                                                                                    isSearchable={
                                                                                        true
                                                                                    }
                                                                                    options={
                                                                                        this
                                                                                            .state
                                                                                            .userListForFilterApp
                                                                                    }
                                                                                    name="filter_app_by_users"
                                                                                    placeholder="Select user"
                                                                                    value={
                                                                                        this
                                                                                            .state
                                                                                            .appSearchByUser
                                                                                    }
                                                                                    handleChange={(
                                                                                        selected,
                                                                                    ) => {
                                                                                        this.handleUserChange(
                                                                                            selected.value,
                                                                                        );
                                                                                    }}
                                                                                />
                                                                            )}
                                                                        {this.state
                                                                            .userListForFilterApp
                                                                            .length <
                                                                            1 &&
                                                                            this
                                                                                .state
                                                                                .appSearchByOrg && (
                                                                                <p className="text-center text-danger">
                                                                                    No
                                                                                    User
                                                                                    For
                                                                                    this
                                                                                    Organization
                                                                                </p>
                                                                            )}
                                                                    </div>
                                                                </div>
                                                            )}
                                                        <div className="form-group">
                                                            <div className="col-sm-12 filter_manage_dropdown border-none">
                                                                <SelectDropDown
                                                                    isSearchable={
                                                                        true
                                                                    }
                                                                    options={
                                                                        this
                                                                            .state
                                                                            .bankList
                                                                    }
                                                                    name="filter_user_by_organization"
                                                                    placeholder="Select Processors"
                                                                    value={
                                                                        this
                                                                            .state
                                                                            .selectedBank
                                                                    }
                                                                    handleChange={(
                                                                        selected,
                                                                    ) => {
                                                                        this.hanldeBankChange(
                                                                            selected.value,
                                                                        );
                                                                    }}
                                                                />
                                                            </div>
                                                        </div>

                                                        <div className="form-group">
                                                            <div className="col-sm-12 filter_manage_dropdown border-none">
                                                                <SelectDropDown
                                                                    isSearchable={
                                                                        true
                                                                    }
                                                                    options={[
                                                                        {
                                                                            label: "Terminated",
                                                                            value: "terminated",
                                                                        },
                                                                        {
                                                                            label: "Support",
                                                                            value: "support",
                                                                        },
                                                                    ]}
                                                                    name="filter_progress_id"
                                                                    placeholder="Select Progress"
                                                                    value={
                                                                        this
                                                                            .state
                                                                            .left_progression_filter
                                                                    }
                                                                    handleChange={(
                                                                        selected,
                                                                    ) => {
                                                                        this.hanldeLetProgressionFilter(
                                                                            selected.value,
                                                                        );
                                                                    }}
                                                                />
                                                            </div>
                                                        </div>
                                                    </div>
                                                ) : (
                                                    <div>
                                                        {this.state.loggedInUser
                                                            ?.role == "admin" &&
                                                            this.state.loggedInUser
                                                                ?.channel ==
                                                            "sales_channel" ? (
                                                            <div>
                                                                {this.state
                                                                    .userListForFilterApp
                                                                    .length >
                                                                    0 && (
                                                                        <div className="form-group">
                                                                            <div className="col-sm-12 filter_manage_dropdown border-none">
                                                                                {this
                                                                                    .state
                                                                                    .userListForFilterApp
                                                                                    .length >
                                                                                    0 && (
                                                                                        <SelectDropDown
                                                                                            isSearchable={
                                                                                                true
                                                                                            }
                                                                                            options={
                                                                                                this
                                                                                                    .state
                                                                                                    .userListForFilterApp
                                                                                            }
                                                                                            name="filter_app_by_users"
                                                                                            placeholder="Select user"
                                                                                            value={
                                                                                                this
                                                                                                    .state
                                                                                                    .appSearchByUser
                                                                                            }
                                                                                            handleChange={(
                                                                                                selected,
                                                                                            ) => {
                                                                                                this.handleUserChange(
                                                                                                    selected.value,
                                                                                                );
                                                                                            }}
                                                                                        />
                                                                                    )}
                                                                                {this
                                                                                    .state
                                                                                    .userListForFilterApp
                                                                                    .length <
                                                                                    1 &&
                                                                                    this
                                                                                        .state
                                                                                        .appSearchByOrg && (
                                                                                        <p className="text-center text-danger">
                                                                                            No
                                                                                            User
                                                                                            For
                                                                                            this
                                                                                            Organization
                                                                                        </p>
                                                                                    )}
                                                                            </div>
                                                                        </div>
                                                                    )}
                                                            </div>
                                                        ) : (
                                                            <></>
                                                        )}
                                                    </div>
                                                )}

                                                <div className="form-group">
                                                    <div className="col-sm-12 text-right">
                                                        <button
                                                            type="button"
                                                            className="btn btn-primary 3"
                                                            onClick={(e) =>
                                                                this.getPreappData()
                                                            }
                                                        >
                                                            Search
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}

                    <form>
                        {loggedInUser && loggedInUser.role && (
                            <div id="scrollableDiv">
                                <div className="table-div">
                                    {/* Bulk actions */}
                                    {this.state.bulkDataIds.length > 0 && (
                                        <BulkActions
                                            loggedInUser={loggedInUser}
                                            ids={this.state.bulkDataIds}
                                            getPreappData={() =>
                                                this.getPreappData()
                                            }
                                            clear={() => {
                                                this.setState({
                                                    bulkDataIds: [],
                                                });
                                            }}
                                        />
                                    )}
                                    {/* end Bulk actions */}
                                    <div className="table-div-thead">
                                        <div
                                            className="table-div-th col-status "
                                            onClick={(e) =>
                                                this.sortData("progression_id")
                                            }
                                        >
                                            Status{" "}
                                            {sortBy === "progression_id" && (
                                                <i
                                                    className={
                                                        sortValue === "ASC"
                                                            ? "fa fa-arrow-up"
                                                            : "fa fa-arrow-down"
                                                    }
                                                    aria-hidden="true"
                                                />
                                            )}
                                        </div>
                                        <div className="table-div-th col-star"></div>
                                        {isMobile || (
                                            <div
                                                className="table-div-th col-id"
                                                onClick={(e) =>
                                                    this.sortData("id")
                                                }
                                            >
                                                ID{" "}
                                                {sortBy === "id" && (
                                                    <i
                                                        className={
                                                            sortValue === "ASC"
                                                                ? "fa fa-arrow-up"
                                                                : "fa fa-arrow-down"
                                                        }
                                                        aria-hidden="true"
                                                    />
                                                )}
                                            </div>
                                        )}

                                        <div
                                            className={
                                                loggedInUser.role !== "agent"
                                                    ? "table-div-th col-merchant-dba"
                                                    : "table-div-th col-merchant-dba dba-name-agent"
                                            }
                                            onClick={(e) =>
                                                this.sortData("field_dba")
                                            }
                                        >
                                            Merchant DBA{" "}
                                            {sortBy === "field_dba" && (
                                                <i
                                                    className={
                                                        sortValue === "ASC"
                                                            ? "fa fa-arrow-up"
                                                            : "fa fa-arrow-down"
                                                    }
                                                    aria-hidden="true"
                                                />
                                            )}
                                        </div>
                                        {isMobile || (
                                            <div
                                                className={
                                                    loggedInUser.role !==
                                                        "agent"
                                                        ? "table-div-th col-bank"
                                                        : "table-div-th col-bank dba-name-agent"
                                                }
                                            >
                                                Organization
                                            </div>
                                        )}
                                        {isMobile ||
                                            (loggedInUser.role !== "agent" && (
                                                <div
                                                    className="table-div-th col-agent"
                                                    onClick={(e) =>
                                                        this.sortData("user_id")
                                                    }
                                                >
                                                    Agent ID{" "}
                                                    {sortBy === "user_id" && (
                                                        <i
                                                            className={
                                                                sortValue ===
                                                                    "ASC"
                                                                    ? "fa fa-arrow-up"
                                                                    : "fa fa-arrow-down"
                                                            }
                                                            aria-hidden="true"
                                                        />
                                                    )}
                                                </div>
                                            ))}

                                        {isMobile || (
                                            <div
                                                className="table-div-th col-created-at"
                                                onClick={(e) =>
                                                    this.sortData("created_at")
                                                }
                                            >
                                                <span>
                                                    Created&nbsp;
                                                    {sortBy ===
                                                        "created_at" && (
                                                            <i
                                                                className={
                                                                    sortValue ===
                                                                        "ASC"
                                                                        ? "fa fa-sort-amount-asc"
                                                                        : "fa fa-sort-amount-desc"
                                                                }
                                                                aria-hidden="true"
                                                            />
                                                        )}
                                                </span>
                                            </div>
                                        )}

                                        {isMobile || (
                                            <div
                                                className="table-div-th col-approved"
                                                onClick={(e) =>
                                                    this.sortData("approved_at")
                                                }
                                            >
                                                <span>
                                                    Approved At
                                                    {sortBy ===
                                                        "approved_at" && (
                                                            <i
                                                                className={
                                                                    sortValue ===
                                                                        "ASC"
                                                                        ? "fa fa-sort-amount-asc"
                                                                        : "fa fa-sort-amount-desc"
                                                                }
                                                                aria-hidden="true"
                                                            />
                                                        )}
                                                </span>
                                            </div>
                                        )}
                                    </div>
                                    <div className="table-div-tbody">
                                        <InfiniteScroll
                                            dataLength={preapp.length || 1}
                                            next={this.fetchMoreData}
                                            hasMore={hasMore}
                                            loader={
                                                <div className="loaderWrap">
                                                    <p className="loader">
                                                        {hasMore
                                                            ? "Loading..."
                                                            : "no more data"}
                                                    </p>
                                                </div>
                                            }
                                            height="100%"
                                        >
                                            {Object.entries(important).map(
                                                (t, k) =>
                                                    important_id.includes(
                                                        t[1].id,
                                                    ) && (
                                                        <div
                                                            className={
                                                                check.includes(
                                                                    "" +
                                                                    t[1]
                                                                        .id +
                                                                    "",
                                                                ) ||
                                                                    activeId ===
                                                                    t[1].id
                                                                    ? "table-div-tr active"
                                                                    : "table-div-tr"
                                                            }
                                                            key={t[0]}
                                                            onClick={(e) =>
                                                                this.handleClick(
                                                                    t[1].id,
                                                                    t[0],
                                                                )
                                                            }
                                                            onMouseLeave={() => {
                                                                this.handleHideButtons();
                                                            }}
                                                            onMouseEnter={() => {
                                                                this.handleShowButtons();
                                                            }}
                                                        >
                                                            <div className="table-div-td col-status">
                                                                {t[1]
                                                                    .form_type ===
                                                                    1 ? (
                                                                    <div className="text-right">
                                                                        Prevet
                                                                        Application
                                                                    </div>
                                                                ) : (
                                                                    <StatusBar
                                                                        className="col-status-bar"
                                                                        style={{
                                                                            maxWidth:
                                                                                "65px",
                                                                        }}
                                                                        percentage={status2Percentage(
                                                                            t[1],
                                                                        )}
                                                                    />
                                                                )}
                                                            </div>
                                                            <div className="table-div-td col-id">
                                                                {t[1].id}
                                                            </div>
                                                            {t[1].important
                                                                .is_important ===
                                                                1 ? (
                                                                <div
                                                                    className="table-div-td"
                                                                    onClick={(
                                                                        e,
                                                                    ) =>
                                                                        this.updateImportantTag(
                                                                            t[1],
                                                                            k,
                                                                            "important",
                                                                        )
                                                                    }
                                                                >
                                                                    <img src="/img/label_important.png" />
                                                                </div>
                                                            ) : (
                                                                <div className="table-div-td"></div>
                                                            )}
                                                            <div className="table-div-td col-bank">
                                                                {
                                                                    t[1]
                                                                        .organization
                                                                        .name
                                                                }
                                                            </div>
                                                            {loggedInUser.role !==
                                                                "agent" && (
                                                                    <div className="table-div-td col-agent">
                                                                        {t[1]
                                                                            .user !=
                                                                            null
                                                                            ? t[1]
                                                                                .user
                                                                                .name +
                                                                            "(" +
                                                                            t[1]
                                                                                .user
                                                                                .id +
                                                                            ")"
                                                                            : ""}
                                                                    </div>
                                                                )}
                                                            <div className="table-div-td col-merchant-dba">
                                                                {t[1]
                                                                    .field_dba || (
                                                                        <>&mdash;</>
                                                                    )}
                                                            </div>
                                                            <div className="table-div-td col-created-at">
                                                                {t[1]
                                                                    .created_at !=
                                                                    null
                                                                    ? moment(
                                                                        t[1]
                                                                            .created_at,
                                                                    ).format(
                                                                        "MMM D, YYYY",
                                                                    )
                                                                    : ""}
                                                            </div>
                                                            <div className="table-div-td col-approved">
                                                                {t[1]
                                                                    .approved_at !=
                                                                    null
                                                                    ? moment(
                                                                        t[1]
                                                                            .approved_at,
                                                                    ).format(
                                                                        "MMM D, YYYY",
                                                                    )
                                                                    : ""}
                                                            </div>
                                                        </div>
                                                    ),
                                            )}
                                            {important.length >= 1 && (
                                                <div className="table-div-tr seprator" />
                                            )}
                                            {Object.entries(preapp).map(
                                                (t, k) =>
                                                    !important_id.includes(
                                                        t[1].id,
                                                    ) && (
                                                        <PreappArow
                                                            pci_admin={
                                                                pci_admin
                                                            }
                                                            t={t}
                                                            default_index={
                                                                default_index
                                                            }
                                                            defaultBank={
                                                                defaultBank
                                                            }
                                                            status2Percentage={status2Percentage(
                                                                t[1],
                                                            )}
                                                            handleClick={(
                                                                id,
                                                                data,
                                                            ) =>
                                                                this.handleClick(
                                                                    id,
                                                                    data,
                                                                )
                                                            }
                                                            handleClickForMobileView={
                                                                this
                                                                    .handleClickForMobileView
                                                            }
                                                            handleClickWithChild={(
                                                                id,
                                                                data,
                                                            ) =>
                                                                this.handleClickWithChild(
                                                                    id,
                                                                    data,
                                                                )
                                                            }
                                                            handleChildAppClick={(
                                                                id,
                                                                data,
                                                            ) =>
                                                                this.handleChildAppClick(
                                                                    id,
                                                                    data,
                                                                )
                                                            }
                                                            currentStatus={currentStatus(
                                                                t[1],
                                                            )}
                                                            handleStar={(e) =>
                                                                this.handleStar(
                                                                    e,
                                                                )
                                                            }
                                                            handleCancle={(e) =>
                                                                this.handleCancle(
                                                                    e,
                                                                )
                                                            }
                                                            handlePdfRun={(e) =>
                                                                this.handlePdfRun(
                                                                    e,
                                                                )
                                                            }
                                                            handleAppCopy={(
                                                                e,
                                                            ) =>
                                                                this.handleAppCopy(
                                                                    e,
                                                                )
                                                            }
                                                            handleChangeOwner={(
                                                                e,
                                                            ) =>
                                                                this.handleShowOwnerModal()
                                                            }
                                                            showBanks={(
                                                                appId,
                                                                childApp,
                                                            ) =>
                                                                this.showBanks(
                                                                    appId,
                                                                    childApp,
                                                                )
                                                            }
                                                            handleActiveBank={(
                                                                e,
                                                            ) =>
                                                                this.handleActiveBank(
                                                                    e,
                                                                )
                                                            }
                                                            status2PercentageFn={(
                                                                e,
                                                            ) =>
                                                                status2Percentage(
                                                                    e,
                                                                )
                                                            }
                                                            check={check}
                                                            activeId={activeId}
                                                            user={loggedInUser}
                                                            row_info={row_info}
                                                            show_info={
                                                                show_info
                                                            }
                                                            isMobile={isMobile}
                                                            showExpandedInfo={
                                                                showExpandedInfo
                                                            }
                                                            currentProgressName={(
                                                                e,
                                                            ) =>
                                                                this.CurrentProgressionName(
                                                                    e,
                                                                )
                                                            }
                                                            handleChangeBank={() => {
                                                                this.setState({
                                                                    changeBankPopUp:
                                                                        t[1].id,
                                                                });
                                                            }}
                                                            appInfoContent={
                                                                appInfoContent
                                                            }
                                                            checkedPowerApp={(
                                                                e,
                                                                id,
                                                                index,
                                                            ) =>
                                                                this.checkedPowerApp(
                                                                    e,
                                                                    id,
                                                                    index,
                                                                )
                                                            }
                                                            updateBulkDataArray={(
                                                                data,
                                                                checked,
                                                            ) =>
                                                                this.updateBulkDataArray(
                                                                    data,
                                                                    checked,
                                                                )
                                                            }
                                                        />
                                                    ),
                                            )}
                                        </InfiniteScroll>
                                    </div>
                                </div>
                            </div>
                        )}
                    </form>
                </div>
            </div>
        );

        const rightContent = (
            <div className="content-area-right-col">
                <div className=" content-area">
                    <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 content-area-right-side-col">
                        {show_info && (
                            <div className="content-area-right-side">
                                {!activeId && (
                                    <h3 className="no-preapp">
                                        No Preapp Selected
                                    </h3>
                                )}
                                <div
                                    className={
                                        activeId
                                            ? "content-area-right-side-top"
                                            : "content-area-right-side-top hidden"
                                    }
                                >
                                    {appInfoContent}
                                    <div className="action-btns-tabs text-center">
                                        <ul
                                            className="nav nav-tabs"
                                            onClick={(e) => this.handleTab(e)}
                                        >
                                            <li
                                                className={
                                                    tab === "tab1"
                                                        ? "active"
                                                        : ""
                                                }
                                            >
                                                <a
                                                    data-toggle="tab"
                                                    name="tab1"
                                                >
                                                    Merchant Info
                                                </a>
                                            </li>
                                            <li
                                                className={
                                                    tab === "tab2"
                                                        ? "active"
                                                        : ""
                                                }
                                            >
                                                <a
                                                    data-toggle="tab"
                                                    name="tab2"
                                                >
                                                    Notes
                                                </a>
                                            </li>
                                            <li
                                                className={
                                                    tab === "tab3"
                                                        ? "active"
                                                        : ""
                                                }
                                            >
                                                <a
                                                    data-toggle="tab"
                                                    name="tab3"
                                                >
                                                    Files
                                                </a>
                                            </li>
                                            {is_parent && pci_admin && (
                                                <li
                                                    className={
                                                        tab === "tab4"
                                                            ? "active"
                                                            : ""
                                                    }
                                                >
                                                    <a
                                                        data-toggle="tab"
                                                        name="tab4"
                                                    >
                                                        Ehawk Note{" "}
                                                        {appData.ehawk &&
                                                            appData.ehawk
                                                                .length > 0 && (
                                                                <span
                                                                    className={
                                                                        "label label-default " +
                                                                        this.getScoreClass(
                                                                            appData
                                                                                .ehawk[0]
                                                                                .content,
                                                                        )
                                                                    }
                                                                >
                                                                    {
                                                                        appData
                                                                            .ehawk[0]
                                                                            .content
                                                                            .score
                                                                            .total
                                                                    }
                                                                </span>
                                                            )}
                                                    </a>
                                                </li>
                                            )}
                                            {appData.lead_progression_id > 7 ?

                                                <li
                                                    className={
                                                        tab === "tab5"
                                                            ? "active"
                                                            : ""
                                                    }
                                                >
                                                    <a
                                                        data-toggle="tab"
                                                        name="tab5"
                                                    >
                                                        Submission
                                                    </a>
                                                </li>
                                                : null}
                                            {pci_admin ||
                                                this.state.loggedInUser?.channel ==
                                                "sales_channel" ? (
                                                <li
                                                    className={
                                                        tab === "tab6"
                                                            ? "active"
                                                            : ""
                                                    }
                                                >
                                                    <a
                                                        data-toggle="tab"
                                                        name="tab6"
                                                    >
                                                        Activity
                                                    </a>
                                                </li>
                                            ) : null}
                                        </ul>
                                    </div>
                                    <div
                                        className="tab-content details-tab-content suggestion-list-tab"
                                        style={{ position: "relative" }}
                                    >
                                        {show_right_spinner ? (
                                            <div className="right-loader-wrap">
                                                <p className="loader"></p>
                                            </div>
                                        ) : (
                                            ""
                                        )}
                                        <div
                                            id="tab2"
                                            className={
                                                tab === "tab2"
                                                    ? "tab-pane fade in active"
                                                    : "tab-pane fade"
                                            }
                                        >
                                            {appData.notes != undefined && (
                                                <div className=" note-form">
                                                    <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 float-none">
                                                        <div class="dropdown-tags-area">
                                                            <MentionsInput
                                                                value={
                                                                    this.state
                                                                        .note
                                                                }
                                                                onChange={(
                                                                    e,
                                                                    newValue,
                                                                    newPlainTextValue,
                                                                    mentions,
                                                                ) =>
                                                                    this.handleNote(
                                                                        e,
                                                                        newValue,
                                                                        newPlainTextValue,
                                                                        mentions,
                                                                    )
                                                                }
                                                                className="form-control"
                                                                name="note"
                                                                placeholder={
                                                                    "Add New Note"
                                                                }
                                                            >
                                                                <Mention
                                                                    trigger="@"
                                                                    data={
                                                                        this
                                                                            .state
                                                                            .usersToMeation
                                                                    }
                                                                    appendSpaceOnAdd={
                                                                        true
                                                                    }
                                                                    displayTransform={(
                                                                        id,
                                                                        display,
                                                                    ) =>
                                                                        `@${display}`
                                                                    }
                                                                    onAdd={(
                                                                        id,
                                                                        display,
                                                                        startPos,
                                                                        endPos,
                                                                    ) =>
                                                                        this.getMentions(
                                                                            id,
                                                                            display,
                                                                            startPos,
                                                                            endPos,
                                                                        )
                                                                    }
                                                                />
                                                            </MentionsInput>

                                                            <div class="form-control box-shadow-none">
                                                                {pci_admin ? (
                                                                    <button
                                                                        name="merchant"
                                                                        onClick={(
                                                                            e,
                                                                        ) =>
                                                                            this.submit(
                                                                                e,
                                                                            )
                                                                        }
                                                                        disabled={
                                                                            !this
                                                                                .state
                                                                                .note
                                                                        }
                                                                        title={
                                                                            this
                                                                                .state
                                                                                .merchant_text
                                                                        }
                                                                        className={
                                                                            !this
                                                                                .state
                                                                                .note
                                                                                ? "edit notessave merchant-btn-note disabled-cursor"
                                                                                : "edit notessave merchant-btn-note"
                                                                        }
                                                                    >
                                                                        Save(M)
                                                                    </button>
                                                                ) : (
                                                                    <div></div>
                                                                )}

                                                                <button
                                                                    name="agent"
                                                                    onClick={(
                                                                        e,
                                                                    ) =>
                                                                        this.submit(
                                                                            e,
                                                                        )
                                                                    }
                                                                    disabled={
                                                                        !this
                                                                            .state
                                                                            .note
                                                                    }
                                                                    title={
                                                                        this
                                                                            .state
                                                                            .agent_text
                                                                    }
                                                                    className={
                                                                        !this
                                                                            .state
                                                                            .note
                                                                            ? "edit notessave agent-btn-note disabled-cursor"
                                                                            : "edit notessave agent-btn-note"
                                                                    }
                                                                >
                                                                    Save(A)
                                                                </button>

                                                                {pci_admin ? (
                                                                    <button
                                                                        name="pci"
                                                                        onClick={(
                                                                            e,
                                                                        ) =>
                                                                            this.submit(
                                                                                e,
                                                                            )
                                                                        }
                                                                        disabled={
                                                                            !this
                                                                                .state
                                                                                .note
                                                                        }
                                                                        title={
                                                                            this
                                                                                .state
                                                                                .pci_text
                                                                        }
                                                                        className={
                                                                            !this
                                                                                .state
                                                                                .note
                                                                                ? "edit notessave pci-btn-note disabled-cursor"
                                                                                : "edit notessave pci-btn-note"
                                                                        }
                                                                    >
                                                                        Save(P)
                                                                    </button>
                                                                ) : (
                                                                    <div></div>
                                                                )}
                                                            </div>
                                                        </div>
                                                    </div>
                                                    {this.state
                                                        .noteErrorMessage ? (
                                                        <span
                                                            style={{
                                                                marginLeft:
                                                                    "15px",
                                                            }}
                                                            className="text-danger"
                                                        >
                                                            *{" "}
                                                            {
                                                                this.state
                                                                    .noteErrorMessage
                                                            }
                                                        </span>
                                                    ) : null}
                                                </div>
                                            )}
                                            <div className="notes-box">
                                                {appData.latest !=
                                                    undefined && (
                                                        <div
                                                            className={
                                                                "applicationsnotes " +
                                                                "applicationnotes-" +
                                                                appData.latest
                                                                    .signal
                                                            }
                                                        >
                                                            <p
                                                                className="panel-body"
                                                                dangerouslySetInnerHTML={{
                                                                    __html: DOMPurify.sanitize(
                                                                        appData
                                                                            .latest
                                                                            .content,
                                                                    ),
                                                                }}
                                                            ></p>
                                                            <div className="fulldetailsnote">
                                                                <div className="notesdetails">
                                                                    <div className="notesavt">
                                                                        <img
                                                                            src={
                                                                                imgAvatarDefault
                                                                            }
                                                                        />
                                                                    </div>
                                                                    <div className="avtname">
                                                                        <span>
                                                                            {appData
                                                                                .latest
                                                                                .who !=
                                                                                ""
                                                                                ? appData
                                                                                    .latest
                                                                                    .who
                                                                                : "Anonymous"}
                                                                        </span>
                                                                    </div>
                                                                    <div className="avtdatetime">
                                                                        <span>
                                                                            {appData
                                                                                .latest
                                                                                .created_at !=
                                                                                null ? (
                                                                                moment(
                                                                                    appData
                                                                                        .latest
                                                                                        .created_at,
                                                                                ).format(
                                                                                    "MMM D, YYYY | H:mm A",
                                                                                )
                                                                            ) : (
                                                                                <>
                                                                                    &mdash;
                                                                                </>
                                                                            )}{" "}
                                                                            {appData
                                                                                .latest
                                                                                .bank !=
                                                                                null
                                                                                ? appData
                                                                                    .latest
                                                                                    .bank !=
                                                                                    ""
                                                                                    ? "(" +
                                                                                    appData
                                                                                        .latest
                                                                                        .bank +
                                                                                    ")"
                                                                                    : "(" +
                                                                                    defaultBank.name +
                                                                                    ")"
                                                                                : ""}
                                                                        </span>
                                                                    </div>
                                                                </div>
                                                                <span className="addresidualIMG">
                                                                    <img src="/images/delet.svg " />
                                                                </span>
                                                            </div>
                                                        </div>
                                                    )}
                                                {appData.notes != undefined &&
                                                    appData.notes.map(
                                                        (note, i) => (
                                                            <div
                                                                className={
                                                                    "applicationsnotes " +
                                                                    "applicationnotes-" +
                                                                    note.signal
                                                                }
                                                                key={i}
                                                            >
                                                                <p
                                                                    className="panel-body"
                                                                    dangerouslySetInnerHTML={{
                                                                        __html: DOMPurify.sanitize(
                                                                            note.content,
                                                                        ),
                                                                    }}
                                                                ></p>
                                                                <div className="fulldetailsnote">
                                                                    <div className="notesdetails">
                                                                        <div className="notesavt">
                                                                            <img
                                                                                src={
                                                                                    imgAvatarDefault
                                                                                }
                                                                            />
                                                                        </div>
                                                                        <div className="avtname">
                                                                            <span>
                                                                                {note.who !=
                                                                                    ""
                                                                                    ? note.who
                                                                                    : note.note_owner
                                                                                        ? note.note_owner
                                                                                        : "Anonymous"}
                                                                            </span>
                                                                        </div>
                                                                        <div className="avtdatetime">
                                                                            <span>
                                                                                {note.created_at !=
                                                                                    null ? (
                                                                                    moment(
                                                                                        note.created_at,
                                                                                    ).format(
                                                                                        "MMM D, YYYY | H:mm A",
                                                                                    )
                                                                                ) : (
                                                                                    <>
                                                                                        &mdash;
                                                                                    </>
                                                                                )}{" "}
                                                                                {note.bank !=
                                                                                    null
                                                                                    ? note.bank !=
                                                                                        ""
                                                                                        ? "(" +
                                                                                        note.bank +
                                                                                        ")"
                                                                                        : "(" +
                                                                                        defaultBank.name +
                                                                                        ")"
                                                                                    : ""}
                                                                            </span>
                                                                        </div>
                                                                    </div>
                                                                    {user?.channel ==
                                                                        "sales_channel" ? (
                                                                        <></>
                                                                    ) : (
                                                                        <span
                                                                            className="addresidualIMG"
                                                                            onClick={() =>
                                                                                this.deleteNote(
                                                                                    note.id,
                                                                                )
                                                                            }
                                                                        >
                                                                            <img src="/images/delet.svg " />
                                                                        </span>
                                                                    )}
                                                                </div>
                                                            </div>
                                                        ),
                                                    )}
                                            </div>
                                        </div>
                                        <div
                                            id="tab3"
                                            className={
                                                tab === "tab3"
                                                    ? "tab-pane fade in active"
                                                    : "tab-pane fade"
                                            }
                                        >
                                            <div className="newdargndrop">
                                                <Dropzone
                                                    onDrop={(e) =>
                                                        this.handleDrop(e)
                                                    }
                                                    onDropRejected={(e) =>
                                                        this.handleDropReject(e)
                                                    }
                                                    minSize={100}
                                                    maxSize={1000000 * 200}
                                                >
                                                    {({
                                                        getRootProps,
                                                        getInputProps,
                                                    }) => (
                                                        <>
                                                            <section className="desktopdragndrop">
                                                                <div
                                                                    {...getRootProps(
                                                                        {
                                                                            className:
                                                                                "dragndrop text-center",
                                                                        },
                                                                    )}
                                                                >
                                                                    <img
                                                                        src={
                                                                            imgUpload
                                                                        }
                                                                    />
                                                                    <p>
                                                                        Drag and
                                                                        drop the
                                                                        file
                                                                        <br />{" "}
                                                                        or{" "}
                                                                        <span>
                                                                            browse
                                                                        </span>{" "}
                                                                        to
                                                                        choose a
                                                                        file
                                                                    </p>
                                                                    <input
                                                                        {...getInputProps()}
                                                                    />
                                                                </div>
                                                                {this.state
                                                                    .uploadFileError !=
                                                                    null &&
                                                                    this.state
                                                                        .uploadFileError !==
                                                                    "" && (
                                                                        <p className="upload-error text-danger text-center">
                                                                            {
                                                                                this
                                                                                    .state
                                                                                    .uploadFileError
                                                                            }
                                                                        </p>
                                                                    )}
                                                            </section>
                                                            <section className="mobdragndrop">
                                                                <div
                                                                    {...getRootProps(
                                                                        {
                                                                            className:
                                                                                "dragndrop text-center",
                                                                        },
                                                                    )}
                                                                >
                                                                    <p>
                                                                        <span>
                                                                            {" "}
                                                                            +
                                                                            Upload
                                                                            file
                                                                        </span>
                                                                    </p>
                                                                    <input
                                                                        {...getInputProps()}
                                                                    />
                                                                </div>
                                                            </section>
                                                        </>
                                                    )}
                                                </Dropzone>
                                                <ReactModal
                                                    isOpen={
                                                        this.state.showModal
                                                    }
                                                    contentLabel="Minimal Modal Example"
                                                    className="upload-file-modal"
                                                >
                                                    <h4 className="text-center">
                                                        Select Title for file{" "}
                                                        {file}
                                                    </h4>
                                                    <div className="row">
                                                        <div className="col-md-12">
                                                            <select
                                                                className="form-control"
                                                                onChange={(e) =>
                                                                    this.handlechange(
                                                                        e,
                                                                    )
                                                                }
                                                            >
                                                                <option
                                                                    val=""
                                                                    disabled
                                                                    selected
                                                                >
                                                                    Select Title
                                                                </option>
                                                                <option val="Drivers License">
                                                                    Drivers
                                                                    License
                                                                </option>
                                                                <option val="Voided Check">
                                                                    Voided Check
                                                                </option>
                                                                <option val="Bank Statements">
                                                                    Bank
                                                                    Statements
                                                                </option>
                                                                <option val="Processing Statements">
                                                                    Processing
                                                                    Statements
                                                                </option>
                                                                <option val="Financials">
                                                                    Financials
                                                                </option>
                                                                <option val="Misc. Business Information">
                                                                    Misc.
                                                                    Business
                                                                    Information
                                                                </option>
                                                                <option val="Reserve">
                                                                    Reserve
                                                                </option>
                                                                <option val="Inside Photo">
                                                                    Inside Photo
                                                                </option>
                                                                <option val="Outside Photo">
                                                                    Outside
                                                                    Photo
                                                                </option>
                                                                <option val="Marketing Material">
                                                                    Marketing
                                                                    Material
                                                                </option>
                                                                <option val="Rate Review">
                                                                    Rate Review
                                                                </option>
                                                                <option val="Menu for MaxxPay">
                                                                    Menu for
                                                                    MaxxPay
                                                                </option>
                                                                <option val="WHO pre-questionnaire">
                                                                    WHO
                                                                    pre-questionnaire
                                                                </option>
                                                                <option val="Misc.">
                                                                    Misc.
                                                                </option>
                                                            </select>
                                                        </div>

                                                        <div className="col-md-12">
                                                            <button
                                                                className="btn btn-danger close_modal"
                                                                onClick={
                                                                    this
                                                                        .handleCloseModal
                                                                }
                                                            >
                                                                Close Modal
                                                            </button>
                                                            <button
                                                                className="btn btn-success close_modal"
                                                                onClick={(
                                                                    e,
                                                                ) => {
                                                                    if (
                                                                        this
                                                                            .uploadTitle !==
                                                                        ""
                                                                    ) {
                                                                        this.handleUpload();
                                                                    } else {
                                                                        this.setState(
                                                                            {
                                                                                uploadFileTypeError:
                                                                                    "Please select a file type.",
                                                                            },
                                                                        );
                                                                    }
                                                                }}
                                                            >
                                                                Save
                                                            </button>
                                                        </div>
                                                    </div>
                                                    <div className="row">
                                                        <div className="col-md-12">
                                                            {uploadFileTypeError &&
                                                                uploadFileTypeError !==
                                                                "" && (
                                                                    <p className="error-msg">
                                                                        {
                                                                            uploadFileTypeError
                                                                        }
                                                                    </p>
                                                                )}
                                                        </div>
                                                    </div>
                                                </ReactModal>
                                            </div>
                                            <div className="files-box text-center">
                                                <div className="file-uploadbox">
                                                    <h2>
                                                        Signed Documents{" "}
                                                        <img src="/images/opicon.svg" />
                                                    </h2>
                                                    {appData.files !=
                                                        undefined &&
                                                        Object.entries(
                                                            appData.files,
                                                        ).map((element, k) => (
                                                            <a
                                                                onClick={() =>
                                                                    this.openDocModal(
                                                                        element[1],
                                                                    )
                                                                }
                                                            >
                                                                <div
                                                                    key={k}
                                                                    className="file-uploadmain"
                                                                >
                                                                    <div className="uploadfilename">
                                                                        <div className="pdfupload">
                                                                            <img src="/images/pdffile.svg" />
                                                                        </div>
                                                                        <div className="pdfname">
                                                                            <p>
                                                                                {
                                                                                    element[1]
                                                                                        .name
                                                                                }
                                                                            </p>
                                                                        </div>
                                                                    </div>
                                                                    <div className="uploadsuccc"></div>
                                                                </div>
                                                            </a>
                                                        ))}
                                                </div>
                                                <div className="file-uploadbox bankuploadinfo">
                                                    <h2>
                                                        Uploaded files
                                                        {pci_admin ? (
                                                            <a
                                                                href={
                                                                    "download-all-file/" +
                                                                    appData.id
                                                                }
                                                                style={{
                                                                    float: "right",
                                                                }}
                                                            >
                                                                Download All
                                                            </a>
                                                        ) : null}
                                                    </h2>
                                                    <p>
                                                        Required documents:
                                                        Drivers license, voided
                                                        check, 3 month bank
                                                        statements, 3 month
                                                        processing statements
                                                        (optional)
                                                    </p>
                                                    {appData.uploads !=
                                                        undefined &&
                                                        Object.entries(
                                                            appData.uploads,
                                                        ).map((element, k) => (
                                                            <>
                                                                <div
                                                                    key={k}
                                                                    className="file-uploadmain"
                                                                >
                                                                    <a
                                                                        onClick={() =>
                                                                            this.openDocModal(
                                                                                element[1],
                                                                            )
                                                                        }
                                                                    >
                                                                        <div className="uploadfilename">
                                                                            <div className="pdfupload">
                                                                                <img src="/images/pdffile.svg" />
                                                                            </div>
                                                                            <div className="pdfname">
                                                                                <p>
                                                                                    {
                                                                                        element[1]
                                                                                            .file
                                                                                    }{" "}
                                                                                    -{" "}
                                                                                    {
                                                                                        element[1]
                                                                                            .title
                                                                                    }{" "}
                                                                                    -{" "}
                                                                                    {moment(
                                                                                        element[1]
                                                                                            .created_at,
                                                                                    ).format(
                                                                                        "MMM D, YYYY | H:mm A",
                                                                                    )}
                                                                                </p>
                                                                            </div>
                                                                        </div>
                                                                    </a>
                                                                    <div className="uploadsuccc">
                                                                        {user?.channel ==
                                                                            "partner_channel" ||
                                                                            loggedInUser?.is_ems_pc_admin ||
                                                                            loggedInUser?.is_pc_admin ? (
                                                                            <div className="uploaddelet">
                                                                                <img
                                                                                    onClick={(
                                                                                        e,
                                                                                    ) =>
                                                                                        this.deleteUploadedFiles(
                                                                                            element[1]
                                                                                                .id,
                                                                                            "show_right_spinner",
                                                                                        )
                                                                                    }
                                                                                    src="/images/delet.svg"
                                                                                    style={{
                                                                                        cursor: "pointer",
                                                                                    }}
                                                                                />
                                                                            </div>
                                                                        ) : (
                                                                            <>

                                                                            </>
                                                                        )}
                                                                    </div>
                                                                </div>
                                                            </>
                                                        ))}
                                                </div>
                                            </div>
                                        </div>
                                        <div
                                            id="tab1"
                                            className={
                                                tab === "tab1"
                                                    ? "tab-pane fade in active"
                                                    : "tab-pane fade"
                                            }
                                        >
                                            <Accordion defaultActiveKey="0">
                                                {appData.lead_progression_id > 0 ? (
                                                    <>
                                                        <Card>
                                                            <Card.Header
                                                                className={
                                                                    accordionNumber ===
                                                                        0
                                                                        ? "opened"
                                                                        : ""
                                                                }
                                                            >
                                                                <Accordion.Toggle
                                                                    as={Button}
                                                                    variant="link"
                                                                    eventKey="0"
                                                                    onClick={() =>
                                                                        this.handleToggleAccordion(
                                                                            0,
                                                                        )
                                                                    }
                                                                >
                                                                    Personal{" "}
                                                                    <i
                                                                        className={
                                                                            accordionNumber ===
                                                                                0
                                                                                ? "fa fa-chevron-up"
                                                                                : "fa fa-chevron-down"
                                                                        }
                                                                    />
                                                                </Accordion.Toggle>
                                                            </Card.Header>
                                                            <Accordion.Collapse eventKey="0">
                                                                <Card.Body>
                                                                    <span className="separator" />
                                                                    <div className="relevent-info-box">
                                                                        <div className="relevent-infos">
                                                                            <div className="row">
                                                                                <div className="col-md-6 col-sm-12 col-xs-12">
                                                                                    <div className="form-group">
                                                                                        <label>
                                                                                            Title
                                                                                        </label>
                                                                                        <p className="form-control-static">
                                                                                            {this.getTitleLabel(appData.title) || (
                                                                                                <>
                                                                                                    &mdash;
                                                                                                </>
                                                                                            )}
                                                                                        </p>
                                                                                    </div>
                                                                                    <div className="form-group">
                                                                                        <label>
                                                                                            First
                                                                                            Name
                                                                                        </label>
                                                                                        <p className="form-control-static">
                                                                                            {appData.field_firstname || (
                                                                                                <>
                                                                                                    &mdash;
                                                                                                </>
                                                                                            )}
                                                                                        </p>
                                                                                    </div>
                                                                                    <div className="form-group">
                                                                                        <label>
                                                                                            Last
                                                                                            Name
                                                                                        </label>
                                                                                        <p className="form-control-static">
                                                                                            {appData.field_lastname || (
                                                                                                <>
                                                                                                    &mdash;
                                                                                                </>
                                                                                            )}
                                                                                        </p>
                                                                                    </div>
                                                                                    <div className="form-group">
                                                                                        <label>
                                                                                            Date
                                                                                            of
                                                                                            Birth
                                                                                        </label>
                                                                                        <p className="form-control-static">
                                                                                            {this
                                                                                                .state
                                                                                                .loggedInUser
                                                                                                ?.channel ==
                                                                                                "sales_channel" ? (
                                                                                                <>
                                                                                                    {
                                                                                                        appData.field_birthdate
                                                                                                    }
                                                                                                </>
                                                                                            ) : (
                                                                                                <>
                                                                                                    {appData.field_birthdate &&
                                                                                                        appData.field_birthdate !==
                                                                                                        "1970-01-01 00:00:00" ? (
                                                                                                        moment(
                                                                                                            appData.field_birthdate,
                                                                                                        ).format(
                                                                                                            "MMMM D Y",
                                                                                                        )
                                                                                                    ) : (
                                                                                                        <>
                                                                                                            &mdash;
                                                                                                        </>
                                                                                                    )}
                                                                                                </>
                                                                                            )}
                                                                                        </p>
                                                                                    </div>
                                                                                    <div className="form-group">
                                                                                        <label>
                                                                                            Home
                                                                                            Address
                                                                                        </label>
                                                                                        <p className="form-control-static">
                                                                                            {appData.field_personalstreet || (
                                                                                                <>
                                                                                                    &mdash;
                                                                                                </>
                                                                                            )}
                                                                                        </p>
                                                                                    </div>
                                                                                    <div className="form-group">
                                                                                        <label>
                                                                                            City
                                                                                        </label>
                                                                                        <p className="form-control-static">
                                                                                            {appData.field_personalcity || (
                                                                                                <>
                                                                                                    &mdash;
                                                                                                </>
                                                                                            )}
                                                                                        </p>
                                                                                    </div>
                                                                                    <div className="form-group">
                                                                                        <label>
                                                                                            State
                                                                                        </label>
                                                                                        <p className="form-control-static">
                                                                                            {appData.field_personalstate || (
                                                                                                <>
                                                                                                    &mdash;
                                                                                                </>
                                                                                            )}
                                                                                        </p>
                                                                                    </div>
                                                                                    <div className="form-group">
                                                                                        <label>
                                                                                            Zip
                                                                                            Code
                                                                                        </label>
                                                                                        <p className="form-control-static">
                                                                                            {appData.field_personalzip || (
                                                                                                <>
                                                                                                    &mdash;
                                                                                                </>
                                                                                            )}
                                                                                        </p>
                                                                                    </div>
                                                                                    <div className="form-group">
                                                                                        <label>
                                                                                            Ownership
                                                                                            %
                                                                                        </label>
                                                                                        <p className="form-control-static">
                                                                                            {this.getOwnershipPercent()}
                                                                                        </p>
                                                                                    </div>
                                                                                </div>
                                                                                <div className="col-md-6 col-sm-12 col-xs-12">
                                                                                    <div className="form-group">
                                                                                        <label>
                                                                                            Time
                                                                                            at
                                                                                            current
                                                                                            residence(years)
                                                                                        </label>
                                                                                        <p className="form-control-static">
                                                                                            {appData.field_residenceyears !==
                                                                                                "" &&
                                                                                                appData.field_residenceyears !==
                                                                                                null ? (
                                                                                                appData.field_residenceyears
                                                                                            ) : (
                                                                                                <>
                                                                                                    &mdash;
                                                                                                </>
                                                                                            )}
                                                                                        </p>
                                                                                    </div>
                                                                                    <div className="form-group">
                                                                                        <label>
                                                                                            Time
                                                                                            at
                                                                                            current
                                                                                            residence(months)
                                                                                        </label>
                                                                                        <p className="form-control-static">
                                                                                            {appData.field_residencemonths !==
                                                                                                "" &&
                                                                                                appData.field_residencemonths !==
                                                                                                null ? (
                                                                                                appData.field_residencemonths
                                                                                            ) : (
                                                                                                <>
                                                                                                    &mdash;
                                                                                                </>
                                                                                            )}
                                                                                        </p>
                                                                                    </div>
                                                                                    <div className="form-group">
                                                                                        <label>
                                                                                            Social
                                                                                            security
                                                                                        </label>
                                                                                        <p className="form-control-static">
                                                                                            {appData.field_socialsecurity ==
                                                                                                "XXXXXXXlder" ? (
                                                                                                <>
                                                                                                    &mdash;
                                                                                                </>
                                                                                            ) : (
                                                                                                appData.field_socialsecurity || (
                                                                                                    <>
                                                                                                        &mdash;
                                                                                                    </>
                                                                                                )
                                                                                            )}
                                                                                        </p>
                                                                                    </div>
                                                                                    <div className="form-group">
                                                                                        <label>
                                                                                            {appData.field_documenttype ==
                                                                                                "PASSPORT"
                                                                                                ? "Passport Number"
                                                                                                : appData.field_documenttype ==
                                                                                                    "STATE_ID"
                                                                                                    ? "Drivers License"
                                                                                                    : appData.field_documenttype ==
                                                                                                        "LOCAL_STATE_ID"
                                                                                                        ? "State ID"
                                                                                                        : "Citizenship Card"}{" "}
                                                                                        </label>
                                                                                        <p className="form-control-static">
                                                                                            {appData.field_documentnumber || (
                                                                                                <>
                                                                                                    &mdash;
                                                                                                </>
                                                                                            )}
                                                                                        </p>
                                                                                    </div>

                                                                                    {appData.field_documenttype ==
                                                                                        "STATE_ID" ? (
                                                                                        <div className="form-group">
                                                                                            <label>
                                                                                                Drivers
                                                                                                License
                                                                                                (state)
                                                                                            </label>
                                                                                            <p className="form-control-static">
                                                                                                {appData.field_driverstate || (
                                                                                                    <>
                                                                                                        &mdash;
                                                                                                    </>
                                                                                                )}
                                                                                            </p>
                                                                                        </div>
                                                                                    ) : appData.field_documenttype ==
                                                                                        "PASSPORT" &&
                                                                                        this
                                                                                            .state
                                                                                            .loggedInUser
                                                                                            ?.channel ==
                                                                                        "sales_channel" ? (
                                                                                        <div className="form-group">
                                                                                            <label>
                                                                                                Passport
                                                                                                Country
                                                                                            </label>
                                                                                            <p className="form-control-static">
                                                                                                {appData.document_country ? (
                                                                                                    appData
                                                                                                        .document_country
                                                                                                        .name
                                                                                                ) : (
                                                                                                    <>
                                                                                                        &mdash;
                                                                                                    </>
                                                                                                )}
                                                                                            </p>
                                                                                        </div>
                                                                                    ) : (
                                                                                        <div className="form-group">
                                                                                            <label>
                                                                                                Place
                                                                                                Issued
                                                                                            </label>
                                                                                            <p className="form-control-static">
                                                                                                {appData.field_driverstate ==
                                                                                                    "placeholder" ? (
                                                                                                    <>
                                                                                                        &mdash;
                                                                                                    </>
                                                                                                ) : (
                                                                                                    appData.field_driverstate || (
                                                                                                        <>
                                                                                                            &mdash;
                                                                                                        </>
                                                                                                    )
                                                                                                )}
                                                                                            </p>
                                                                                        </div>
                                                                                    )}

                                                                                    <div className="form-group">
                                                                                        <label>
                                                                                            Personal
                                                                                            Phone
                                                                                        </label>
                                                                                        <p className="form-control-static">
                                                                                            {appData.field_personalphone ==
                                                                                                "1000000000" ? (
                                                                                                <>
                                                                                                    &mdash;
                                                                                                </>
                                                                                            ) : (
                                                                                                appData.field_personalphone || (
                                                                                                    <>
                                                                                                        &mdash;
                                                                                                    </>
                                                                                                )
                                                                                            )}
                                                                                        </p>
                                                                                    </div>
                                                                                    <div className="form-group">
                                                                                        <label>
                                                                                            Email
                                                                                            Id
                                                                                        </label>
                                                                                        <p className="form-control-static">
                                                                                            {appData.field_email ==
                                                                                                "placeholder@email.com" ? (
                                                                                                <>
                                                                                                    &mdash;
                                                                                                </>
                                                                                            ) : (
                                                                                                appData.field_email || (
                                                                                                    <>
                                                                                                        &mdash;
                                                                                                    </>
                                                                                                )
                                                                                            )}
                                                                                        </p>
                                                                                    </div>
                                                                                </div>
                                                                                {appData &&
                                                                                    appData.signers &&
                                                                                    Array.isArray(
                                                                                        appData.signers,
                                                                                    ) &&
                                                                                    appData
                                                                                        .signers
                                                                                        .length >
                                                                                    0 ? (
                                                                                    <>
                                                                                        {appData.signers.map(
                                                                                            (
                                                                                                signer,
                                                                                                index,
                                                                                            ) => (
                                                                                                <>
                                                                                                    <div className="col-md-12 col-sm-12 col-xs-12">
                                                                                                        <h4 className="text-center">
                                                                                                            Signers
                                                                                                            (
                                                                                                            {index +
                                                                                                                1}
                                                                                                            )
                                                                                                        </h4>
                                                                                                    </div>
                                                                                                    <div className="col-md-6 col-sm-12 col-xs-12">    
                                                                                                        <div className="form-group">
                                                                                                            <label>
                                                                                                                Title
                                                                                                            </label>
                                                                                                            <p className="form-control-static">
                                                                                                                {this.getTitleLabel(signer.title) || (
                                                                                                                    <>
                                                                                                                        &mdash;
                                                                                                                    </>
                                                                                                                )}
                                                                                                            </p>
                                                                                                        </div>   

                                                                                                        <div className="form-group">
                                                                                                            <label>
                                                                                                                First
                                                                                                                Name
                                                                                                            </label>
                                                                                                            <p className="form-control-static">
                                                                                                                {signer.first_name || (
                                                                                                                    <>
                                                                                                                        &mdash;
                                                                                                                    </>
                                                                                                                )}
                                                                                                            </p>
                                                                                                        </div>
                                                                                                        <div className="form-group">
                                                                                                            <label>
                                                                                                                E-Mail
                                                                                                            </label>
                                                                                                            <p className="form-control-static">
                                                                                                                {signer.email || (
                                                                                                                    <>
                                                                                                                        &mdash;
                                                                                                                    </>
                                                                                                                )}
                                                                                                            </p>
                                                                                                        </div>
                                                                                                        <div className="form-group">
                                                                                                            <label>
                                                                                                                Street
                                                                                                            </label>
                                                                                                            <p className="form-control-static">
                                                                                                                {signer.address_street || (
                                                                                                                    <>
                                                                                                                        &mdash;
                                                                                                                    </>
                                                                                                                )}
                                                                                                            </p>
                                                                                                        </div>
                                                                                                        <div className="form-group">
                                                                                                            <label>
                                                                                                                State
                                                                                                            </label>
                                                                                                            <p className="form-control-static">
                                                                                                                {signer.address_state || (
                                                                                                                    <>
                                                                                                                        &mdash;
                                                                                                                    </>
                                                                                                                )}
                                                                                                            </p>
                                                                                                        </div>
                                                                                                        <div className="form-group">
                                                                                                            <label>
                                                                                                                SSN
                                                                                                            </label>
                                                                                                            <p className="form-control-static">
                                                                                                                {signer.social_security || (
                                                                                                                    <>
                                                                                                                        &mdash;
                                                                                                                    </>
                                                                                                                )}
                                                                                                            </p>
                                                                                                        </div>
                                                                                                        <div className="form-group">
                                                                                                            <label>
                                                                                                                Document
                                                                                                                Type
                                                                                                            </label>
                                                                                                            <p className="form-control-static">
                                                                                                                {signer.document_type ? (
                                                                                                                    this.getDocumentLabel(
                                                                                                                        signer.document_type,
                                                                                                                    )
                                                                                                                ) : (
                                                                                                                    <>
                                                                                                                        &mdash;
                                                                                                                    </>
                                                                                                                )}
                                                                                                            </p>
                                                                                                        </div>
                                                                                                        {!signer.drivers_license_number ? null : (
                                                                                                            <div className="form-group">
                                                                                                                <label>
                                                                                                                    {this.getDocumentTypeLabel(
                                                                                                                        signer.document_type,
                                                                                                                    )}
                                                                                                                </label>
                                                                                                                <p className="form-control-static">
                                                                                                                    {signer.drivers_license_number || (
                                                                                                                        <>
                                                                                                                            &mdash;
                                                                                                                        </>
                                                                                                                    )}
                                                                                                                </p>
                                                                                                            </div>
                                                                                                        )}
                                                                                                        {signer.document_type ==
                                                                                                            "PASSPORT" &&
                                                                                                            this
                                                                                                                .state
                                                                                                                .loggedInUser
                                                                                                                ?.channel ==
                                                                                                            "sales_channel" ? (
                                                                                                            <div className="form-group">
                                                                                                                <label>
                                                                                                                    Document
                                                                                                                    Country
                                                                                                                </label>
                                                                                                                <p className="form-control-static">
                                                                                                                    {signer.country !==
                                                                                                                        null ? (
                                                                                                                        signer
                                                                                                                            ?.country
                                                                                                                            ?.name
                                                                                                                    ) : (
                                                                                                                        <>
                                                                                                                            &mdash;
                                                                                                                        </>
                                                                                                                    )}
                                                                                                                </p>
                                                                                                            </div>
                                                                                                        ) : (
                                                                                                            ""
                                                                                                        )}
                                                                                                        {(signer.document_type ==
                                                                                                            "CITIZENSHIP_CARD" ||
                                                                                                            signer.document_type ==
                                                                                                            "STATE_ID" ||
                                                                                                            signer.document_type ==
                                                                                                            "LOCAL_STATE_ID") && (
                                                                                                                <div className="form-group">
                                                                                                                    <label>
                                                                                                                        Place
                                                                                                                        Issued
                                                                                                                    </label>
                                                                                                                    <p className="form-control-static">
                                                                                                                        {signer.drivers_license_state !==
                                                                                                                            null ? (
                                                                                                                            signer.drivers_license_state
                                                                                                                        ) : (
                                                                                                                            <>
                                                                                                                                &mdash;
                                                                                                                            </>
                                                                                                                        )}
                                                                                                                    </p>
                                                                                                                </div>
                                                                                                            )}
                                                                                                    </div>
                                                                                                    <div className="col-md-6 col-sm-12 col-xs-12">
                                                                                                        <div className="form-group">
                                                                                                            <label>
                                                                                                                Last
                                                                                                                Name
                                                                                                            </label>
                                                                                                            <p className="form-control-static">
                                                                                                                {signer.last_name || (
                                                                                                                    <>
                                                                                                                        &mdash;
                                                                                                                    </>
                                                                                                                )}
                                                                                                            </p>
                                                                                                        </div>
                                                                                                        <div className="form-group">
                                                                                                            <label>
                                                                                                                Phone
                                                                                                            </label>
                                                                                                            <p className="form-control-static">
                                                                                                                {signer.phone || (
                                                                                                                    <>
                                                                                                                        &mdash;
                                                                                                                    </>
                                                                                                                )}
                                                                                                            </p>
                                                                                                        </div>
                                                                                                        <div className="form-group">
                                                                                                            <label>
                                                                                                                City
                                                                                                            </label>
                                                                                                            <p className="form-control-static">
                                                                                                                {signer.address_city || (
                                                                                                                    <>
                                                                                                                        &mdash;
                                                                                                                    </>
                                                                                                                )}
                                                                                                            </p>
                                                                                                        </div>
                                                                                                        <div className="form-group">
                                                                                                            <label>
                                                                                                                Zip
                                                                                                                Code
                                                                                                            </label>
                                                                                                            <p className="form-control-static">
                                                                                                                {signer.address_zip_code || (
                                                                                                                    <>
                                                                                                                        &mdash;
                                                                                                                    </>
                                                                                                                )}
                                                                                                            </p>
                                                                                                        </div>
                                                                                                        <div className="form-group">
                                                                                                            <label>
                                                                                                                Date
                                                                                                                Of
                                                                                                                Birth
                                                                                                            </label>
                                                                                                            <p className="form-control-static">
                                                                                                                {signer.date_of_birth || (
                                                                                                                    <>
                                                                                                                        &mdash;
                                                                                                                    </>
                                                                                                                )}
                                                                                                            </p>
                                                                                                        </div>
                                                                                                        <div className="form-group">
                                                                                                            <label>
                                                                                                                Ownership
                                                                                                                (%)
                                                                                                            </label>
                                                                                                            <p className="form-control-static">
                                                                                                                {signer.ownership_percentage || (
                                                                                                                    <>
                                                                                                                        &mdash;
                                                                                                                    </>
                                                                                                                )}
                                                                                                            </p>
                                                                                                        </div>
                                                                                                        {!signer.drivers_license_state ||
                                                                                                            signer.document_type !==
                                                                                                            "STATE_ID" ? null : (
                                                                                                            <div className="form-group">
                                                                                                                <label>
                                                                                                                    License
                                                                                                                    State
                                                                                                                </label>
                                                                                                                <p className="form-control-static">
                                                                                                                    {signer.drivers_license_state || (
                                                                                                                        <>
                                                                                                                            &mdash;
                                                                                                                        </>
                                                                                                                    )}
                                                                                                                </p>
                                                                                                            </div>
                                                                                                        )}
                                                                                                    </div>
                                                                                                </>
                                                                                            ),
                                                                                        )}
                                                                                    </>
                                                                                ) : null}
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </Card.Body>
                                                            </Accordion.Collapse>
                                                        </Card>
                                                        <Card>
                                                            <Card.Header
                                                                className={
                                                                    accordionNumber ===
                                                                        1
                                                                        ? "opened"
                                                                        : ""
                                                                }
                                                            >
                                                                <Accordion.Toggle
                                                                    as={Button}
                                                                    variant="link"
                                                                    eventKey="1"
                                                                    onClick={() =>
                                                                        this.handleToggleAccordion(
                                                                            1,
                                                                        )
                                                                    }
                                                                >
                                                                    Legal{" "}
                                                                    <i
                                                                        className={
                                                                            accordionNumber ===
                                                                                1
                                                                                ? "fa fa-chevron-up"
                                                                                : "fa fa-chevron-down"
                                                                        }
                                                                    />
                                                                </Accordion.Toggle>
                                                            </Card.Header>
                                                            <Accordion.Collapse eventKey="1">
                                                                <Card.Body>
                                                                    <span className="separator" />
                                                                    <div className="relevent-info-box">
                                                                        <div className="relevent-infos">
                                                                            <div className="row">
                                                                                <div className="col-md-6 col-sm-12 col-xs-12">
                                                                                    <div className="form-group">
                                                                                        <label>
                                                                                            Legal
                                                                                            Name
                                                                                        </label>
                                                                                        <p className="form-control-static">
                                                                                            {appData.field_legalname ==
                                                                                                "placeholder" ? (
                                                                                                <>
                                                                                                    &mdash;
                                                                                                </>
                                                                                            ) : (
                                                                                                appData.field_legalname || (
                                                                                                    <>
                                                                                                        &mdash;
                                                                                                    </>
                                                                                                )
                                                                                            )}
                                                                                        </p>
                                                                                    </div>
                                                                                    <div className="form-group">
                                                                                        <label>
                                                                                            Type
                                                                                            of
                                                                                            Ownership
                                                                                        </label>
                                                                                        <p className="form-control-static">
                                                                                            {appData.field_ownership || (
                                                                                                <>
                                                                                                    &mdash;
                                                                                                </>
                                                                                            )}
                                                                                        </p>
                                                                                    </div>
                                                                                    <div className="form-group">
                                                                                        <label>
                                                                                            Type
                                                                                            of
                                                                                            Business
                                                                                        </label>
                                                                                        <p className="form-control-static">
                                                                                            {appData.field_businesstype ? (
                                                                                                appData.field_businesstype
                                                                                            ) : appData.powerappbusinessprofile ? (
                                                                                                appData
                                                                                                    .powerappbusinessprofile
                                                                                                    .product_service_sold
                                                                                            ) : (
                                                                                                <>
                                                                                                    &mdash;
                                                                                                </>
                                                                                            )}
                                                                                        </p>
                                                                                    </div>
                                                                                    <div className="form-group">
                                                                                        <label>
                                                                                            Legal
                                                                                            Address
                                                                                        </label>
                                                                                        <p className="form-control-static">
                                                                                            {appData.field_legalstreet ==
                                                                                                "placeholder" ? (
                                                                                                <>
                                                                                                    &mdash;
                                                                                                </>
                                                                                            ) : (
                                                                                                appData.field_legalstreet || (
                                                                                                    <>
                                                                                                        &mdash;
                                                                                                    </>
                                                                                                )
                                                                                            )}
                                                                                        </p>
                                                                                    </div>
                                                                                    <div className="form-group">
                                                                                        <label>
                                                                                            City
                                                                                        </label>
                                                                                        <p className="form-control-static">
                                                                                            {appData.field_legalcity ==
                                                                                                "placeholder" ? (
                                                                                                <>
                                                                                                    &mdash;
                                                                                                </>
                                                                                            ) : (
                                                                                                appData.field_legalcity || (
                                                                                                    <>
                                                                                                        &mdash;
                                                                                                    </>
                                                                                                )
                                                                                            )}
                                                                                        </p>
                                                                                    </div>
                                                                                    <div className="form-group">
                                                                                        <label>
                                                                                            State
                                                                                        </label>
                                                                                        <p className="form-control-static">
                                                                                            {appData.field_legalstate ==
                                                                                                "placeholder" ? (
                                                                                                <>
                                                                                                    &mdash;
                                                                                                </>
                                                                                            ) : (
                                                                                                appData.field_legalstate || (
                                                                                                    <>
                                                                                                        &mdash;
                                                                                                    </>
                                                                                                )
                                                                                            )}
                                                                                        </p>
                                                                                    </div>
                                                                                    <div className="form-group">
                                                                                        <label>
                                                                                            Zip
                                                                                            Code
                                                                                        </label>
                                                                                        <p className="form-control-static">
                                                                                            {appData.field_legalzip ==
                                                                                                "placeholder" ? (
                                                                                                <>
                                                                                                    &mdash;
                                                                                                </>
                                                                                            ) : (
                                                                                                appData.field_legalzip || (
                                                                                                    <>
                                                                                                        &mdash;
                                                                                                    </>
                                                                                                )
                                                                                            )}
                                                                                        </p>
                                                                                    </div>
                                                                                    <div className="form-group">
                                                                                        <label>
                                                                                            DBA
                                                                                        </label>
                                                                                        <p className="form-control-static">
                                                                                            {appData.field_dba || (
                                                                                                <>
                                                                                                    &mdash;
                                                                                                </>
                                                                                            )}
                                                                                        </p>
                                                                                    </div>
                                                                                    <div className="form-group">
                                                                                        <label>
                                                                                            DBA
                                                                                            Phone
                                                                                        </label>
                                                                                        <p className="form-control-static">
                                                                                            {appData.field_dbaphone || (
                                                                                                <>
                                                                                                    &mdash;
                                                                                                </>
                                                                                            )}
                                                                                        </p>
                                                                                    </div>
                                                                                    <div className="form-group">
                                                                                        <label>
                                                                                            DBA
                                                                                            Address
                                                                                        </label>
                                                                                        <p className="form-control-static">
                                                                                            {appData.field_dbastreet || (
                                                                                                <>
                                                                                                    &mdash;
                                                                                                </>
                                                                                            )}
                                                                                        </p>
                                                                                    </div>
                                                                                    <div className="form-group">
                                                                                        <label>
                                                                                            DBA
                                                                                            City
                                                                                        </label>
                                                                                        <p className="form-control-static">
                                                                                            {appData.field_dbacity || (
                                                                                                <>
                                                                                                    &mdash;
                                                                                                </>
                                                                                            )}
                                                                                        </p>
                                                                                    </div>
                                                                                    <div className="form-group">
                                                                                        <label>
                                                                                            DBA
                                                                                            State
                                                                                        </label>
                                                                                        <p className="form-control-static">
                                                                                            {appData.field_dbastate || (
                                                                                                <>
                                                                                                    &mdash;
                                                                                                </>
                                                                                            )}
                                                                                        </p>
                                                                                    </div>
                                                                                </div>
                                                                                <div className="col-md-6 col-sm-12 col-xs-12">
                                                                                    <div className="form-group">
                                                                                        <label>
                                                                                            DBA
                                                                                            Zip
                                                                                        </label>
                                                                                        <p className="form-control-static">
                                                                                            {appData.field_dbazip || (
                                                                                                <>
                                                                                                    &mdash;
                                                                                                </>
                                                                                            )}
                                                                                        </p>
                                                                                    </div>
                                                                                    <div className="form-group">
                                                                                        <label>
                                                                                            Length
                                                                                            at
                                                                                            location(years)
                                                                                        </label>
                                                                                        <p className="form-control-static">
                                                                                            {appData.field_locationyears !==
                                                                                                "" &&
                                                                                                appData.field_locationyears !==
                                                                                                null ? (
                                                                                                appData.field_locationyears
                                                                                            ) : (
                                                                                                <>
                                                                                                    &mdash;
                                                                                                </>
                                                                                            )}
                                                                                        </p>
                                                                                    </div>
                                                                                    <div className="form-group">
                                                                                        <label>
                                                                                            Length
                                                                                            at
                                                                                            location(months)
                                                                                        </label>
                                                                                        <p className="form-control-static">
                                                                                            {appData.field_locationmonths !==
                                                                                                null &&
                                                                                                appData.field_locationmonths !==
                                                                                                "" ? (
                                                                                                appData.field_locationmonths
                                                                                            ) : (
                                                                                                <>
                                                                                                    &mdash;
                                                                                                </>
                                                                                            )}
                                                                                        </p>
                                                                                    </div>
                                                                                    <div className="form-group">
                                                                                        <label>
                                                                                            Business
                                                                                            Phone
                                                                                        </label>
                                                                                        <p className="form-control-static">
                                                                                            {appData.field_businessphone ? (
                                                                                                appData.field_businessphone
                                                                                            ) : (
                                                                                                <>
                                                                                                    &mdash;
                                                                                                </>
                                                                                            )}
                                                                                        </p>
                                                                                    </div>
                                                                                    <div className="form-group">
                                                                                        <label>
                                                                                            Tax
                                                                                            ID/EIN
                                                                                        </label>
                                                                                        <p className="form-control-static">
                                                                                            {appData.field_ein || (
                                                                                                <>
                                                                                                    &mdash;
                                                                                                </>
                                                                                            )}
                                                                                        </p>
                                                                                    </div>
                                                                                    <div className="form-group">
                                                                                        <label>
                                                                                            Business
                                                                                            Email
                                                                                        </label>
                                                                                        <p className="form-control-static">
                                                                                            {appData.field_businessemail || (
                                                                                                <>
                                                                                                    &mdash;
                                                                                                </>
                                                                                            )}
                                                                                        </p>
                                                                                    </div>
                                                                                    <div className="form-group">
                                                                                        <label>
                                                                                            Website
                                                                                            address
                                                                                        </label>
                                                                                        <p className="form-control-static">
                                                                                            {appData.field_website || (
                                                                                                <>
                                                                                                    &mdash;
                                                                                                </>
                                                                                            )}
                                                                                        </p>
                                                                                    </div>
                                                                                    <div className="form-group">
                                                                                        <label>
                                                                                            Length
                                                                                            of
                                                                                            Ownership(years)
                                                                                        </label>
                                                                                        <p className="form-control-static">
                                                                                            {appData.field_ownershipyears !==
                                                                                                "" &&
                                                                                                appData.field_ownershipyears !==
                                                                                                null ? (
                                                                                                appData.field_ownershipyears
                                                                                            ) : (
                                                                                                <>
                                                                                                    &mdash;
                                                                                                </>
                                                                                            )}
                                                                                        </p>
                                                                                    </div>
                                                                                    <div className="form-group">
                                                                                        <label>
                                                                                            Length
                                                                                            of
                                                                                            Ownership(months)
                                                                                        </label>
                                                                                        <p className="form-control-static">
                                                                                            {appData.field_ownershipmonths !==
                                                                                                "" &&
                                                                                                appData.field_ownershipmonths !==
                                                                                                null ? (
                                                                                                appData.field_ownershipmonths
                                                                                            ) : (
                                                                                                <>
                                                                                                    &mdash;
                                                                                                </>
                                                                                            )}
                                                                                        </p>
                                                                                    </div>
                                                                                    <div className="form-group">
                                                                                        <label>
                                                                                            Industry
                                                                                            Type
                                                                                            (MCC)
                                                                                        </label>
                                                                                        <p className="form-control-static">
                                                                                            {appData.mcc_info ? (
                                                                                                appData
                                                                                                    .mcc_info
                                                                                                    .description +
                                                                                                " (" +
                                                                                                appData
                                                                                                    .mcc_info
                                                                                                    .mcc +
                                                                                                ")"
                                                                                            ) : (
                                                                                                <>
                                                                                                    &mdash;
                                                                                                </>
                                                                                            )}
                                                                                        </p>
                                                                                    </div>
                                                                                    <br />
                                                                                    <div className="form-group">
                                                                                        <label>
                                                                                            Zone
                                                                                        </label>
                                                                                        <p className="form-control-static">
                                                                                            {appData.field_zone || (
                                                                                                <>
                                                                                                    &mdash;
                                                                                                </>
                                                                                            )}
                                                                                        </p>
                                                                                    </div>
                                                                                    {this
                                                                                        .state
                                                                                        .loggedInUser
                                                                                        ?.channel ==
                                                                                        "sales_channel" ? (
                                                                                        <div className="form-group">
                                                                                            <label>
                                                                                                Premise
                                                                                                Type
                                                                                            </label>
                                                                                            <p className="form-control-static">
                                                                                                {getPremiseType(
                                                                                                    appData.premise_type,
                                                                                                )}
                                                                                            </p>
                                                                                        </div>
                                                                                    ) : (
                                                                                        <>

                                                                                        </>
                                                                                    )}
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </Card.Body>
                                                            </Accordion.Collapse>
                                                        </Card>
                                                        <Card>
                                                            <Card.Header
                                                                className={
                                                                    accordionNumber ===
                                                                        2
                                                                        ? "opened"
                                                                        : ""
                                                                }
                                                            >
                                                                <Accordion.Toggle
                                                                    as={Button}
                                                                    variant="link"
                                                                    eventKey="2"
                                                                    onClick={() =>
                                                                        this.handleToggleAccordion(
                                                                            2,
                                                                        )
                                                                    }
                                                                >
                                                                    Business{" "}
                                                                    <i
                                                                        className={
                                                                            accordionNumber ===
                                                                                2
                                                                                ? "fa fa-chevron-up"
                                                                                : "fa fa-chevron-down"
                                                                        }
                                                                    />
                                                                </Accordion.Toggle>
                                                            </Card.Header>
                                                            <Accordion.Collapse eventKey="2">
                                                                <Card.Body>
                                                                    {appData.powerappbusinessprofile ? (
                                                                        <div className="relevent-info-box">
                                                                            <h4 className="text-center">
                                                                                Business
                                                                                Info
                                                                            </h4>
                                                                            <div className="relevent-infos business-info ">
                                                                                <div className="row">
                                                                                    <div className="col-md-12 col-sm-12 col-xs-12">
                                                                                        <div className="form-group">
                                                                                            <label>
                                                                                                Please
                                                                                                describe
                                                                                                in
                                                                                                detail
                                                                                                the
                                                                                                products/services
                                                                                                sold.
                                                                                            </label>
                                                                                            <p className="form-control-static">
                                                                                                {appData
                                                                                                    .powerappbusinessprofile
                                                                                                    .product_service_sold || (
                                                                                                        <>
                                                                                                            &mdash;
                                                                                                        </>
                                                                                                    )}{" "}
                                                                                            </p>
                                                                                        </div>

                                                                                        <div className="form-group">
                                                                                            <label>
                                                                                                If
                                                                                                charging
                                                                                                for
                                                                                                services,
                                                                                                how
                                                                                                long
                                                                                                will
                                                                                                it
                                                                                                take
                                                                                                to
                                                                                                complete
                                                                                                all
                                                                                                services
                                                                                                once
                                                                                                the
                                                                                                card
                                                                                                is
                                                                                                charged?
                                                                                            </label>
                                                                                            <p className="form-control-static">
                                                                                                {appData
                                                                                                    .powerappbusinessprofile
                                                                                                    .time_to_complete_services || (
                                                                                                        <>
                                                                                                            &mdash;
                                                                                                        </>
                                                                                                    )}{" "}
                                                                                            </p>
                                                                                        </div>

                                                                                        <div className="form-group">
                                                                                            <label>
                                                                                                Is
                                                                                                there
                                                                                                any
                                                                                                recurring
                                                                                                billing
                                                                                                or
                                                                                                trial
                                                                                                offers
                                                                                                as
                                                                                                part
                                                                                                of
                                                                                                the
                                                                                                purchase?
                                                                                            </label>
                                                                                            <p className="form-control-static">
                                                                                                {appData
                                                                                                    .powerappbusinessprofile
                                                                                                    .recurring_bill_triel_radio || (
                                                                                                        <>
                                                                                                            &mdash;
                                                                                                        </>
                                                                                                    )}{" "}
                                                                                            </p>
                                                                                        </div>

                                                                                        <div className="form-group">
                                                                                            <label>
                                                                                                What
                                                                                                percentage
                                                                                                of
                                                                                                sales
                                                                                                are
                                                                                                shipped
                                                                                                or
                                                                                                completed
                                                                                                outside
                                                                                                of
                                                                                                30
                                                                                                days?
                                                                                            </label>
                                                                                            <p className="form-control-static">
                                                                                                {appData
                                                                                                    .powerappbusinessprofile
                                                                                                    .complete_sales_outside_30 || (
                                                                                                        <>
                                                                                                            &mdash;
                                                                                                        </>
                                                                                                    )}{" "}
                                                                                            </p>
                                                                                        </div>
                                                                                        <div className="form-group">
                                                                                            <label>
                                                                                                Please
                                                                                                detail
                                                                                                how
                                                                                                the
                                                                                                products
                                                                                                or
                                                                                                services
                                                                                                are
                                                                                                advertised
                                                                                                or
                                                                                                marketed?
                                                                                                (i.e.
                                                                                                website,
                                                                                                tv,
                                                                                                radio,
                                                                                                call
                                                                                                center).
                                                                                                Please
                                                                                                provide
                                                                                                a
                                                                                                sample
                                                                                                of
                                                                                                your
                                                                                                marketing
                                                                                                material
                                                                                                (brochure,
                                                                                                flyer,
                                                                                                order
                                                                                                form,
                                                                                                advertising
                                                                                                script,
                                                                                                contracts,
                                                                                                or
                                                                                                agreements)
                                                                                            </label>
                                                                                            <p className="form-control-static">
                                                                                                {appData
                                                                                                    .powerappbusinessprofile
                                                                                                    .prod_advertise_desc || (
                                                                                                        <>
                                                                                                            &mdash;
                                                                                                        </>
                                                                                                    )}
                                                                                            </p>
                                                                                        </div>

                                                                                        <div className="form-group">
                                                                                            <p>
                                                                                                <b>
                                                                                                    Do
                                                                                                    you
                                                                                                    anticipate
                                                                                                    accepting
                                                                                                    foreign
                                                                                                    sales?
                                                                                                </b>
                                                                                            </p>
                                                                                            <p className="form-control-static">
                                                                                                {appData
                                                                                                    .powerappbusinessprofile
                                                                                                    .anticipate_accepting_foreign_sales_radio || (
                                                                                                        <>
                                                                                                            &mdash;
                                                                                                        </>
                                                                                                    )}{" "}
                                                                                            </p>
                                                                                        </div>
                                                                                        <div className="form-group">
                                                                                            <label>
                                                                                                If
                                                                                                yes,
                                                                                                what
                                                                                                percentage?
                                                                                            </label>
                                                                                            <p className="form-control-static">
                                                                                                {appData
                                                                                                    .powerappbusinessprofile
                                                                                                    .anticipate_forign_sale_desc || (
                                                                                                        <>
                                                                                                            &mdash;
                                                                                                        </>
                                                                                                    )}{" "}
                                                                                            </p>
                                                                                        </div>

                                                                                        <div className="form-group">
                                                                                            <label>
                                                                                                Are
                                                                                                products/services
                                                                                                delivered
                                                                                                by
                                                                                                a
                                                                                                third
                                                                                                party?
                                                                                            </label>
                                                                                            <p className="form-control-static">
                                                                                                {appData
                                                                                                    .powerappbusinessprofile
                                                                                                    .thirdparty_delivered_radio || (
                                                                                                        <>
                                                                                                            &mdash;
                                                                                                        </>
                                                                                                    )}{" "}
                                                                                            </p>
                                                                                        </div>

                                                                                        {this
                                                                                            .state
                                                                                            .loggedInUser
                                                                                            ?.channel ==
                                                                                            "sales_channel" ? (
                                                                                            <>
                                                                                                <div className="form-group">
                                                                                                    <label>
                                                                                                        Check
                                                                                                        Proccessing?
                                                                                                    </label>
                                                                                                    <p className="form-control-static">
                                                                                                        {
                                                                                                            appData
                                                                                                                .powerappbusinessprofile
                                                                                                                .cheque_processing
                                                                                                        }
                                                                                                    </p>
                                                                                                </div>
                                                                                                <div className="form-group">
                                                                                                    <label>
                                                                                                        Average
                                                                                                        Monthly
                                                                                                        Reveue
                                                                                                        (USD)
                                                                                                    </label>
                                                                                                    <p className="form-control-static">
                                                                                                        {
                                                                                                            appData
                                                                                                                .powerappbusinessprofile
                                                                                                                .average_annual_revenue
                                                                                                        }
                                                                                                    </p>
                                                                                                </div>
                                                                                                <div className="form-group">
                                                                                                    <p>
                                                                                                        <b>
                                                                                                            Is
                                                                                                            Business
                                                                                                            funding
                                                                                                            required?
                                                                                                        </b>
                                                                                                    </p>
                                                                                                    <p className="form-control-static">
                                                                                                        {appData
                                                                                                            .powerappbusinessprofile
                                                                                                            .business_funding_required ==
                                                                                                            1
                                                                                                            ? "Yes"
                                                                                                            : "No"}{" "}
                                                                                                    </p>
                                                                                                </div>
                                                                                                {appData
                                                                                                    .powerappbusinessprofile
                                                                                                    .business_funding_required ==
                                                                                                    1 && (
                                                                                                        <>
                                                                                                            <div className="form-group">
                                                                                                                <label>
                                                                                                                    How
                                                                                                                    much
                                                                                                                    funding
                                                                                                                    needed
                                                                                                                </label>
                                                                                                                <p className="form-control-static">
                                                                                                                    {
                                                                                                                        appData
                                                                                                                            .powerappbusinessprofile
                                                                                                                            .how_much_funding_do_you_need
                                                                                                                    }
                                                                                                                </p>
                                                                                                            </div>
                                                                                                            <div className="form-group">
                                                                                                                <label>
                                                                                                                    Intended
                                                                                                                    use
                                                                                                                    of
                                                                                                                    funds
                                                                                                                </label>
                                                                                                                <p className="form-control-static">
                                                                                                                    {
                                                                                                                        appData
                                                                                                                            .powerappbusinessprofile
                                                                                                                            .intended_use_of_funds
                                                                                                                    }
                                                                                                                </p>
                                                                                                            </div>
                                                                                                            <div className="form-group">
                                                                                                                <label>
                                                                                                                    Credit
                                                                                                                    Score
                                                                                                                </label>
                                                                                                                <p className="form-control-static">
                                                                                                                    {
                                                                                                                        appData
                                                                                                                            .powerappbusinessprofile
                                                                                                                            .what_is_your_credit_score
                                                                                                                    }
                                                                                                                </p>
                                                                                                            </div>
                                                                                                        </>
                                                                                                    )}
                                                                                                {(appData
                                                                                                    .powerappbusinessprofile
                                                                                                    ?.type_of_sales && (appData?.powerappbusinessprofile?.origination_of_transaction && 
                                                                                                        !appData.powerappbusinessprofile.origination_of_transaction.hasOwnProperty('internet'))) && (
                                                                                                        <div className="form-group">
                                                                                                            <label>
                                                                                                                Type
                                                                                                                Of
                                                                                                                Sales
                                                                                                            </label>
                                                                                                            <p className="form-control-static">
                                                                                                                On
                                                                                                                Premise
                                                                                                                Sale:{" "}
                                                                                                                {
                                                                                                                    appData
                                                                                                                        .powerappbusinessprofile
                                                                                                                        ?.type_of_sales
                                                                                                                        ?.on_premise_sale
                                                                                                                }
                                                                                                            </p>
                                                                                                            <p className="form-control-static">
                                                                                                                Off
                                                                                                                Premise
                                                                                                                Sale:{" "}
                                                                                                                {
                                                                                                                    appData
                                                                                                                        .powerappbusinessprofile
                                                                                                                        ?.type_of_sales
                                                                                                                        ?.off_premise_sale
                                                                                                                }
                                                                                                            </p>
                                                                                                            <p className="form-control-static">
                                                                                                                Mail
                                                                                                                Order:{" "}
                                                                                                                {
                                                                                                                    appData
                                                                                                                        .powerappbusinessprofile
                                                                                                                        ?.type_of_sales
                                                                                                                        ?.mail_order
                                                                                                                }
                                                                                                            </p>
                                                                                                            <p className="form-control-static">
                                                                                                                Telephone
                                                                                                                Order:{" "}
                                                                                                                {
                                                                                                                    appData
                                                                                                                        .powerappbusinessprofile
                                                                                                                        ?.type_of_sales
                                                                                                                        ?.telephone_order
                                                                                                                }
                                                                                                            </p>
                                                                                                            <p className="form-control-static">
                                                                                                                Internet:{" "}
                                                                                                                {
                                                                                                                    appData
                                                                                                                        .powerappbusinessprofile
                                                                                                                        ?.type_of_sales
                                                                                                                        ?.internet
                                                                                                                }
                                                                                                            </p>
                                                                                                        </div>
    )}
                                                                                                {appData
                                                                                                    .powerappbusinessprofile
                                                                                                    ?.origination_of_transaction && (
                                                                                                        <div className="form-group">
                                                                                                            <label>
                                                                                                                Origination
                                                                                                                Of
                                                                                                                Transaction
                                                                                                            </label>
                                                                                                            <p className="form-control-static">
                                                                                                                Sales
                                                                                                                Keyed:{" "}
                                                                                                                {
                                                                                                                    appData
                                                                                                                        .powerappbusinessprofile
                                                                                                                        ?.origination_of_transaction
                                                                                                                        ?.sales_keyed
                                                                                                                }
                                                                                                            </p>
                                                                                                            <p className="form-control-static">
                                                                                                                Sales
                                                                                                                Swiped:{" "}
                                                                                                                {
                                                                                                                    appData
                                                                                                                        .powerappbusinessprofile
                                                                                                                        ?.origination_of_transaction
                                                                                                                        ?.sales_swiped
                                                                                                                }
                                                                                                            </p>
                                                                                                            {appData.powerappbusinessprofile.origination_of_transaction.hasOwnProperty('internet') && (<p className="form-control-static">
                                                                                                                Internet:{" "}
                                                                                                                {
                                                                                                                    appData
                                                                                                                        .powerappbusinessprofile
                                                                                                                        ?.origination_of_transaction
                                                                                                                        ?.internet
                                                                                                                }
                                                                                                            </p>)}
                                                                                                        </div>
                                                                                                    )}

                                                                                                {appData
                                                                                                    .powerappbusinessprofile
                                                                                                    ?.tax_exempt && (
                                                                                                        <div className="form-group">
                                                                                                            <label>
                                                                                                                TAX
                                                                                                                Exempt
                                                                                                            </label>
                                                                                                            <p className="form-control-static">
                                                                                                                {
                                                                                                                    appData
                                                                                                                        .powerappbusinessprofile
                                                                                                                        ?.tax_exempt
                                                                                                                }
                                                                                                            </p>
                                                                                                        </div>
                                                                                                    )}
                                                                                            </>
                                                                                        ) : (
                                                                                            <>

                                                                                            </>
                                                                                        )}
                                                                                    </div>
                                                                                </div>
                                                                                <div className="row">
                                                                                    <div className="col-md-12 col-sm-12 col-xs-12">
                                                                                        <div className="form-group">
                                                                                            <label>
                                                                                                Multiple
                                                                                                Locations?
                                                                                            </label>
                                                                                            <p className="form-control-static text-capitalize">
                                                                                                {this
                                                                                                    .state
                                                                                                    .powerappbusinessprofile
                                                                                                    ?.is_multiple_locations || (
                                                                                                        <>
                                                                                                            &mdash;
                                                                                                        </>
                                                                                                    )}
                                                                                            </p>
                                                                                        </div>
                                                                                    </div>
                                                                                    {this
                                                                                        .state
                                                                                        .powerappbusinessprofile
                                                                                        ?.is_multiple_locations ==
                                                                                        "yes" && (
                                                                                            <>
                                                                                                <div className="col-md-6 col-sm-12 col-xs-12">
                                                                                                    <div className="form-group">
                                                                                                        <label>
                                                                                                            Multi-Merchant
                                                                                                        </label>
                                                                                                        <p className="form-control-static text-capitalize">
                                                                                                            {
                                                                                                                this
                                                                                                                    .state
                                                                                                                    .powerappbusinessprofile
                                                                                                                    ?.multi_merchant
                                                                                                            }{" "}
                                                                                                            Of{" "}
                                                                                                            {
                                                                                                                this
                                                                                                                    .state
                                                                                                                    .powerappbusinessprofile
                                                                                                                    ?.multi_merchant_of
                                                                                                            }
                                                                                                        </p>
                                                                                                    </div>
                                                                                                </div>
                                                                                                <div className="col-md-6 col-sm-12 col-xs-12">
                                                                                                    <div className="form-group">
                                                                                                        <label>
                                                                                                            Additional
                                                                                                            Location
                                                                                                        </label>
                                                                                                        <p className="form-control-static text-capitalize">
                                                                                                            {
                                                                                                                this
                                                                                                                    .state
                                                                                                                    .powerappbusinessprofile
                                                                                                                    ?.additional_location
                                                                                                            }{" "}
                                                                                                            Of{" "}
                                                                                                            {
                                                                                                                this
                                                                                                                    .state
                                                                                                                    .powerappbusinessprofile
                                                                                                                    ?.additional_location_of
                                                                                                            }
                                                                                                        </p>
                                                                                                    </div>
                                                                                                </div>
                                                                                            </>
                                                                                        )}
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    ) : (
                                                                        <div className="relevent-info-box">
                                                                            <div className="relevent-infos card-profile">
                                                                                <h4 className="text-center">
                                                                                    Business
                                                                                    Info
                                                                                    not
                                                                                    Available
                                                                                </h4>
                                                                            </div>
                                                                        </div>
                                                                    )}
                                                                </Card.Body>
                                                            </Accordion.Collapse>
                                                        </Card>
                                                        <Card>
                                                            <Card.Header
                                                                className={
                                                                    accordionNumber ===
                                                                        3
                                                                        ? "opened"
                                                                        : ""
                                                                }
                                                            >
                                                                <Accordion.Toggle
                                                                    as={Button}
                                                                    variant="link"
                                                                    eventKey="3"
                                                                    onClick={() =>
                                                                        this.handleToggleAccordion(
                                                                            3,
                                                                        )
                                                                    }
                                                                >
                                                                    Credit Card
                                                                    Processing{" "}
                                                                    <i
                                                                        className={
                                                                            accordionNumber ===
                                                                                3
                                                                                ? "fa fa-chevron-up"
                                                                                : "fa fa-chevron-down"
                                                                        }
                                                                    />
                                                                </Accordion.Toggle>
                                                            </Card.Header>
                                                            <Accordion.Collapse eventKey="3">
                                                                <Card.Body>
                                                                    <div className="relevent-info-box">
                                                                        {appData.creditcardprocess ? (
                                                                            <div className="relevent-infos card-profile">
                                                                                <h4 className="text-center">
                                                                                    Credit
                                                                                    Card
                                                                                    Processing
                                                                                </h4>
                                                                                <div className="row">
                                                                                    <div className="col-md-12 col-sm-12 col-xs-12">
                                                                                        <p>
                                                                                            <b>
                                                                                                Has
                                                                                                the
                                                                                                business
                                                                                                or
                                                                                                any
                                                                                                associated
                                                                                                owner
                                                                                                ever
                                                                                                been
                                                                                                terminated
                                                                                                as
                                                                                                a
                                                                                                Visa®MasterCard®/Discover®/American
                                                                                                Express®
                                                                                                merchant?
                                                                                            </b>
                                                                                        </p>
                                                                                        <p>
                                                                                            {appData.creditcardprocess
                                                                                                ? appData
                                                                                                    .creditcardprocess
                                                                                                    .terminated_as_vmdax
                                                                                                : ""}{" "}
                                                                                        </p>
                                                                                        <p>
                                                                                            <b>
                                                                                                Do
                                                                                                you
                                                                                                currently
                                                                                                accept
                                                                                                Visa®/MasterCard®/Discover®/American
                                                                                                Express®
                                                                                                If
                                                                                                yes,
                                                                                                please
                                                                                                submit
                                                                                                3
                                                                                                most
                                                                                                current
                                                                                                monthly
                                                                                                statements.
                                                                                            </b>
                                                                                        </p>
                                                                                        <p>
                                                                                            {appData.creditcardprocess
                                                                                                ? appData
                                                                                                    .creditcardprocess
                                                                                                    .accept_vmdax
                                                                                                : ""}{" "}
                                                                                        </p>

                                                                                        <p>
                                                                                            <b>
                                                                                                Are
                                                                                                the
                                                                                                third
                                                                                                parties/payment
                                                                                                application
                                                                                                involved
                                                                                                with
                                                                                                your
                                                                                                payment
                                                                                                process.
                                                                                            </b>
                                                                                        </p>
                                                                                        <p>
                                                                                            {appData.creditcardprocess
                                                                                                ? appData
                                                                                                    .creditcardprocess
                                                                                                    .third_party_involve
                                                                                                : ""}
                                                                                        </p>
                                                                                        <p>
                                                                                            <b>
                                                                                                Is
                                                                                                your
                                                                                                business
                                                                                                PCI
                                                                                                complaint?
                                                                                            </b>
                                                                                        </p>
                                                                                        <p>
                                                                                            {appData.creditcardprocess
                                                                                                ? appData
                                                                                                    .creditcardprocess
                                                                                                    .pci_complaint
                                                                                                : ""}{" "}
                                                                                        </p>

                                                                                        <p>
                                                                                            <b>
                                                                                                Has
                                                                                                your
                                                                                                business
                                                                                                had
                                                                                                any
                                                                                                ongoing
                                                                                                or
                                                                                                prior
                                                                                                data
                                                                                                compromise
                                                                                                investigations?
                                                                                            </b>
                                                                                        </p>
                                                                                        <p>
                                                                                            {appData.creditcardprocess
                                                                                                ? appData
                                                                                                    .creditcardprocess
                                                                                                    .prior_data_compromise_invetigation
                                                                                                : ""}{" "}
                                                                                        </p>

                                                                                        <p>
                                                                                            <b>
                                                                                                Has
                                                                                                the
                                                                                                business
                                                                                                previously
                                                                                                identified
                                                                                                with
                                                                                                Visa
                                                                                                Risk
                                                                                                Programs.
                                                                                            </b>
                                                                                        </p>
                                                                                        <p>
                                                                                            {appData.creditcardprocess
                                                                                                ? appData
                                                                                                    .creditcardprocess
                                                                                                    .identified_visa_risk_program
                                                                                                : ""}{" "}
                                                                                        </p>
                                                                                        <p>
                                                                                            <b>
                                                                                                How
                                                                                                are
                                                                                                you
                                                                                                taking
                                                                                                cards?
                                                                                            </b>
                                                                                        </p>
                                                                                        <p>
                                                                                            {appData.creditcardprocess
                                                                                                ? appData
                                                                                                    .creditcardprocess
                                                                                                    .takingcards
                                                                                                : ""}{" "}
                                                                                        </p>
                                                                                        {this
                                                                                            .state
                                                                                            .loggedInUser
                                                                                            ?.channel ==
                                                                                            "sales_channel" ? (
                                                                                            <>
                                                                                                <p>
                                                                                                    <b>
                                                                                                        Are
                                                                                                        you
                                                                                                        currently
                                                                                                        processing?
                                                                                                    </b>
                                                                                                </p>
                                                                                                <p>
                                                                                                    {appData.creditcardprocess
                                                                                                        ? appData
                                                                                                            .creditcardprocess
                                                                                                            .currently_processing
                                                                                                        : ""}{" "}
                                                                                                </p>
                                                                                            </>
                                                                                        ) : (
                                                                                            <>

                                                                                            </>
                                                                                        )}
                                                                                    </div>
                                                                                    <div className="col-md-12 col-sm-12 col-xs-12">
                                                                                        <h4 className="text-center">
                                                                                            Bank
                                                                                            Info
                                                                                        </h4>
                                                                                    </div>
                                                                                    <div className="col-md-6 col-sm-12 col-xs-12">
                                                                                        <p>
                                                                                            <b>
                                                                                                Bank
                                                                                                Name{" "}
                                                                                            </b>
                                                                                            :{" "}
                                                                                            {appData.bankinfo
                                                                                                ? appData
                                                                                                    .bankinfo
                                                                                                    .bankname
                                                                                                : ""}
                                                                                        </p>
                                                                                        <p>
                                                                                            <b>
                                                                                                Routing
                                                                                                Number
                                                                                            </b>{" "}
                                                                                            :{" "}
                                                                                            {appData.bankinfo
                                                                                                ? appData
                                                                                                    .bankinfo
                                                                                                    .bankrouting
                                                                                                : ""}
                                                                                        </p>
                                                                                        <p>
                                                                                            <b>
                                                                                                Account
                                                                                                Number
                                                                                            </b>{" "}
                                                                                            :{" "}
                                                                                            {appData.bankinfo
                                                                                                ? appData
                                                                                                    .bankinfo
                                                                                                    .bankaccount
                                                                                                : ""}
                                                                                        </p>
                                                                                        <>
                                                                                            {this
                                                                                                .state
                                                                                                .loggedInUser
                                                                                                ?.channel ==
                                                                                                "sales_channel" ? (
                                                                                                <p>
                                                                                                    <b>
                                                                                                        Bank
                                                                                                        Institute
                                                                                                        Number
                                                                                                    </b>{" "}
                                                                                                    :{" "}
                                                                                                    {appData.bankinfo
                                                                                                        ? appData
                                                                                                            .bankinfo
                                                                                                            .bank_institution_number
                                                                                                        : ""}
                                                                                                </p>
                                                                                            ) : (
                                                                                                <>

                                                                                                </>
                                                                                            )}
                                                                                        </>
                                                                                    </div>
                                                                                    <div className="col-md-6 col-sm-12 col-xs-12">
                                                                                        <p>
                                                                                            <b>
                                                                                                Max
                                                                                                monthly
                                                                                                sales
                                                                                                (
                                                                                                USD){" "}
                                                                                            </b>
                                                                                            :{" "}
                                                                                            {appData.bankinfo
                                                                                                ? parseInt(
                                                                                                    appData
                                                                                                        .bankinfo
                                                                                                        .maxsales,
                                                                                                )
                                                                                                : ""}{" "}
                                                                                        </p>
                                                                                        <p>
                                                                                            <b>
                                                                                                Average
                                                                                                Ticket
                                                                                            </b>{" "}
                                                                                            :{" "}
                                                                                            {appData.bankinfo
                                                                                                ? appData
                                                                                                    .bankinfo
                                                                                                    .ticketaverage
                                                                                                : ""}
                                                                                        </p>
                                                                                        <p>
                                                                                            <b>
                                                                                                Highest
                                                                                                Ticket
                                                                                            </b>{" "}
                                                                                            :{" "}
                                                                                            {appData.bankinfo
                                                                                                ? appData
                                                                                                    .bankinfo
                                                                                                    .tickethighest
                                                                                                : ""}
                                                                                        </p>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        ) : (
                                                                            <div className="relevent-infos card-profile">
                                                                                <h4 className="text-center">
                                                                                    Credit
                                                                                    Card
                                                                                    Processing
                                                                                    Info
                                                                                    not
                                                                                    Available
                                                                                </h4>
                                                                            </div>
                                                                        )}
                                                                    </div>
                                                                </Card.Body>
                                                            </Accordion.Collapse>
                                                        </Card>
                                                        <Card>
                                                            <Card.Header
                                                                className={
                                                                    accordionNumber ===
                                                                        4
                                                                        ? "opened"
                                                                        : ""
                                                                }
                                                            >
                                                                <Accordion.Toggle
                                                                    as={Button}
                                                                    variant="link"
                                                                    eventKey="4"
                                                                    onClick={() =>
                                                                        this.handleToggleAccordion(
                                                                            4,
                                                                        )
                                                                    }
                                                                >
                                                                    Pricing{" "}
                                                                    <i
                                                                        className={
                                                                            accordionNumber ===
                                                                                4
                                                                                ? "fa fa-chevron-up"
                                                                                : "fa fa-chevron-down"
                                                                        }
                                                                    />
                                                                </Accordion.Toggle>
                                                            </Card.Header>
                                                            <Accordion.Collapse eventKey="4">
                                                                <Card.Body>
                                                                    <div className="relevent-info-box">

                                                                        {appData.prices &&
                                                                            appData
                                                                                .prices
                                                                                .length >=
                                                                            1 ? (
                                                                            <div className="relevent-infos card-profile">
                                                                                <div>
                                                                                    <div>
                                                                                        <h4 className="text-center">
                                                                                            {this.PricingLabel(
                                                                                                appData.qualifiedtype,
                                                                                            )}
                                                                                        </h4>
                                                                                    </div>
                                                                                </div>
                                                                                {appData.billing ? (
                                                                                    <Pricing
                                                                                        prices={
                                                                                            appData.prices
                                                                                        }
                                                                                        pricingType={
                                                                                            appData.qualifiedtype
                                                                                        }
                                                                                        tieredAmex={
                                                                                            appData.pricing_model
                                                                                        }
                                                                                        isAch={
                                                                                            appData.is_ach
                                                                                        }
                                                                                        billingInfo={
                                                                                            appData.billing
                                                                                        }
                                                                                    />
                                                                                ) : (
                                                                                    <>
                                                                                        {appData.qualifiedtype ==
                                                                                            "icppt" ||
                                                                                            appData.qualifiedtype ==
                                                                                            "frate" ? (
                                                                                            <div>
                                                                                                <div>
                                                                                                    <h4 className="text-center">
                                                                                                        Processing
                                                                                                        Fees
                                                                                                    </h4>
                                                                                                    <div className="row">
                                                                                                        <div className="col-md-6 col-sm-6 col-xs-6">
                                                                                                            <p
                                                                                                                className={
                                                                                                                    "form-control-static "
                                                                                                                }
                                                                                                            >
                                                                                                                <b>
                                                                                                                    Passthrough
                                                                                                                    (per
                                                                                                                    item){" "}
                                                                                                                    {
                                                                                                                        appData
                                                                                                                            .prices[1]
                                                                                                                            .subtitle
                                                                                                                    }
                                                                                                                </b>

                                                                                                                :{" "}
                                                                                                                {
                                                                                                                    appData
                                                                                                                        .prices[1]
                                                                                                                        .pivot
                                                                                                                        .percent
                                                                                                                }
                                                                                                                %
                                                                                                            </p>
                                                                                                        </div>
                                                                                                        <div className="col-md-6 col-sm-6 col-xs-6">
                                                                                                            <p
                                                                                                                className={
                                                                                                                    "form-control-static "
                                                                                                                }
                                                                                                            >
                                                                                                                <b>
                                                                                                                    Passthrough
                                                                                                                    (per
                                                                                                                    item){" "}
                                                                                                                    {
                                                                                                                        appData
                                                                                                                            .prices[1]
                                                                                                                            .subtitle
                                                                                                                    }
                                                                                                                </b>

                                                                                                                :
                                                                                                                $
                                                                                                                {
                                                                                                                    appData
                                                                                                                        .prices[1]
                                                                                                                        .pivot
                                                                                                                        .dollars
                                                                                                                }
                                                                                                            </p>
                                                                                                        </div>
                                                                                                    </div>
                                                                                                    <div className="row">
                                                                                                        <div className="col-md-6 col-sm-6 col-xs-6">
                                                                                                            <p className="form-control-static">
                                                                                                                <b>
                                                                                                                    Pin
                                                                                                                    Debit
                                                                                                                    :{" "}
                                                                                                                </b>
                                                                                                                {
                                                                                                                    appData.debit_pin
                                                                                                                }
                                                                                                            </p>
                                                                                                        </div>
                                                                                                        <div className="col-md-6 col-sm-6 col-xs-6">
                                                                                                            <p className="form-control-static"></p>
                                                                                                        </div>
                                                                                                    </div>
                                                                                                    {appData.debit_pin ==
                                                                                                        "yes" ? (
                                                                                                        <div className="row">
                                                                                                            <div className="col-md-6 col-sm-6 col-xs-6">
                                                                                                                <p
                                                                                                                    className={
                                                                                                                        "form-control-static "
                                                                                                                    }
                                                                                                                >
                                                                                                                    <b>
                                                                                                                        PIN
                                                                                                                        Debit
                                                                                                                    </b>
                                                                                                                    :{" "}
                                                                                                                    {
                                                                                                                        appData
                                                                                                                            .prices[4]
                                                                                                                            .pivot
                                                                                                                            .percent
                                                                                                                    }
                                                                                                                    %
                                                                                                                </p>
                                                                                                            </div>
                                                                                                            <div className="col-md-6 col-sm-6 col-xs-6">
                                                                                                                <p
                                                                                                                    className={
                                                                                                                        "form-control-static "
                                                                                                                    }
                                                                                                                >
                                                                                                                    <b>
                                                                                                                        PIN
                                                                                                                        Debit
                                                                                                                    </b>
                                                                                                                    :
                                                                                                                    $
                                                                                                                    {
                                                                                                                        appData
                                                                                                                            .prices[4]
                                                                                                                            .pivot
                                                                                                                            .dollars
                                                                                                                    }
                                                                                                                </p>
                                                                                                            </div>
                                                                                                        </div>
                                                                                                    ) : null}
                                                                                                    <div className="row">
                                                                                                        <div className="col-md-6 col-sm-6 col-xs-6">
                                                                                                            <p
                                                                                                                className={
                                                                                                                    "form-control-static "
                                                                                                                }
                                                                                                            >
                                                                                                                <b>
                                                                                                                    Signature
                                                                                                                    Debit
                                                                                                                </b>
                                                                                                                :{" "}
                                                                                                                {
                                                                                                                    appData
                                                                                                                        .prices[5]
                                                                                                                        .pivot
                                                                                                                        .percent
                                                                                                                }
                                                                                                                %
                                                                                                            </p>
                                                                                                        </div>
                                                                                                        <div className="col-md-6 col-sm-6 col-xs-6">
                                                                                                            <p
                                                                                                                className={
                                                                                                                    "form-control-static "
                                                                                                                }
                                                                                                            >
                                                                                                                <b>
                                                                                                                    Signature
                                                                                                                    Debit
                                                                                                                </b>
                                                                                                                :
                                                                                                                $
                                                                                                                {
                                                                                                                    appData
                                                                                                                        .prices[5]
                                                                                                                        .pivot
                                                                                                                        .dollars
                                                                                                                }
                                                                                                            </p>
                                                                                                        </div>
                                                                                                    </div>
                                                                                                    <h4 className="text-center">
                                                                                                        General
                                                                                                        fees
                                                                                                    </h4>
                                                                                                    <div>
                                                                                                        <div className="row">
                                                                                                            <div className="col-md-6 col-sm-6 col-xs-6">
                                                                                                                <p
                                                                                                                    className={
                                                                                                                        "form-control-static "
                                                                                                                    }
                                                                                                                >
                                                                                                                    <b>
                                                                                                                        Service
                                                                                                                        (Monthly)
                                                                                                                    </b>
                                                                                                                    :
                                                                                                                    $
                                                                                                                    {
                                                                                                                        appData
                                                                                                                            .prices[16]
                                                                                                                            .pivot
                                                                                                                            .dollars
                                                                                                                    }
                                                                                                                </p>
                                                                                                            </div>
                                                                                                            <div className="col-md-6 col-sm-6 col-xs-6">
                                                                                                                <p
                                                                                                                    className={
                                                                                                                        "form-control-static "
                                                                                                                    }
                                                                                                                >
                                                                                                                    <b>
                                                                                                                        Authorization
                                                                                                                        (Per
                                                                                                                        Item)
                                                                                                                    </b>
                                                                                                                    :
                                                                                                                    $
                                                                                                                    {
                                                                                                                        appData
                                                                                                                            .prices[10]
                                                                                                                            .pivot
                                                                                                                            .dollars
                                                                                                                    }
                                                                                                                </p>
                                                                                                            </div>
                                                                                                        </div>
                                                                                                        <div className="row">
                                                                                                            <div className="col-md-6 col-sm-6 col-xs-6">
                                                                                                                <p
                                                                                                                    className={
                                                                                                                        "form-control-static "
                                                                                                                    }
                                                                                                                >
                                                                                                                    <b>
                                                                                                                        Batch
                                                                                                                        Header
                                                                                                                        (Per
                                                                                                                        Batch)
                                                                                                                    </b>
                                                                                                                    :
                                                                                                                    $
                                                                                                                    {
                                                                                                                        appData
                                                                                                                            .prices[13]
                                                                                                                            .pivot
                                                                                                                            .dollars
                                                                                                                    }
                                                                                                                </p>
                                                                                                            </div>
                                                                                                            <div className="col-md-6 col-sm-6 col-xs-6">
                                                                                                                <p
                                                                                                                    className={
                                                                                                                        "form-control-static "
                                                                                                                    }
                                                                                                                >
                                                                                                                    <b>
                                                                                                                        Voice
                                                                                                                        Authorization
                                                                                                                        (Per
                                                                                                                        Item)
                                                                                                                    </b>
                                                                                                                    :
                                                                                                                    $
                                                                                                                    {
                                                                                                                        appData
                                                                                                                            .prices[11]
                                                                                                                            .pivot
                                                                                                                            .dollars
                                                                                                                    }
                                                                                                                </p>
                                                                                                            </div>
                                                                                                        </div>
                                                                                                        <div className="row">
                                                                                                            <div className="col-md-6 col-sm-6 col-xs-6">
                                                                                                                <p
                                                                                                                    className={
                                                                                                                        "form-control-static "
                                                                                                                    }
                                                                                                                >
                                                                                                                    <b>
                                                                                                                        Chargeback
                                                                                                                        (Per
                                                                                                                        Item)
                                                                                                                    </b>
                                                                                                                    :
                                                                                                                    $
                                                                                                                    {
                                                                                                                        appData
                                                                                                                            .prices[19]
                                                                                                                            .pivot
                                                                                                                            .dollars
                                                                                                                    }
                                                                                                                </p>
                                                                                                            </div>
                                                                                                            <div className="col-md-6 col-sm-6 col-xs-6">
                                                                                                                <p
                                                                                                                    className={
                                                                                                                        "form-control-static "
                                                                                                                    }
                                                                                                                >
                                                                                                                    <b>
                                                                                                                        Retrieval
                                                                                                                        (Per
                                                                                                                        Item)
                                                                                                                    </b>
                                                                                                                    :
                                                                                                                    $
                                                                                                                    {
                                                                                                                        appData
                                                                                                                            .prices[20]
                                                                                                                            .pivot
                                                                                                                            .dollars
                                                                                                                    }
                                                                                                                </p>
                                                                                                            </div>
                                                                                                        </div>
                                                                                                        <div className="row">
                                                                                                            <div className="col-md-6 col-sm-6 col-xs-6">
                                                                                                                <p
                                                                                                                    className={
                                                                                                                        "form-control-static "
                                                                                                                    }
                                                                                                                >
                                                                                                                    <b>
                                                                                                                        NSF/ACH
                                                                                                                        Reject
                                                                                                                        (Per
                                                                                                                        Item)
                                                                                                                    </b>
                                                                                                                    :
                                                                                                                    $
                                                                                                                    {
                                                                                                                        appData
                                                                                                                            .prices[21]
                                                                                                                            .pivot
                                                                                                                            .dollars
                                                                                                                    }
                                                                                                                </p>
                                                                                                            </div>
                                                                                                            <div className="col-md-6 col-sm-6 col-xs-6">
                                                                                                                <p
                                                                                                                    className={
                                                                                                                        "form-control-static "
                                                                                                                    }
                                                                                                                >
                                                                                                                    <b>
                                                                                                                        Monthly
                                                                                                                        Minimum
                                                                                                                        (minimum
                                                                                                                        discount)
                                                                                                                    </b>

                                                                                                                    :
                                                                                                                    $
                                                                                                                    {
                                                                                                                        appData
                                                                                                                            .prices[17]
                                                                                                                            .pivot
                                                                                                                            .dollars
                                                                                                                    }
                                                                                                                </p>
                                                                                                            </div>
                                                                                                        </div>
                                                                                                        <div className="row">
                                                                                                            <div className="col-md-6 col-sm-6 col-xs-6">
                                                                                                                <p
                                                                                                                    className={
                                                                                                                        "form-control-static "
                                                                                                                    }
                                                                                                                >
                                                                                                                    <b>
                                                                                                                        Annual
                                                                                                                        Fee
                                                                                                                    </b>
                                                                                                                    :
                                                                                                                    $
                                                                                                                    {
                                                                                                                        appData
                                                                                                                            .prices[24]
                                                                                                                            .pivot
                                                                                                                            .dollars
                                                                                                                    }
                                                                                                                </p>
                                                                                                            </div>
                                                                                                            <div className="col-md-6 col-sm-6 col-xs-6">
                                                                                                                <p
                                                                                                                    className={
                                                                                                                        "form-control-static "
                                                                                                                    }
                                                                                                                >
                                                                                                                    <b>
                                                                                                                        {" "}
                                                                                                                        Early
                                                                                                                        closure
                                                                                                                        (ETF)
                                                                                                                    </b>
                                                                                                                    :
                                                                                                                    $
                                                                                                                    {
                                                                                                                        appData
                                                                                                                            .prices[26]
                                                                                                                            .pivot
                                                                                                                            .dollars
                                                                                                                    }
                                                                                                                </p>
                                                                                                            </div>
                                                                                                        </div>
                                                                                                        <div className="row">
                                                                                                            <div className="col-md-6 col-sm-6 col-xs-6">
                                                                                                                <p
                                                                                                                    className={
                                                                                                                        "form-control-static "
                                                                                                                    }
                                                                                                                >
                                                                                                                    <b>
                                                                                                                        AVS
                                                                                                                        Fee
                                                                                                                    </b>
                                                                                                                    :
                                                                                                                    $
                                                                                                                    {
                                                                                                                        appData
                                                                                                                            .prices[12]
                                                                                                                            .pivot
                                                                                                                            .dollars
                                                                                                                    }
                                                                                                                </p>
                                                                                                            </div>
                                                                                                        </div>
                                                                                                    </div>
                                                                                                    <h4 className="text-center">
                                                                                                        EBT
                                                                                                        Fees
                                                                                                    </h4>
                                                                                                    <div className="row">
                                                                                                        <div className="col-md-6 col-sm-6 col-xs-6">
                                                                                                            <p
                                                                                                                className={
                                                                                                                    "form-control-static "
                                                                                                                }
                                                                                                            >
                                                                                                                <b>
                                                                                                                    Does
                                                                                                                    Merchant
                                                                                                                    Accept
                                                                                                                    EBT
                                                                                                                    :{" "}
                                                                                                                </b>
                                                                                                                {
                                                                                                                    appData.ebt_fees
                                                                                                                }
                                                                                                            </p>
                                                                                                        </div>
                                                                                                    </div>
                                                                                                    {appData.ebt_fees ===
                                                                                                        "yes" && (
                                                                                                            <div>
                                                                                                                <div className="row">
                                                                                                                    <div className="col-md-6 col-sm-6 col-xs-6">
                                                                                                                        <p
                                                                                                                            className={
                                                                                                                                "form-control-static "
                                                                                                                            }
                                                                                                                        >
                                                                                                                            <b>
                                                                                                                                EBT
                                                                                                                                Transactions
                                                                                                                                (Per
                                                                                                                                Item)
                                                                                                                            </b>
                                                                                                                            :
                                                                                                                            $
                                                                                                                            {
                                                                                                                                appData
                                                                                                                                    .prices[28]
                                                                                                                                    .pivot
                                                                                                                                    .dollars
                                                                                                                            }
                                                                                                                        </p>
                                                                                                                    </div>
                                                                                                                    <div className="col-md-6 col-sm-6 col-xs-6">
                                                                                                                        <p
                                                                                                                            className={
                                                                                                                                "form-control-static "
                                                                                                                            }
                                                                                                                        >
                                                                                                                            <b>
                                                                                                                                {" "}
                                                                                                                                EBT
                                                                                                                                Transaction
                                                                                                                                (Monthly)
                                                                                                                            </b>
                                                                                                                            :
                                                                                                                            $
                                                                                                                            {
                                                                                                                                appData
                                                                                                                                    .prices[29]
                                                                                                                                    .pivot
                                                                                                                                    .dollars
                                                                                                                            }
                                                                                                                        </p>
                                                                                                                    </div>
                                                                                                                </div>
                                                                                                                <div className="row">
                                                                                                                    <div className="col-md-6 col-sm-6 col-xs-6">
                                                                                                                        <p
                                                                                                                            className={
                                                                                                                                "form-control-static "
                                                                                                                            }
                                                                                                                        >
                                                                                                                            <b>
                                                                                                                                EBT
                                                                                                                                Reg
                                                                                                                                Number
                                                                                                                            </b>
                                                                                                                            :
                                                                                                                            $
                                                                                                                            {
                                                                                                                                appData
                                                                                                                                    .prices[30]
                                                                                                                                    .pivot
                                                                                                                                    .dollars
                                                                                                                            }
                                                                                                                        </p>
                                                                                                                    </div>
                                                                                                                </div>
                                                                                                            </div>
                                                                                                        )}
                                                                                                    <h4 className="text-center">
                                                                                                        American
                                                                                                        Express
                                                                                                    </h4>
                                                                                                    <div className="row">
                                                                                                        <div className="col-md-6 col-sm-6 col-xs-6">
                                                                                                            <p
                                                                                                                className={
                                                                                                                    "form-control-static "
                                                                                                                }
                                                                                                            >
                                                                                                                <b>
                                                                                                                    Does
                                                                                                                    Merchant
                                                                                                                    want
                                                                                                                    to
                                                                                                                    accept
                                                                                                                    American
                                                                                                                    Express?&nbsp;
                                                                                                                </b>
                                                                                                                {appData?.apexoptout ==
                                                                                                                    "yes"
                                                                                                                    ? "No"
                                                                                                                    : "Yes"}
                                                                                                            </p>
                                                                                                        </div>
                                                                                                    </div>
                                                                                                </div>
                                                                                                {appData.apexoptout ===
                                                                                                    "no" && (
                                                                                                        <div className="row">
                                                                                                            <div className="col-md-6 col-sm-6 col-xs-6">
                                                                                                                <p
                                                                                                                    className={
                                                                                                                        "form-control-static "
                                                                                                                    }
                                                                                                                >
                                                                                                                    <b>
                                                                                                                        Passthrough
                                                                                                                        (Per
                                                                                                                        Item)
                                                                                                                    </b>
                                                                                                                    :{" "}
                                                                                                                    {
                                                                                                                        appData
                                                                                                                            .prices[34]
                                                                                                                            .pivot
                                                                                                                            .percent
                                                                                                                    }
                                                                                                                    %
                                                                                                                </p>
                                                                                                            </div>
                                                                                                            <div className="col-md-6 col-sm-6 col-xs-6">
                                                                                                                <p
                                                                                                                    className={
                                                                                                                        "form-control-static "
                                                                                                                    }
                                                                                                                >
                                                                                                                    <b>
                                                                                                                        Passthrough
                                                                                                                        (Per
                                                                                                                        Item)
                                                                                                                    </b>
                                                                                                                    :
                                                                                                                    $
                                                                                                                    {
                                                                                                                        appData
                                                                                                                            .prices[34]
                                                                                                                            .pivot
                                                                                                                            .dollars
                                                                                                                    }
                                                                                                                </p>
                                                                                                            </div>
                                                                                                        </div>
                                                                                                    )}
                                                                                            </div>
                                                                                        ) : null}
                                                                                        {appData.qualifiedtype ==
                                                                                            "tiered" ? (
                                                                                            <div>
                                                                                                <div>
                                                                                                    <h4 className="text-center">
                                                                                                        Processing
                                                                                                        Fees
                                                                                                    </h4>
                                                                                                    <div className="row">
                                                                                                        <div className="col-md-6 col-sm-6 col-xs-6">
                                                                                                            <p
                                                                                                                className={
                                                                                                                    "form-control-static "
                                                                                                                }
                                                                                                            >
                                                                                                                <b>
                                                                                                                    Qualified-tiered
                                                                                                                    (Per
                                                                                                                    Item)
                                                                                                                </b>
                                                                                                                :{" "}
                                                                                                                {
                                                                                                                    appData
                                                                                                                        .prices[0]
                                                                                                                        .pivot
                                                                                                                        .percent
                                                                                                                }
                                                                                                                %
                                                                                                            </p>
                                                                                                        </div>
                                                                                                        <div className="col-md-6 col-sm-6 col-xs-6">
                                                                                                            <p
                                                                                                                className={
                                                                                                                    "form-control-static "
                                                                                                                }
                                                                                                            >
                                                                                                                <b>
                                                                                                                    Qualified-tiered
                                                                                                                    (Per
                                                                                                                    Item)
                                                                                                                </b>
                                                                                                                :
                                                                                                                $
                                                                                                                {
                                                                                                                    appData
                                                                                                                        .prices[0]
                                                                                                                        .pivot
                                                                                                                        .dollars
                                                                                                                }
                                                                                                            </p>
                                                                                                        </div>
                                                                                                    </div>
                                                                                                    <div className="row">
                                                                                                        <div className="col-md-6 col-sm-6 col-xs-6">
                                                                                                            <p
                                                                                                                className={
                                                                                                                    "form-control-static "
                                                                                                                }
                                                                                                            >
                                                                                                                <b>
                                                                                                                    Mid-tiered
                                                                                                                    (Per
                                                                                                                    item)
                                                                                                                </b>
                                                                                                                :{" "}
                                                                                                                {
                                                                                                                    appData
                                                                                                                        .prices[2]
                                                                                                                        .pivot
                                                                                                                        .percent
                                                                                                                }
                                                                                                                %
                                                                                                            </p>
                                                                                                        </div>
                                                                                                        <div className="col-md-6 col-sm-6 col-xs-6">
                                                                                                            <p
                                                                                                                className={
                                                                                                                    "form-control-static "
                                                                                                                }
                                                                                                            >
                                                                                                                <b>
                                                                                                                    Mid-tiered
                                                                                                                    (Per
                                                                                                                    item)
                                                                                                                </b>
                                                                                                                :
                                                                                                                $
                                                                                                                {
                                                                                                                    appData
                                                                                                                        .prices[2]
                                                                                                                        .pivot
                                                                                                                        .dollars
                                                                                                                }
                                                                                                            </p>
                                                                                                        </div>
                                                                                                    </div>
                                                                                                    <div className="row">
                                                                                                        <div className="col-md-6 col-sm-6 col-xs-6">
                                                                                                            <p
                                                                                                                className={
                                                                                                                    "form-control-static "
                                                                                                                }
                                                                                                            >
                                                                                                                <b>
                                                                                                                    Non-tiered
                                                                                                                    (Per
                                                                                                                    Item)
                                                                                                                </b>
                                                                                                                :{" "}
                                                                                                                {
                                                                                                                    appData
                                                                                                                        .prices[3]
                                                                                                                        .pivot
                                                                                                                        .percent
                                                                                                                }
                                                                                                                %
                                                                                                            </p>
                                                                                                        </div>
                                                                                                        <div className="col-md-6 col-sm-6 col-xs-6">
                                                                                                            <p
                                                                                                                className={
                                                                                                                    "form-control-static "
                                                                                                                }
                                                                                                            >
                                                                                                                <b>
                                                                                                                    Non-tiered
                                                                                                                    (Per
                                                                                                                    Item)
                                                                                                                </b>
                                                                                                                :
                                                                                                                $
                                                                                                                {
                                                                                                                    appData
                                                                                                                        .prices[3]
                                                                                                                        .pivot
                                                                                                                        .dollars
                                                                                                                }
                                                                                                            </p>
                                                                                                        </div>
                                                                                                    </div>
                                                                                                    <h4 className="text-center">
                                                                                                        Pin
                                                                                                        Debit
                                                                                                    </h4>
                                                                                                    <div className="row">
                                                                                                        <div className="col-md-6 col-sm-6 col-xs-6">
                                                                                                            <p
                                                                                                                className={
                                                                                                                    "form-control-static "
                                                                                                                }
                                                                                                            >
                                                                                                                <b>
                                                                                                                    Pin
                                                                                                                    Debit
                                                                                                                    :{" "}
                                                                                                                </b>
                                                                                                                {
                                                                                                                    appData.debit_pin
                                                                                                                }
                                                                                                            </p>
                                                                                                        </div>
                                                                                                    </div>
                                                                                                    {appData.debit_pin ==
                                                                                                        "yes" ? (
                                                                                                        <div className="row">
                                                                                                            <div className="col-md-6 col-sm-6 col-xs-6">
                                                                                                                <p
                                                                                                                    className={
                                                                                                                        "form-control-static "
                                                                                                                    }
                                                                                                                >
                                                                                                                    <b>
                                                                                                                        PIN
                                                                                                                        Debit
                                                                                                                    </b>
                                                                                                                    :{" "}
                                                                                                                    {
                                                                                                                        appData
                                                                                                                            .prices[4]
                                                                                                                            .pivot
                                                                                                                            .percent
                                                                                                                    }
                                                                                                                    %
                                                                                                                </p>
                                                                                                            </div>
                                                                                                            <div className="col-md-6 col-sm-6 col-xs-6">
                                                                                                                <p
                                                                                                                    className={
                                                                                                                        "form-control-static "
                                                                                                                    }
                                                                                                                >
                                                                                                                    <b>
                                                                                                                        PIN
                                                                                                                        Debit
                                                                                                                    </b>
                                                                                                                    :
                                                                                                                    $
                                                                                                                    {
                                                                                                                        appData
                                                                                                                            .prices[4]
                                                                                                                            .pivot
                                                                                                                            .dollars
                                                                                                                    }
                                                                                                                </p>
                                                                                                            </div>
                                                                                                        </div>
                                                                                                    ) : null}
                                                                                                    <div className="row">
                                                                                                        <div className="col-md-6 col-sm-6 col-xs-6">
                                                                                                            <p
                                                                                                                className={
                                                                                                                    "form-control-static "
                                                                                                                }
                                                                                                            >
                                                                                                                <b>
                                                                                                                    Signature
                                                                                                                    Debit
                                                                                                                </b>
                                                                                                                :{" "}
                                                                                                                {
                                                                                                                    appData
                                                                                                                        .prices[5]
                                                                                                                        .pivot
                                                                                                                        .percent
                                                                                                                }
                                                                                                                %
                                                                                                            </p>
                                                                                                        </div>
                                                                                                        <div className="col-md-6 col-sm-6 col-xs-6">
                                                                                                            <p
                                                                                                                className={
                                                                                                                    "form-control-static "
                                                                                                                }
                                                                                                            >
                                                                                                                <b>
                                                                                                                    Signature
                                                                                                                    Debit
                                                                                                                </b>
                                                                                                                :
                                                                                                                $
                                                                                                                {
                                                                                                                    appData
                                                                                                                        .prices[5]
                                                                                                                        .pivot
                                                                                                                        .dollars
                                                                                                                }
                                                                                                            </p>
                                                                                                        </div>
                                                                                                    </div>
                                                                                                    <h4 className="text-center">
                                                                                                        General
                                                                                                        fees
                                                                                                    </h4>
                                                                                                    <div>
                                                                                                        <div className="row">
                                                                                                            <div className="col-md-6 col-sm-6 col-xs-6">
                                                                                                                <p
                                                                                                                    className={
                                                                                                                        "form-control-static "
                                                                                                                    }
                                                                                                                >
                                                                                                                    <b>
                                                                                                                        Service
                                                                                                                        (Monthly)
                                                                                                                    </b>
                                                                                                                    :
                                                                                                                    $
                                                                                                                    {
                                                                                                                        appData
                                                                                                                            .prices[16]
                                                                                                                            .pivot
                                                                                                                            .dollars
                                                                                                                    }
                                                                                                                </p>
                                                                                                            </div>
                                                                                                            <div className="col-md-6 col-sm-6 col-xs-6">
                                                                                                                <p
                                                                                                                    className={
                                                                                                                        "form-control-static "
                                                                                                                    }
                                                                                                                >
                                                                                                                    <b>
                                                                                                                        Authorization
                                                                                                                        (Per
                                                                                                                        Item)
                                                                                                                    </b>
                                                                                                                    :
                                                                                                                    $
                                                                                                                    {
                                                                                                                        appData
                                                                                                                            .prices[10]
                                                                                                                            .pivot
                                                                                                                            .dollars
                                                                                                                    }
                                                                                                                </p>
                                                                                                            </div>
                                                                                                        </div>
                                                                                                        <div className="row">
                                                                                                            <div className="col-md-6 col-sm-6 col-xs-6">
                                                                                                                <p
                                                                                                                    className={
                                                                                                                        "form-control-static "
                                                                                                                    }
                                                                                                                >
                                                                                                                    <b>
                                                                                                                        Batch
                                                                                                                        Header
                                                                                                                        (Per
                                                                                                                        Batch)
                                                                                                                    </b>
                                                                                                                    :
                                                                                                                    $
                                                                                                                    {
                                                                                                                        appData
                                                                                                                            .prices[13]
                                                                                                                            .pivot
                                                                                                                            .dollars
                                                                                                                    }
                                                                                                                </p>
                                                                                                            </div>
                                                                                                            <div className="col-md-6 col-sm-6 col-xs-6">
                                                                                                                <p
                                                                                                                    className={
                                                                                                                        "form-control-static "
                                                                                                                    }
                                                                                                                >
                                                                                                                    <b>
                                                                                                                        Voice
                                                                                                                        Authorization
                                                                                                                        (Per
                                                                                                                        Item)
                                                                                                                    </b>
                                                                                                                    :
                                                                                                                    $
                                                                                                                    {
                                                                                                                        appData
                                                                                                                            .prices[11]
                                                                                                                            .pivot
                                                                                                                            .dollars
                                                                                                                    }
                                                                                                                </p>
                                                                                                            </div>
                                                                                                        </div>
                                                                                                        <div className="row">
                                                                                                            <div className="col-md-6 col-sm-6 col-xs-6">
                                                                                                                <p
                                                                                                                    className={
                                                                                                                        "form-control-static "
                                                                                                                    }
                                                                                                                >
                                                                                                                    <b>
                                                                                                                        Chargeback
                                                                                                                        (Per
                                                                                                                        Item)
                                                                                                                    </b>
                                                                                                                    :
                                                                                                                    $
                                                                                                                    {
                                                                                                                        appData
                                                                                                                            .prices[19]
                                                                                                                            .pivot
                                                                                                                            .dollars
                                                                                                                    }
                                                                                                                </p>
                                                                                                            </div>
                                                                                                            <div className="col-md-6 col-sm-6 col-xs-6">
                                                                                                                <p
                                                                                                                    className={
                                                                                                                        "form-control-static "
                                                                                                                    }
                                                                                                                >
                                                                                                                    <b>
                                                                                                                        Retrieval
                                                                                                                        (Per
                                                                                                                        Item)
                                                                                                                    </b>
                                                                                                                    :
                                                                                                                    $
                                                                                                                    {
                                                                                                                        appData
                                                                                                                            .prices[20]
                                                                                                                            .pivot
                                                                                                                            .dollars
                                                                                                                    }
                                                                                                                </p>
                                                                                                            </div>
                                                                                                        </div>
                                                                                                        <div className="row">
                                                                                                            <div className="col-md-6 col-sm-6 col-xs-6">
                                                                                                                <p
                                                                                                                    className={
                                                                                                                        "form-control-static "
                                                                                                                    }
                                                                                                                >
                                                                                                                    <b>
                                                                                                                        NSF/ACH
                                                                                                                        Reject
                                                                                                                        (Per
                                                                                                                        Item)
                                                                                                                    </b>
                                                                                                                    :
                                                                                                                    $
                                                                                                                    {
                                                                                                                        appData
                                                                                                                            .prices[21]
                                                                                                                            .pivot
                                                                                                                            .dollars
                                                                                                                    }
                                                                                                                </p>
                                                                                                            </div>
                                                                                                            <div className="col-md-6 col-sm-6 col-xs-6">
                                                                                                                <p
                                                                                                                    className={
                                                                                                                        "form-control-static "
                                                                                                                    }
                                                                                                                >
                                                                                                                    <b>
                                                                                                                        Monthly
                                                                                                                        Minimum
                                                                                                                        (minimum
                                                                                                                        discount)
                                                                                                                    </b>

                                                                                                                    :
                                                                                                                    $
                                                                                                                    {
                                                                                                                        appData
                                                                                                                            .prices[17]
                                                                                                                            .pivot
                                                                                                                            .dollars
                                                                                                                    }
                                                                                                                </p>
                                                                                                            </div>
                                                                                                        </div>
                                                                                                        <div className="row">
                                                                                                            <div className="col-md-6 col-sm-6 col-xs-6">
                                                                                                                <p
                                                                                                                    className={
                                                                                                                        "form-control-static "
                                                                                                                    }
                                                                                                                >
                                                                                                                    <b>
                                                                                                                        Annual
                                                                                                                        Fee
                                                                                                                    </b>
                                                                                                                    :
                                                                                                                    $
                                                                                                                    {
                                                                                                                        appData
                                                                                                                            .prices[24]
                                                                                                                            .pivot
                                                                                                                            .dollars
                                                                                                                    }
                                                                                                                </p>
                                                                                                            </div>
                                                                                                            <div className="col-md-6 col-sm-6 col-xs-6">
                                                                                                                <p
                                                                                                                    className={
                                                                                                                        "form-control-static "
                                                                                                                    }
                                                                                                                >
                                                                                                                    <b>
                                                                                                                        {" "}
                                                                                                                        Early
                                                                                                                        closure
                                                                                                                        (ETF)
                                                                                                                    </b>
                                                                                                                    :
                                                                                                                    $
                                                                                                                    {
                                                                                                                        appData
                                                                                                                            .prices[26]
                                                                                                                            .pivot
                                                                                                                            .dollars
                                                                                                                    }
                                                                                                                </p>
                                                                                                            </div>
                                                                                                        </div>
                                                                                                        <div className="row">
                                                                                                            <div className="col-md-6 col-sm-6 col-xs-6">
                                                                                                                <p
                                                                                                                    className={
                                                                                                                        "form-control-static "
                                                                                                                    }
                                                                                                                >
                                                                                                                    <b>
                                                                                                                        AVS
                                                                                                                        Fee
                                                                                                                    </b>
                                                                                                                    :
                                                                                                                    $
                                                                                                                    {
                                                                                                                        appData
                                                                                                                            .prices[12]
                                                                                                                            .pivot
                                                                                                                            .dollars
                                                                                                                    }
                                                                                                                </p>
                                                                                                            </div>
                                                                                                        </div>
                                                                                                    </div>
                                                                                                    <h4 className="text-center">
                                                                                                        EBT
                                                                                                        Fees
                                                                                                    </h4>
                                                                                                    <div className="row">
                                                                                                        <div className="col-md-6 col-sm-6 col-xs-6">
                                                                                                            <p
                                                                                                                className={
                                                                                                                    "form-control-static "
                                                                                                                }
                                                                                                            >
                                                                                                                <b>
                                                                                                                    Does
                                                                                                                    Merchant
                                                                                                                    Accept
                                                                                                                    EBT
                                                                                                                    :{" "}
                                                                                                                </b>
                                                                                                                {
                                                                                                                    appData.ebt_fees
                                                                                                                }
                                                                                                            </p>
                                                                                                        </div>
                                                                                                    </div>
                                                                                                    {appData.ebt_fees ===
                                                                                                        "yes" && (
                                                                                                            <div>
                                                                                                                <div className="row">
                                                                                                                    <div className="col-md-6 col-sm-6 col-xs-6">
                                                                                                                        <p
                                                                                                                            className={
                                                                                                                                "form-control-static "
                                                                                                                            }
                                                                                                                        >
                                                                                                                            <b>
                                                                                                                                EBT
                                                                                                                                Transactions
                                                                                                                                (Per
                                                                                                                                Item)
                                                                                                                            </b>
                                                                                                                            :
                                                                                                                            $
                                                                                                                            {
                                                                                                                                appData
                                                                                                                                    .prices[28]
                                                                                                                                    .pivot
                                                                                                                                    .dollars
                                                                                                                            }
                                                                                                                        </p>
                                                                                                                    </div>
                                                                                                                    <div className="col-md-6 col-sm-6 col-xs-6">
                                                                                                                        <p
                                                                                                                            className={
                                                                                                                                "form-control-static "
                                                                                                                            }
                                                                                                                        >
                                                                                                                            <b>
                                                                                                                                {" "}
                                                                                                                                EBT
                                                                                                                                Transaction
                                                                                                                                (Monthly)
                                                                                                                            </b>
                                                                                                                            :
                                                                                                                            $
                                                                                                                            {
                                                                                                                                appData
                                                                                                                                    .prices[29]
                                                                                                                                    .pivot
                                                                                                                                    .dollars
                                                                                                                            }
                                                                                                                        </p>
                                                                                                                    </div>
                                                                                                                </div>
                                                                                                                <div className="row">
                                                                                                                    <div className="col-md-6 col-sm-6 col-xs-6">
                                                                                                                        <p
                                                                                                                            className={
                                                                                                                                "form-control-static "
                                                                                                                            }
                                                                                                                        >
                                                                                                                            <b>
                                                                                                                                EBT
                                                                                                                                Reg
                                                                                                                                Number
                                                                                                                            </b>
                                                                                                                            :
                                                                                                                            $
                                                                                                                            {
                                                                                                                                appData
                                                                                                                                    .prices[30]
                                                                                                                                    .pivot
                                                                                                                                    .dollars
                                                                                                                            }
                                                                                                                        </p>
                                                                                                                    </div>
                                                                                                                </div>
                                                                                                            </div>
                                                                                                        )}
                                                                                                    <h4 className="text-center">
                                                                                                        American
                                                                                                        Express
                                                                                                    </h4>
                                                                                                    <div className="row">
                                                                                                        <div className="col-md-6 col-sm-6 col-xs-6">
                                                                                                            <p
                                                                                                                className={
                                                                                                                    "form-control-static "
                                                                                                                }
                                                                                                            >
                                                                                                                <b>
                                                                                                                    Does
                                                                                                                    Merchant
                                                                                                                    want
                                                                                                                    to
                                                                                                                    accept
                                                                                                                    American
                                                                                                                    Express?&nbsp;
                                                                                                                </b>
                                                                                                                {appData?.apexoptout ==
                                                                                                                    "yes"
                                                                                                                    ? "No"
                                                                                                                    : "Yes"}
                                                                                                            </p>
                                                                                                        </div>
                                                                                                    </div>
                                                                                                </div>
                                                                                                {appData.apexoptout ===
                                                                                                    "no" && (
                                                                                                        <div>
                                                                                                            <div className="row">
                                                                                                                <div className="col-md-6 col-sm-6 col-xs-6">
                                                                                                                    <p
                                                                                                                        className={
                                                                                                                            "form-control-static "
                                                                                                                        }
                                                                                                                    >
                                                                                                                        <b>
                                                                                                                            {
                                                                                                                                "Tier 1 (<$150)"
                                                                                                                            }{" "}
                                                                                                                        </b>
                                                                                                                        :{" "}
                                                                                                                        {
                                                                                                                            appData
                                                                                                                                .prices[31]
                                                                                                                                .pivot
                                                                                                                                .percent
                                                                                                                        }
                                                                                                                        %
                                                                                                                    </p>
                                                                                                                </div>
                                                                                                                <div className="col-md-6 col-sm-6 col-xs-6">
                                                                                                                    <p
                                                                                                                        className={
                                                                                                                            "form-control-static "
                                                                                                                        }
                                                                                                                    >
                                                                                                                        <b>
                                                                                                                            {
                                                                                                                                "Tier 1 (<$150)"
                                                                                                                            }{" "}
                                                                                                                        </b>
                                                                                                                        :
                                                                                                                        $
                                                                                                                        {
                                                                                                                            appData
                                                                                                                                .prices[31]
                                                                                                                                .pivot
                                                                                                                                .dollars
                                                                                                                        }
                                                                                                                    </p>
                                                                                                                </div>
                                                                                                            </div>
                                                                                                            <div className="row">
                                                                                                                <div className="col-md-6 col-sm-6 col-xs-6">
                                                                                                                    <p
                                                                                                                        className={
                                                                                                                            "form-control-static "
                                                                                                                        }
                                                                                                                    >
                                                                                                                        <b>
                                                                                                                            {
                                                                                                                                "Tier 2 ($150 - $3,000)"
                                                                                                                            }{" "}
                                                                                                                        </b>
                                                                                                                        :{" "}
                                                                                                                        {
                                                                                                                            appData
                                                                                                                                .prices[32]
                                                                                                                                .pivot
                                                                                                                                .percent
                                                                                                                        }
                                                                                                                        %
                                                                                                                    </p>
                                                                                                                </div>
                                                                                                                <div className="col-md-6 col-sm-6 col-xs-6">
                                                                                                                    <p
                                                                                                                        className={
                                                                                                                            "form-control-static "
                                                                                                                        }
                                                                                                                    >
                                                                                                                        <b>
                                                                                                                            {
                                                                                                                                "Tier 2 ($150 - $3,000)"
                                                                                                                            }
                                                                                                                        </b>
                                                                                                                        :
                                                                                                                        $
                                                                                                                        {
                                                                                                                            appData
                                                                                                                                .prices[32]
                                                                                                                                .pivot
                                                                                                                                .dollars
                                                                                                                        }
                                                                                                                    </p>
                                                                                                                </div>
                                                                                                            </div>
                                                                                                            <div className="row">
                                                                                                                <div className="col-md-6 col-sm-6 col-xs-6">
                                                                                                                    <p
                                                                                                                        className={
                                                                                                                            "form-control-static "
                                                                                                                        }
                                                                                                                    >
                                                                                                                        <b>
                                                                                                                            {
                                                                                                                                "Tier 3 (>$3,000)"
                                                                                                                            }
                                                                                                                        </b>
                                                                                                                        :{" "}
                                                                                                                        {
                                                                                                                            appData
                                                                                                                                .prices[33]
                                                                                                                                .pivot
                                                                                                                                .percent
                                                                                                                        }
                                                                                                                        %
                                                                                                                    </p>
                                                                                                                </div>
                                                                                                                <div className="col-md-6 col-sm-6 col-xs-6">
                                                                                                                    <p
                                                                                                                        className={
                                                                                                                            "form-control-static "
                                                                                                                        }
                                                                                                                    >
                                                                                                                        <b>
                                                                                                                            {
                                                                                                                                "Tier 3 (>$3,000)"
                                                                                                                            }
                                                                                                                        </b>
                                                                                                                        :
                                                                                                                        $
                                                                                                                        {
                                                                                                                            appData
                                                                                                                                .prices[33]
                                                                                                                                .pivot
                                                                                                                                .dollars
                                                                                                                        }
                                                                                                                    </p>
                                                                                                                </div>
                                                                                                            </div>
                                                                                                        </div>
                                                                                                    )}
                                                                                            </div>
                                                                                        ) : null}
                                                                                        {appData.qualifiedtype ==
                                                                                            "sccd" ? (
                                                                                            <div>
                                                                                                <div>
                                                                                                    <div className="row">
                                                                                                        <div className="col-md-6 col-sm-6 col-xs-6">
                                                                                                            <p
                                                                                                                className={
                                                                                                                    "form-control-static "
                                                                                                                }
                                                                                                            >
                                                                                                                <b>
                                                                                                                    {
                                                                                                                        "Discount Rate (Per Transaction)"
                                                                                                                    }{" "}
                                                                                                                </b>

                                                                                                                :{" "}
                                                                                                                {
                                                                                                                    appData
                                                                                                                        .prices[34]
                                                                                                                        .pivot
                                                                                                                        .percent
                                                                                                                }
                                                                                                                %
                                                                                                            </p>
                                                                                                        </div>
                                                                                                    </div>
                                                                                                    <h4 className="text-center">
                                                                                                        Pin
                                                                                                        Debit
                                                                                                    </h4>
                                                                                                    <div className="row">
                                                                                                        <div className="col-md-6 col-sm-6 col-xs-6">
                                                                                                            <p
                                                                                                                className={
                                                                                                                    "form-control-static "
                                                                                                                }
                                                                                                            >
                                                                                                                <b>
                                                                                                                    Pin
                                                                                                                    Debit
                                                                                                                    :{" "}
                                                                                                                </b>
                                                                                                                {
                                                                                                                    appData.debit_pin
                                                                                                                }
                                                                                                            </p>
                                                                                                        </div>
                                                                                                    </div>
                                                                                                    {appData.debit_pin ==
                                                                                                        "yes" ? (
                                                                                                        <div className="row">
                                                                                                            <div className="col-md-6 col-sm-6 col-xs-6">
                                                                                                                <p
                                                                                                                    className={
                                                                                                                        "form-control-static "
                                                                                                                    }
                                                                                                                >
                                                                                                                    <b>
                                                                                                                        PIN
                                                                                                                        Debit
                                                                                                                    </b>
                                                                                                                    :{" "}
                                                                                                                    {
                                                                                                                        appData
                                                                                                                            .prices[4]
                                                                                                                            .pivot
                                                                                                                            .percent
                                                                                                                    }
                                                                                                                    %
                                                                                                                </p>
                                                                                                            </div>
                                                                                                            <div className="col-md-6 col-sm-6 col-xs-6">
                                                                                                                <p
                                                                                                                    className={
                                                                                                                        "form-control-static "
                                                                                                                    }
                                                                                                                >
                                                                                                                    <b>
                                                                                                                        PIN
                                                                                                                        Debit
                                                                                                                    </b>
                                                                                                                    :
                                                                                                                    $
                                                                                                                    {
                                                                                                                        appData
                                                                                                                            .prices[4]
                                                                                                                            .pivot
                                                                                                                            .dollars
                                                                                                                    }
                                                                                                                </p>
                                                                                                            </div>
                                                                                                        </div>
                                                                                                    ) : null}
                                                                                                </div>
                                                                                                
                                                                                                <h4 className="text-center">
                                                                                                    General
                                                                                                    fees
                                                                                                </h4>
                                                                                                <div>
                                                                                                    <div className="row">
                                                                                                        <div className="col-md-6 col-sm-6 col-xs-6">
                                                                                                            <p
                                                                                                                className={
                                                                                                                    "form-control-static "
                                                                                                                }
                                                                                                            >
                                                                                                                <b>
                                                                                                                    Service
                                                                                                                    (Monthly)
                                                                                                                </b>
                                                                                                                :
                                                                                                                $
                                                                                                                {
                                                                                                                    appData
                                                                                                                        .prices[16]
                                                                                                                        .pivot
                                                                                                                        .dollars
                                                                                                                }
                                                                                                            </p>
                                                                                                        </div>
                                                                                                        <div className="col-md-6 col-sm-6 col-xs-6">
                                                                                                            <p
                                                                                                                className={
                                                                                                                    "form-control-static "
                                                                                                                }
                                                                                                            >
                                                                                                                <b>
                                                                                                                    Authorization
                                                                                                                    (Per
                                                                                                                    Item)
                                                                                                                </b>
                                                                                                                :
                                                                                                                $
                                                                                                                {
                                                                                                                    appData
                                                                                                                        .prices[10]
                                                                                                                        .pivot
                                                                                                                        .dollars
                                                                                                                }
                                                                                                            </p>
                                                                                                        </div>
                                                                                                    </div>
                                                                                                    <div className="row">
                                                                                                        <div className="col-md-6 col-sm-6 col-xs-6">
                                                                                                            <p
                                                                                                                className={
                                                                                                                    "form-control-static "
                                                                                                                }
                                                                                                            >
                                                                                                                <b>
                                                                                                                    Batch
                                                                                                                    Header
                                                                                                                    (Per
                                                                                                                    Batch)
                                                                                                                </b>
                                                                                                                :
                                                                                                                $
                                                                                                                {
                                                                                                                    appData
                                                                                                                        .prices[13]
                                                                                                                        .pivot
                                                                                                                        .dollars
                                                                                                                }
                                                                                                            </p>
                                                                                                        </div>
                                                                                                        <div className="col-md-6 col-sm-6 col-xs-6">
                                                                                                            <p
                                                                                                                className={
                                                                                                                    "form-control-static "
                                                                                                                }
                                                                                                            >
                                                                                                                <b>
                                                                                                                    Voice
                                                                                                                    Authorization
                                                                                                                    (Per
                                                                                                                    Item)
                                                                                                                </b>
                                                                                                                :
                                                                                                                $
                                                                                                                {
                                                                                                                    appData
                                                                                                                        .prices[11]
                                                                                                                        .pivot
                                                                                                                        .dollars
                                                                                                                }
                                                                                                            </p>
                                                                                                        </div>
                                                                                                    </div>
                                                                                                    <div className="row">
                                                                                                        <div className="col-md-6 col-sm-6 col-xs-6">
                                                                                                            <p
                                                                                                                className={
                                                                                                                    "form-control-static "
                                                                                                                }
                                                                                                            >
                                                                                                                <b>
                                                                                                                    Chargeback
                                                                                                                    (Per
                                                                                                                    Item)
                                                                                                                </b>
                                                                                                                :
                                                                                                                $
                                                                                                                {
                                                                                                                    appData
                                                                                                                        .prices[19]
                                                                                                                        .pivot
                                                                                                                        .dollars
                                                                                                                }
                                                                                                            </p>
                                                                                                        </div>
                                                                                                        <div className="col-md-6 col-sm-6 col-xs-6">
                                                                                                            <p
                                                                                                                className={
                                                                                                                    "form-control-static "
                                                                                                                }
                                                                                                            >
                                                                                                                <b>
                                                                                                                    Retrieval
                                                                                                                    (Per
                                                                                                                    Item)
                                                                                                                </b>
                                                                                                                :
                                                                                                                $
                                                                                                                {
                                                                                                                    appData
                                                                                                                        .prices[20]
                                                                                                                        .pivot
                                                                                                                        .dollars
                                                                                                                }
                                                                                                            </p>
                                                                                                        </div>
                                                                                                    </div>
                                                                                                    <div className="row">
                                                                                                        <div className="col-md-6 col-sm-6 col-xs-6">
                                                                                                            <p
                                                                                                                className={
                                                                                                                    "form-control-static "
                                                                                                                }
                                                                                                            >
                                                                                                                <b>
                                                                                                                    NSF/ACH
                                                                                                                    Reject
                                                                                                                    (Per
                                                                                                                    Item)
                                                                                                                </b>
                                                                                                                :
                                                                                                                $
                                                                                                                {
                                                                                                                    appData
                                                                                                                        .prices[21]
                                                                                                                        .pivot
                                                                                                                        .dollars
                                                                                                                }
                                                                                                            </p>
                                                                                                        </div>
                                                                                                        <div className="col-md-6 col-sm-6 col-xs-6">
                                                                                                            <p
                                                                                                                className={
                                                                                                                    "form-control-static "
                                                                                                                }
                                                                                                            >
                                                                                                                <b>
                                                                                                                    Monthly
                                                                                                                    Minimum
                                                                                                                    (minimum
                                                                                                                    discount)
                                                                                                                </b>
                                                                                                                :
                                                                                                                $
                                                                                                                {
                                                                                                                    appData
                                                                                                                        .prices[17]
                                                                                                                        .pivot
                                                                                                                        .dollars
                                                                                                                }
                                                                                                            </p>
                                                                                                        </div>
                                                                                                    </div>
                                                                                                    <div className="row">
                                                                                                        <div className="col-md-6 col-sm-6 col-xs-6">
                                                                                                            <p
                                                                                                                className={
                                                                                                                    "form-control-static "
                                                                                                                }
                                                                                                            >
                                                                                                                <b>
                                                                                                                    Annual
                                                                                                                    Fee
                                                                                                                </b>
                                                                                                                :
                                                                                                                $
                                                                                                                {
                                                                                                                    appData
                                                                                                                        .prices[24]
                                                                                                                        .pivot
                                                                                                                        .dollars
                                                                                                                }
                                                                                                            </p>
                                                                                                        </div>
                                                                                                        <div className="col-md-6 col-sm-6 col-xs-6">
                                                                                                            <p
                                                                                                                className={
                                                                                                                    "form-control-static "
                                                                                                                }
                                                                                                            >
                                                                                                                <b>
                                                                                                                    {" "}
                                                                                                                    Early
                                                                                                                    closure
                                                                                                                    (ETF)
                                                                                                                </b>
                                                                                                                :
                                                                                                                $
                                                                                                                {
                                                                                                                    appData
                                                                                                                        .prices[26]
                                                                                                                        .pivot
                                                                                                                        .dollars
                                                                                                                }
                                                                                                            </p>
                                                                                                        </div>
                                                                                                    </div>
                                                                                                    <div className="row">
                                                                                                        <div className="col-md-6 col-sm-6 col-xs-6">
                                                                                                            <p
                                                                                                                className={
                                                                                                                    "form-control-static "
                                                                                                                }
                                                                                                            >
                                                                                                                <b>
                                                                                                                    AVS
                                                                                                                    Fee
                                                                                                                </b>
                                                                                                                :
                                                                                                                $
                                                                                                                {
                                                                                                                    appData
                                                                                                                        .prices[12]
                                                                                                                        .pivot
                                                                                                                        .dollars
                                                                                                                }
                                                                                                            </p>
                                                                                                        </div>
                                                                                                    </div>
                                                                                                </div>
                                                                                            </div>
                                                                                        ) : null}
                                                                                    </>
                                                                                )}
                                                                            </div>
                                                                        ) : (
                                                                            <div className="relevent-infos card-profile">
                                                                                <h4 className="text-center">
                                                                                    Pricing
                                                                                    Info
                                                                                    not
                                                                                    Available
                                                                                </h4>
                                                                            </div>
                                                                        )}
                                                                    </div>
                                                                </Card.Body>
                                                            </Accordion.Collapse>
                                                        </Card>
                                                        <Card>
                                                            <Card.Header
                                                                className={
                                                                    accordionNumber ===
                                                                        5
                                                                        ? "opened"
                                                                        : ""
                                                                }
                                                            >
                                                                <Accordion.Toggle
                                                                    as={Button}
                                                                    variant="link"
                                                                    eventKey="5"
                                                                    onClick={() =>
                                                                        this.handleToggleAccordion(
                                                                            5,
                                                                        )
                                                                    }
                                                                >
                                                                    Equipment{" "}
                                                                    <i
                                                                        className={
                                                                            accordionNumber ===
                                                                                5
                                                                                ? "fa fa-chevron-up"
                                                                                : "fa fa-chevron-down"
                                                                        }
                                                                    />
                                                                </Accordion.Toggle>
                                                            </Card.Header>
                                                            <Accordion.Collapse eventKey="5">
                                                                <Card.Body>
                                                                    <span class="separator"></span>
                                                                    {appData.billing ? (
                                                                        <EmsBootEquipments
                                                                            boot_equipments={
                                                                                appData?.ems_boot_equipments
                                                                            }
                                                                            equipment_json={
                                                                                appData
                                                                                    ?.billing
                                                                                    ?.equipment_json
                                                                            }
                                                                        />
                                                                    ) : (
                                                                    <div className="relevent-info-box">
                                                                            {appData.powerappequipment &&
                                                                                appData.powerappequipment !=
                                                                                null ? (
                                                                            <div className="relevent-infos card-profile">
                                                                                <h4 className="text-center">
                                                                                        Equipment
                                                                                        Info
                                                                                </h4>
                                                                                <div className="row">
                                                                                    <div className="col-md-6 col-sm-6 col-xs-6">
                                                                                            <p>
                                                                                                <b>
                                                                                                    Selected
                                                                                                    Equipment
                                                                                                    Type
                                                                                                </b>
                                                                                                :{" "}
                                                                                                {appData
                                                                                                    .powerappequipment
                                                                                                    .equipment_option ==
                                                                                                    "terminal"
                                                                                                    ? "Terminal"
                                                                                                    : "Gateway"}
                                                                                            </p>
                                                                                        </div>
                                                                                        <div className="col-md-6 col-sm-6 col-xs-6">
                                                                                            <p>
                                                                                                <b>
                                                                                                    Equipment
                                                                                                    paid
                                                                                                    for
                                                                                                    by
                                                                                                </b>
                                                                                                :
                                                                                                {appData
                                                                                                    .powerappequipment
                                                                                                    .gateway_option &&
                                                                                                    appData
                                                                                                        .powerappequipment
                                                                                                        .gateway_option ==
                                                                                                    "paymentcloud_provided" && (
                                                                                                        <>
                                                                                                            Merchant
                                                                                                        </>
                                                                                                    )}
                                                                                                {appData
                                                                                                    .powerappequipment
                                                                                                    .gateway_option &&
                                                                                                    appData
                                                                                                        .powerappequipment
                                                                                                        .gateway_option !=
                                                                                                    "paymentcloud_provided" && (
                                                                                                        <>
                                                                                                            Agent
                                                                                                        </>
                                                                                                    )}
                                                                                            </p>
                                                                                        </div>
                                                                                        {appData
                                                                                            .powerappequipment
                                                                                            .equipment_option ==
                                                                                            "terminal" && (
                                                                                                <div className="col-md-6 col-sm-6 col-xs-6">
                                                                                                    <p>
                                                                                                        <b>
                                                                                                            Terminal
                                                                                                            Type
                                                                                                        </b>
                                                                                                        :
                                                                                                        {appData
                                                                                                            .powerappequipment
                                                                                                            .equipment_type && (
                                                                                                                <>
                                                                                                                    {
                                                                                                                        appData
                                                                                                                            .powerappequipment
                                                                                                                            .equipment_type
                                                                                                                    }
                                                                                                                </>
                                                                                                            )}
                                                                                                        {(appData
                                                                                                            .powerappequipment
                                                                                                            .equipment_type ==
                                                                                                            null ||
                                                                                                            appData
                                                                                                                .powerappequipment
                                                                                                                .equipment_type ==
                                                                                                            "") && (
                                                                                                                <>
                                                                                                                    {this.getTerminal(
                                                                                                                        appData
                                                                                                                            .powerappequipment
                                                                                                                            .terminal_name,
                                                                                                                    )}
                                                                                                                </>
                                                                                                            )}
                                                                                                    </p>
                                                                                                </div>
                                                                                            )}
                                                                                        {appData
                                                                                            .powerappequipment
                                                                                            .equipment_option ==
                                                                                            "gateway" && (
                                                                                                <div className="col-md-6 col-sm-6 col-xs-6">
                                                                                                    {appData
                                                                                                        .powerappequipment
                                                                                                        .equipment_type && (
                                                                                                            <p>
                                                                                                                <b>
                                                                                                                    Gateway
                                                                                                                    Type
                                                                                                                </b>
                                                                                                                :{" "}
                                                                                                                {
                                                                                                                    appData
                                                                                                                        .powerappequipment
                                                                                                                        .equipment_type
                                                                                                                }
                                                                                                            </p>
                                                                                                        )}
                                                                                                    {(appData
                                                                                                        .powerappequipment
                                                                                                        .equipment_type ==
                                                                                                        null ||
                                                                                                        appData
                                                                                                            .powerappequipment
                                                                                                            .equipment_type ==
                                                                                                        "") && (
                                                                                                            <p>
                                                                                                                <b>
                                                                                                                    Gateway
                                                                                                                    Type
                                                                                                                </b>
                                                                                                                :{" "}
                                                                                                                {this.getGateway(
                                                                                                                    appData
                                                                                                                        .powerappequipment
                                                                                                                        .gateway_name,
                                                                                                                )}
                                                                                                            </p>
                                                                                                        )}
                                                                                                </div>
                                                                                            )}
                                                                                        {appData
                                                                                            .powerappequipment
                                                                                            .special_instruction && (
                                                                                                <div className="col-md-6 col-sm-6 col-xs-6">
                                                                                                    <p>
                                                                                                        <b>
                                                                                                            Special
                                                                                                            Instruction
                                                                                                        </b>
                                                                                                        :{" "}
                                                                                                        {appData
                                                                                                            .powerappequipment
                                                                                                            .special_instruction || (
                                                                                                                <>
                                                                                                                    &mdash;
                                                                                                                </>
                                                                                                            )}
                                                                                                    </p>
                                                                                                </div>
                                                                                            )}

                                                                                        {appData
                                                                                            .powerappequipment
                                                                                            .equipment_option ==
                                                                                            "terminal" && (
                                                                                                <div className="col-md-6 col-sm-6 col-xs-6">
                                                                                                    <p>
                                                                                                        <b>
                                                                                                            Shipping
                                                                                                            Address
                                                                                                        </b>
                                                                                                        :{" "}
                                                                                                        {
                                                                                                            appData
                                                                                                                .powerappequipment
                                                                                                                .merchant_dba_address
                                                                                                        }
                                                                                                    </p>
                                                                                                </div>
                                                                                            )}

                                                                                        <div className="col-md-6 col-sm-6 col-xs-6">
                                                                                            {appData
                                                                                                .powerappequipment
                                                                                                .gateway_id && (
                                                                                                    <p>
                                                                                                        <b>
                                                                                                            Gateway
                                                                                                            Id
                                                                                                        </b>
                                                                                                        :{" "}
                                                                                                        {appData
                                                                                                            .powerappequipment
                                                                                                            .gateway_id || (
                                                                                                                <>
                                                                                                                    &mdash;
                                                                                                                </>
                                                                                                            )}{" "}
                                                                                                    </p>
                                                                                                )}
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                            ) : (
                                                                                <div className="relevent-infos card-profile">
                                                                                    <h4 className="text-center">
                                                                                        Equipment
                                                                                        Info
                                                                                        not
                                                                                        Available
                                                                                    </h4>
                                                                                </div>
                                                                            )}
                                                                        </div>
                                                                    )}
                                                                </Card.Body>
                                                            </Accordion.Collapse>
                                                        </Card>
                                                        <Card>
                                                            <Card.Header
                                                                className={accordionNumber === 6 ? "opened" : ""}
                                                            >
                                                                <Accordion.Toggle
                                                                    as={Button}
                                                                    variant="link"
                                                                    eventKey="6"
                                                                    onClick={() => this.handleToggleAccordion(6)}
                                                                >
                                                                    Var Only{" "}
                                                                    <i
                                                                        className={
                                                                            accordionNumber === 6
                                                                                ? "fa fa-chevron-up"
                                                                                : "fa fa-chevron-down"
                                                                        }
                                                                    />
                                                                </Accordion.Toggle>
                                                            </Card.Header>
                                                            <Accordion.Collapse eventKey="6">
                                                                <Card.Body>
                                                                    <div className="relevent-info-box">
                                                                        {appData.var_only ? (
                                                                            <div className="relevent-infos card-profile">
                                                                                <h4 className="text-center">
                                                                                    Var Only Information
                                                                                </h4>
                                                                                <div className="row">
                                                                                    <div className="col-md-6 col-sm-6 col-xs-6">
                                                                                        <p>
                                                                                            <b>Type</b>:{" "}
                                                                                            {appData?.var_only?.equipment_type}
                                                                                        </p>
                                                                                    </div>
                                                                                    {appData.var_only.equipment_type === "terminal" ? (
                                                                                        <>
                                                                                            <div className="col-md-6 col-sm-6 col-xs-6">
                                                                                                <p>
                                                                                                    <b>Model</b>:{" "}
                                                                                                    {appData?.var_only?.terminal_model}
                                                                                                </p>
                                                                                            </div>
                                                                                            <div className="col-md-6 col-sm-6 col-xs-6">
                                                                                                <p>
                                                                                                    <b>Serial</b>:{" "}
                                                                                                    {appData?.var_only?.terminal_serial}
                                                                                                </p>
                                                                                            </div>
                                                                                        </>
                                                                                    ) : (
                                                                                        <div className="col-md-6 col-sm-6 col-xs-6">
                                                                                            <p>
                                                                                                <b>Gateway</b>:{" "}
                                                                                                {appData?.var_only?.gateway_name}
                                                                                            </p>
                                                                                        </div>
                                                                                    )}
                                                                                </div>
                                                                            </div>
                                                                        ) : (
                                                                            <div className="relevent-infos card-profile">
                                                                                <h4 className="text-center">
                                                                                    Var Only Information not Available
                                                                                </h4>
                                                                            </div>
                                                                        )}
                                                                    </div>
                                                                </Card.Body>
                                                            </Accordion.Collapse>
                                                        </Card>
                                                        {pci_admin ? (
                                                            <Card>
                                                                <Card.Header
                                                                    className={
                                                                        accordionNumber ===
                                                                            7
                                                                            ? "opened"
                                                                            : ""
                                                                    }
                                                                >
                                                                    <Accordion.Toggle
                                                                        as={
                                                                            Button
                                                                        }
                                                                        variant="link"
                                                                        eventKey="7"
                                                                        onClick={() =>
                                                                            this.handleToggleAccordion(
                                                                                7,
                                                                            )
                                                                        }
                                                                    >
                                                                        Var
                                                                        Sheet{" "}
                                                                        <i
                                                                            className={
                                                                                accordionNumber ===
                                                                                    7
                                                                                    ? "fa fa-chevron-up"
                                                                                    : "fa fa-chevron-down"
                                                                            }
                                                                        />
                                                                    </Accordion.Toggle>
                                                                </Card.Header>
                                                                <Accordion.Collapse eventKey="7">
                                                                    <Card.Body>
                                                                        <span className="separator" />
                                                                        <div className="relevent-info-box">
                                                                            <div className="relevent-infos">
                                                                                <div className="row">
                                                                                    <div className="col-md-6 col-sm-12 col-xs-12">
                                                                                        <div className="form-group">
                                                                                            <label>
                                                                                                EMS
                                                                                                ID
                                                                                            </label>
                                                                                            <p className="form-control-static">
                                                                                                {appData
                                                                                                    ?.power_app_submission
                                                                                                    ?.var_sheet
                                                                                                    ?.ems_mid || (
                                                                                                        <>
                                                                                                            &mdash;
                                                                                                        </>
                                                                                                    )}
                                                                                            </p>
                                                                                        </div>
                                                                                        <div className="form-group">
                                                                                            <label>
                                                                                                Model
                                                                                            </label>
                                                                                            <p className="form-control-static">
                                                                                                {appData
                                                                                                    ?.power_app_submission
                                                                                                    ?.var_sheet
                                                                                                    ?.model || (
                                                                                                        <>
                                                                                                            &mdash;
                                                                                                        </>
                                                                                                    )}
                                                                                            </p>
                                                                                        </div>
                                                                                        <div className="form-group">
                                                                                            <label>
                                                                                                Build
                                                                                                Notes
                                                                                            </label>
                                                                                            <p className="form-control-static">
                                                                                                {appData
                                                                                                    ?.power_app_submission
                                                                                                    ?.var_sheet
                                                                                                    ?.build_notes || (
                                                                                                        <>
                                                                                                            &mdash;
                                                                                                        </>
                                                                                                    )}
                                                                                            </p>
                                                                                        </div>
                                                                                        <div className="form-group">
                                                                                            <label>
                                                                                                Office
                                                                                            </label>
                                                                                            <p className="form-control-static">
                                                                                                {appData
                                                                                                    ?.power_app_submission
                                                                                                    ?.var_sheet
                                                                                                    ?.office || (
                                                                                                        <>
                                                                                                            &mdash;
                                                                                                        </>
                                                                                                    )}
                                                                                            </p>
                                                                                        </div>
                                                                                        <div className="form-group">
                                                                                            <label>
                                                                                                Rep
                                                                                                Code
                                                                                            </label>
                                                                                            <p className="form-control-static">
                                                                                                {appData
                                                                                                    ?.power_app_submission
                                                                                                    ?.var_sheet
                                                                                                    ?.rep_code || (
                                                                                                        <>
                                                                                                            &mdash;
                                                                                                        </>
                                                                                                    )}
                                                                                            </p>
                                                                                        </div>
                                                                                        <div className="form-group">
                                                                                            <label>
                                                                                                Branch
                                                                                            </label>
                                                                                            <p className="form-control-static">
                                                                                                {appData
                                                                                                    ?.power_app_submission
                                                                                                    ?.var_sheet
                                                                                                    ?.branch || (
                                                                                                        <>
                                                                                                            &mdash;
                                                                                                        </>
                                                                                                    )}
                                                                                            </p>
                                                                                        </div>
                                                                                        <div className="form-group">
                                                                                            <label>
                                                                                                Merchant
                                                                                            </label>
                                                                                            <p className="form-control-static">
                                                                                                {appData
                                                                                                    ?.power_app_submission
                                                                                                    ?.var_sheet
                                                                                                    ?.merchant || (
                                                                                                        <>
                                                                                                            &mdash;
                                                                                                        </>
                                                                                                    )}
                                                                                            </p>
                                                                                        </div>
                                                                                        <div className="form-group">
                                                                                            <label>
                                                                                                V#
                                                                                            </label>
                                                                                            <p className="form-control-static">
                                                                                                {
                                                                                                    appData
                                                                                                        ?.power_app_submission
                                                                                                        ?.var_sheet
                                                                                                        ?.v_number
                                                                                                }
                                                                                            </p>
                                                                                        </div>
                                                                                        <div className="form-group">
                                                                                            <label>
                                                                                                TPN
                                                                                            </label>
                                                                                            <p className="form-control-static">
                                                                                                {
                                                                                                    appData
                                                                                                        ?.power_app_submission
                                                                                                        ?.var_sheet
                                                                                                        ?.tpn
                                                                                                }
                                                                                            </p>
                                                                                        </div>
                                                                                        <div className="form-group">
                                                                                            <label>
                                                                                                Amex
                                                                                            </label>
                                                                                            <p className="form-control-static">
                                                                                                {
                                                                                                    appData
                                                                                                        ?.power_app_submission
                                                                                                        ?.var_sheet
                                                                                                        ?.amex
                                                                                                }
                                                                                            </p>
                                                                                        </div>
                                                                                        <div className="form-group">
                                                                                            <label>
                                                                                                Discover
                                                                                            </label>
                                                                                            <p className="form-control-static">
                                                                                                {appData
                                                                                                    ?.power_app_submission
                                                                                                    ?.var_sheet
                                                                                                    ?.discover || (
                                                                                                        <>
                                                                                                            &mdash;
                                                                                                        </>
                                                                                                    )}
                                                                                            </p>
                                                                                        </div>
                                                                                        <div className="form-group">
                                                                                            <label>
                                                                                                Platform
                                                                                                (Host)
                                                                                            </label>
                                                                                            <p className="form-control-static">
                                                                                                {appData
                                                                                                    ?.power_app_submission
                                                                                                    ?.var_sheet
                                                                                                    ?.platform_host || (
                                                                                                        <>
                                                                                                            &mdash;
                                                                                                        </>
                                                                                                    )}
                                                                                            </p>
                                                                                        </div>

                                                                                        <div className="form-group">
                                                                                            <label>
                                                                                                BIN#
                                                                                            </label>
                                                                                            <p className="form-control-static">
                                                                                                {appData
                                                                                                    ?.power_app_submission
                                                                                                    ?.var_sheet
                                                                                                    ?.bin || (
                                                                                                        <>
                                                                                                            &mdash;
                                                                                                        </>
                                                                                                    )}
                                                                                            </p>
                                                                                        </div>
                                                                                        <div className="form-group">
                                                                                            <label>
                                                                                                Agent
                                                                                            </label>
                                                                                            <p className="form-control-static">
                                                                                                {appData
                                                                                                    ?.power_app_submission
                                                                                                    ?.var_sheet
                                                                                                    ?.agent || (
                                                                                                        <>
                                                                                                            &mdash;
                                                                                                        </>
                                                                                                    )}
                                                                                            </p>
                                                                                        </div>
                                                                                        <div className="form-group">
                                                                                            <label>
                                                                                                Chain
                                                                                            </label>
                                                                                            <p className="form-control-static">
                                                                                                {appData
                                                                                                    ?.power_app_submission
                                                                                                    ?.var_sheet
                                                                                                    ?.chain || (
                                                                                                        <>
                                                                                                            &mdash;
                                                                                                        </>
                                                                                                    )}
                                                                                            </p>
                                                                                        </div>
                                                                                        <div className="form-group">
                                                                                            <label>
                                                                                                Store
                                                                                            </label>
                                                                                            <p className="form-control-static">
                                                                                                {appData
                                                                                                    ?.power_app_submission
                                                                                                    ?.var_sheet
                                                                                                    ?.store || (
                                                                                                        <>
                                                                                                            &mdash;
                                                                                                        </>
                                                                                                    )}
                                                                                            </p>
                                                                                        </div>
                                                                                        <div className="form-group">
                                                                                            <label>
                                                                                                Country
                                                                                                Code
                                                                                            </label>
                                                                                            <p className="form-control-static">
                                                                                                {appData
                                                                                                    ?.power_app_submission
                                                                                                    ?.var_sheet
                                                                                                    ?.country_code || (
                                                                                                        <>
                                                                                                            &mdash;
                                                                                                        </>
                                                                                                    )}
                                                                                            </p>
                                                                                        </div>
                                                                                    </div>
                                                                                    <div className="col-md-6 col-sm-12 col-xs-12">
                                                                                        <div className="form-group">
                                                                                            <label>
                                                                                                Terminal
                                                                                            </label>
                                                                                            <p className="form-control-static">
                                                                                                {
                                                                                                    appData
                                                                                                        ?.power_app_submission
                                                                                                        ?.var_sheet
                                                                                                        ?.terminal
                                                                                                }
                                                                                            </p>
                                                                                        </div>
                                                                                        <div className="form-group">
                                                                                            <label>
                                                                                                Currency
                                                                                                Code
                                                                                            </label>
                                                                                            <p className="form-control-static">
                                                                                                {
                                                                                                    appData
                                                                                                        ?.power_app_submission
                                                                                                        ?.var_sheet
                                                                                                        ?.currency_code
                                                                                                }
                                                                                            </p>
                                                                                        </div>
                                                                                        <div className="form-group">
                                                                                            <label>
                                                                                                SIC
                                                                                                Code
                                                                                            </label>
                                                                                            <p className="form-control-static">
                                                                                                {appData
                                                                                                    ?.power_app_submission
                                                                                                    ?.var_sheet
                                                                                                    ?.sic_code || (
                                                                                                        <>
                                                                                                            &mdash;
                                                                                                        </>
                                                                                                    )}
                                                                                            </p>
                                                                                        </div>
                                                                                        <div className="form-group">
                                                                                            <label>
                                                                                                Time
                                                                                                Zone
                                                                                            </label>
                                                                                            <p className="form-control-static">
                                                                                                {appData
                                                                                                    ?.power_app_submission
                                                                                                    ?.var_sheet
                                                                                                    ?.time_zone || (
                                                                                                        <>
                                                                                                            &mdash;
                                                                                                        </>
                                                                                                    )}
                                                                                            </p>
                                                                                        </div>

                                                                                        <div className="form-group">
                                                                                            <label>
                                                                                                Location#
                                                                                            </label>
                                                                                            <p className="form-control-static">
                                                                                                {appData
                                                                                                    ?.power_app_submission
                                                                                                    ?.var_sheet
                                                                                                    ?.location || (
                                                                                                        <>
                                                                                                            &mdash;
                                                                                                        </>
                                                                                                    )}
                                                                                            </p>
                                                                                        </div>
                                                                                        <div className="form-group">
                                                                                            <label>
                                                                                                Zip
                                                                                                Code
                                                                                            </label>
                                                                                            <p className="form-control-static">
                                                                                                {appData
                                                                                                    ?.power_app_submission
                                                                                                    ?.var_sheet
                                                                                                    ?.zip_code || (
                                                                                                        <>
                                                                                                            &mdash;
                                                                                                        </>
                                                                                                    )}
                                                                                            </p>
                                                                                        </div>
                                                                                        <div className="form-group">
                                                                                            <label>
                                                                                                Authorization/Settlement
                                                                                                URL
                                                                                            </label>
                                                                                            <p className="form-control-static">
                                                                                                {appData
                                                                                                    ?.power_app_submission
                                                                                                    ?.var_sheet
                                                                                                    ?.authorization_settlement_url || (
                                                                                                        <>
                                                                                                            &mdash;
                                                                                                        </>
                                                                                                    )}
                                                                                            </p>
                                                                                        </div>
                                                                                        <div className="form-group">
                                                                                            <label>
                                                                                                Authorization/Settlement
                                                                                                Port
                                                                                                #
                                                                                            </label>
                                                                                            <p className="form-control-static">
                                                                                                {appData
                                                                                                    ?.power_app_submission
                                                                                                    ?.var_sheet
                                                                                                    ?.authorization_settlement_port || (
                                                                                                        <>
                                                                                                            &mdash;
                                                                                                        </>
                                                                                                    )}
                                                                                            </p>
                                                                                        </div>
                                                                                        <div className="form-group">
                                                                                            <label>
                                                                                                Authorization
                                                                                                Phone
                                                                                                #
                                                                                            </label>
                                                                                            <p className="form-control-static">
                                                                                                {appData
                                                                                                    ?.power_app_submission
                                                                                                    ?.var_sheet
                                                                                                    ?.authorization_phone || (
                                                                                                        <>
                                                                                                            &mdash;
                                                                                                        </>
                                                                                                    )}
                                                                                            </p>
                                                                                        </div>
                                                                                        <div className="form-group">
                                                                                            <label>
                                                                                                Settlement
                                                                                                Phone
                                                                                                #
                                                                                            </label>
                                                                                            <p className="form-control-static">
                                                                                                {appData
                                                                                                    ?.power_app_submission
                                                                                                    ?.var_sheet
                                                                                                    ?.settlement_phone || (
                                                                                                        <>
                                                                                                            &mdash;
                                                                                                        </>
                                                                                                    )}
                                                                                            </p>
                                                                                        </div>
                                                                                        <div className="form-group">
                                                                                            <label>
                                                                                                Merchant
                                                                                                Name
                                                                                            </label>
                                                                                            <p className="form-control-static">
                                                                                                {appData
                                                                                                    ?.power_app_submission
                                                                                                    ?.var_sheet
                                                                                                    ?.merchant_name || (
                                                                                                        <>
                                                                                                            &mdash;
                                                                                                        </>
                                                                                                    )}
                                                                                            </p>
                                                                                        </div>
                                                                                        <div className="form-group">
                                                                                            <label>
                                                                                                Address
                                                                                            </label>
                                                                                            <p className="form-control-static">
                                                                                                {appData
                                                                                                    ?.power_app_submission
                                                                                                    ?.var_sheet
                                                                                                    ?.address || (
                                                                                                        <>
                                                                                                            &mdash;
                                                                                                        </>
                                                                                                    )}
                                                                                            </p>
                                                                                        </div>
                                                                                        <div className="form-group">
                                                                                            <label>
                                                                                                City
                                                                                            </label>
                                                                                            <p className="form-control-static">
                                                                                                {appData
                                                                                                    ?.power_app_submission
                                                                                                    ?.var_sheet
                                                                                                    ?.city || (
                                                                                                        <>
                                                                                                            &mdash;
                                                                                                        </>
                                                                                                    )}
                                                                                            </p>
                                                                                        </div>
                                                                                        <div className="form-group">
                                                                                            <label>
                                                                                                State
                                                                                            </label>
                                                                                            <p className="form-control-static">
                                                                                                {appData
                                                                                                    ?.power_app_submission
                                                                                                    ?.var_sheet
                                                                                                    ?.state || (
                                                                                                        <>
                                                                                                            &mdash;
                                                                                                        </>
                                                                                                    )}
                                                                                            </p>
                                                                                        </div>
                                                                                        <div className="form-group">
                                                                                            <label>
                                                                                                Phone
                                                                                            </label>
                                                                                            <p className="form-control-static">
                                                                                                {appData
                                                                                                    ?.power_app_submission
                                                                                                    ?.var_sheet
                                                                                                    ?.phone || (
                                                                                                        <>
                                                                                                            &mdash;
                                                                                                        </>
                                                                                                    )}
                                                                                            </p>
                                                                                        </div>
                                                                                        <div className="form-group">
                                                                                            <label>
                                                                                                Software
                                                                                            </label>
                                                                                            <p className="form-control-static">
                                                                                                {appData
                                                                                                    ?.power_app_submission
                                                                                                    ?.var_sheet
                                                                                                    ?.software || (
                                                                                                        <>
                                                                                                            &mdash;
                                                                                                        </>
                                                                                                    )}
                                                                                            </p>
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </Card.Body>
                                                                </Accordion.Collapse>
                                                            </Card>
                                                        ) : (
                                                            <></>
                                                        )}
                                                    </>
                                                ) : (
                                                    <Card>
                                                        <Card.Header
                                                            className={
                                                                accordionNumber ===
                                                                    0
                                                                    ? "opened"
                                                                    : ""
                                                            }
                                                        >
                                                            <Accordion.Toggle
                                                                as={Button}
                                                                variant="link"
                                                                eventKey="0"
                                                                onClick={() =>
                                                                    this.handleToggleAccordion(
                                                                        0,
                                                                    )
                                                                }
                                                            >
                                                                Prevet Info{" "}
                                                                <i
                                                                    className={
                                                                        accordionNumber ===
                                                                            0
                                                                            ? "fa fa-chevron-up"
                                                                            : "fa fa-chevron-down"
                                                                    }
                                                                />
                                                            </Accordion.Toggle>
                                                        </Card.Header>
                                                        <Accordion.Collapse eventKey="0">
                                                            <Card.Body>
                                                                <span className="separator" />
                                                                <div className="relevent-info-box">
                                                                    <div className="relevent-infos">
                                                                        <div className="row">
                                                                            <div className="col-md-6 col-sm-12 col-xs-12">
                                                                                <div className="form-group">
                                                                                    <label>
                                                                                        First
                                                                                        Name
                                                                                    </label>
                                                                                    <p className="form-control-static">
                                                                                        {appData.field_firstname || (
                                                                                            <>
                                                                                                &mdash;
                                                                                            </>
                                                                                        )}
                                                                                    </p>
                                                                                </div>
                                                                                <div className="form-group">
                                                                                    <label>
                                                                                        Phone
                                                                                    </label>
                                                                                    <p className="form-control-static">
                                                                                        {appData.field_personalphone || (
                                                                                            <>
                                                                                                &mdash;
                                                                                            </>
                                                                                        )}
                                                                                    </p>
                                                                                </div>
                                                                                <div className="form-group">
                                                                                    <label>
                                                                                        DBA
                                                                                    </label>
                                                                                    <p className="form-control-static">
                                                                                        {appData.field_dba || (
                                                                                            <>
                                                                                                &mdash;
                                                                                            </>
                                                                                        )}
                                                                                    </p>
                                                                                </div>
                                                                                <div className="form-group">
                                                                                    <label>
                                                                                        Currently
                                                                                        Processing
                                                                                    </label>
                                                                                    <p className="form-control-static">
                                                                                        {appData.field_processing
                                                                                            ? "Yes"
                                                                                            : "No"}
                                                                                    </p>
                                                                                </div>
                                                                            </div>
                                                                            <div className="col-md-6 col-sm-12 col-xs-12">
                                                                                <div className="form-group">
                                                                                    <label>
                                                                                        Last
                                                                                        Name
                                                                                    </label>
                                                                                    <p className="form-control-static">
                                                                                        {appData.field_lastname &&
                                                                                            appData.field_lastname.toLowerCase() !==
                                                                                            "placeholder" ? (
                                                                                            appData.field_lastname
                                                                                        ) : (
                                                                                            <>
                                                                                                &mdash;
                                                                                            </>
                                                                                        )}
                                                                                    </p>
                                                                                </div>
                                                                                <div className="form-group">
                                                                                    <label>
                                                                                        Email
                                                                                    </label>
                                                                                    <p className="form-control-static">
                                                                                        {appData.field_email || (
                                                                                            <>
                                                                                                &mdash;
                                                                                            </>
                                                                                        )}
                                                                                    </p>
                                                                                </div>
                                                                                <div className="form-group">
                                                                                    <label>
                                                                                        Website
                                                                                    </label>
                                                                                    <p className="form-control-static">
                                                                                        {appData.field_website || (
                                                                                            <>
                                                                                                &mdash;
                                                                                            </>
                                                                                        )}
                                                                                    </p>
                                                                                </div>
                                                                                <div className="form-group">
                                                                                    <label>
                                                                                        Monthly
                                                                                        Volume
                                                                                    </label>
                                                                                    <p className="form-control-static">
                                                                                        {
                                                                                            appData.field_maxsales
                                                                                        }
                                                                                    </p>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </Card.Body>
                                                        </Accordion.Collapse>
                                                    </Card>
                                                )}
                                            </Accordion>
                                        </div>
                                        <div
                                            id="tab4"
                                            className={
                                                tab === "tab4"
                                                    ? "tab-pane fade in active"
                                                    : "tab-pane fade"
                                            }
                                        >
                                            <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 content-area-right-side-col">
                                                <div className="content-area-right-side ">
                                                    <div className="relevent-info-box notes-box">
                                                        <div className="panel-body">
                                                            {appData.ehawk !=
                                                                undefined &&
                                                                appData.ehawk
                                                                    .length >
                                                                0 &&
                                                                appData.ehawk.map(
                                                                    (
                                                                        ehawk,
                                                                        i,
                                                                    ) => (
                                                                        <div
                                                                            className={
                                                                                "panel panel-" +
                                                                                ehawk.signal
                                                                            }
                                                                        >
                                                                            <div
                                                                                className={
                                                                                    "panel-heading " +
                                                                                    this.getScoreClass(
                                                                                        ehawk.content,
                                                                                    )
                                                                                }
                                                                            >
                                                                                <h3 className="panel-title">
                                                                                    {" "}
                                                                                    {
                                                                                        ehawk.who
                                                                                    }
                                                                                    ,{" "}
                                                                                    {
                                                                                        ehawk.created_ago
                                                                                    }
                                                                                    <span>
                                                                                        {ehawk.date !=
                                                                                            null
                                                                                            ? "(" +
                                                                                            moment(
                                                                                                ehawk.date,
                                                                                            ).format(
                                                                                                "MMMM D",
                                                                                            ) +
                                                                                            ")"
                                                                                            : ""}{" "}
                                                                                        {"(" +
                                                                                            defaultBank.name +
                                                                                            ")"}
                                                                                    </span>
                                                                                </h3>
                                                                            </div>

                                                                            <div className="panel-body">
                                                                                {Object.entries(
                                                                                    ehawk.content,
                                                                                ).map(
                                                                                    (
                                                                                        element,
                                                                                        k,
                                                                                    ) =>
                                                                                        element[1] !=
                                                                                        null &&
                                                                                        typeof element[1] ==
                                                                                        "object" && (
                                                                                            <div
                                                                                                className="ehawk"
                                                                                                key={
                                                                                                    k
                                                                                                }
                                                                                            >
                                                                                                <h5>
                                                                                                    {element[0].toUpperCase()}
                                                                                                </h5>
                                                                                                <table
                                                                                                    className=" table table-bordered ehawk-table table-responsive"
                                                                                                    border="border:1px solid #eee;"
                                                                                                >
                                                                                                    <thead>
                                                                                                        <tr>
                                                                                                            {element[1] !=
                                                                                                                null &&
                                                                                                                Object.entries(
                                                                                                                    element[1],
                                                                                                                ).map(
                                                                                                                    (
                                                                                                                        ele,
                                                                                                                        key,
                                                                                                                    ) => (
                                                                                                                        <th
                                                                                                                            key={
                                                                                                                                key
                                                                                                                            }
                                                                                                                        >
                                                                                                                            {
                                                                                                                                ele[0]
                                                                                                                            }
                                                                                                                        </th>
                                                                                                                    ),
                                                                                                                )}
                                                                                                        </tr>
                                                                                                    </thead>
                                                                                                    <tbody>
                                                                                                        <tr>
                                                                                                            {element[1] !=
                                                                                                                null &&
                                                                                                                Object.entries(
                                                                                                                    element[1],
                                                                                                                ).map(
                                                                                                                    (
                                                                                                                        ele,
                                                                                                                        tdkey,
                                                                                                                    ) => (
                                                                                                                        <td
                                                                                                                            key={
                                                                                                                                tdkey
                                                                                                                            }
                                                                                                                        >
                                                                                                                            {
                                                                                                                                ele[1]
                                                                                                                            }
                                                                                                                        </td>
                                                                                                                    ),
                                                                                                                )}
                                                                                                        </tr>
                                                                                                    </tbody>
                                                                                                </table>
                                                                                            </div>
                                                                                        ),
                                                                                )}
                                                                                <div className="ehawk">
                                                                                    <table
                                                                                        className=" table table-bordered ehawk-table table-responsive"
                                                                                        border="border:1px solid #eee;"
                                                                                    >
                                                                                        <thead>
                                                                                            {Object.entries(
                                                                                                ehawk.content,
                                                                                            ).map(
                                                                                                (
                                                                                                    element,
                                                                                                    k,
                                                                                                ) =>
                                                                                                    element[1] !=
                                                                                                    null &&
                                                                                                    typeof element[1] !=
                                                                                                    "object" && (
                                                                                                        <tr
                                                                                                            key={
                                                                                                                k
                                                                                                            }
                                                                                                        >
                                                                                                            <th>
                                                                                                                {
                                                                                                                    element[0]
                                                                                                                }
                                                                                                            </th>
                                                                                                            <th>
                                                                                                                {
                                                                                                                    element[1]
                                                                                                                }
                                                                                                            </th>
                                                                                                        </tr>
                                                                                                    ),
                                                                                            )}
                                                                                        </thead>
                                                                                    </table>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    ),
                                                                )}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div
                                            id="tab6"
                                            className={
                                                tab === "tab6"
                                                    ? "tab-pane fade in active"
                                                    : "tab-pane fade"
                                            }
                                        >
                                            <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 content-area-right-side-col">
                                                <div className="content-area-right-side ">
                                                    <div className="relevent-info-box notes-box">
                                                        <div className="panel-body">
                                                            {appData.system_notes !=
                                                                undefined &&
                                                                appData.system_notes.map(
                                                                    (
                                                                        note,
                                                                        i,
                                                                    ) => (
                                                                        <div
                                                                            className={
                                                                                "applicationsnotes " +
                                                                                note.signal
                                                                            }
                                                                            key={
                                                                                i
                                                                            }
                                                                        >
                                                                            <p
                                                                                className="panel-body"
                                                                                dangerouslySetInnerHTML={{
                                                                                    __html: DOMPurify.sanitize(
                                                                                        note.content,
                                                                                    ),
                                                                                }}
                                                                            ></p>
                                                                            <div className="fulldetailsnote">
                                                                                <div className="notesdetails">
                                                                                    <div className="notesavt">
                                                                                        <img
                                                                                            src={
                                                                                                imgAvatarDefault
                                                                                            }
                                                                                        />
                                                                                    </div>
                                                                                    <div className="avtname">
                                                                                        <span>
                                                                                            {note.who !=
                                                                                                ""
                                                                                                ? note.who
                                                                                                : "Anonymous"}
                                                                                        </span>
                                                                                    </div>
                                                                                    <div className="avtdatetime">
                                                                                        <span>
                                                                                            {note.created_at !=
                                                                                                null ? (
                                                                                                moment(
                                                                                                    note.created_at,
                                                                                                ).format(
                                                                                                    "MMM D, YYYY | H:mm A",
                                                                                                )
                                                                                            ) : (
                                                                                                <>
                                                                                                    &mdash;
                                                                                                </>
                                                                                            )}{" "}
                                                                                            {note.bank !=
                                                                                                null
                                                                                                ? note.bank !=
                                                                                                    ""
                                                                                                    ? "(" +
                                                                                                    note.bank +
                                                                                                    ")"
                                                                                                    : "(" +
                                                                                                    defaultBank.name +
                                                                                                    ")"
                                                                                                : ""}
                                                                                        </span>
                                                                                    </div>
                                                                                </div>
                                                                                {user?.channel ==
                                                                                    "sales_channel" ? (
                                                                                    <>

                                                                                    </>
                                                                                ) : (
                                                                                    <span className="addresidualIMG">
                                                                                        <img src="/images/delet.svg " />
                                                                                    </span>
                                                                                )}
                                                                            </div>
                                                                        </div>
                                                                    ),
                                                                )}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div
                                            id="tab5"
                                            className={
                                                tab === "tab5"
                                                    ? "tab-pane fade in active"
                                                    : "tab-pane fade"
                                            }
                                        >
                                            {tab === "tab5" ? (
                                                <SendToService
                                                    appData={appData}
                                                    refreshApplicationList={
                                                        this
                                                            .refreshApplicationList
                                                    }
                                                    editSlug={
                                                        this.state?.appData
                                                            ?.editslug
                                                    }
                                                    reRender={
                                                        this.state.reRender
                                                    }
                                                />
                                            ) : null}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )}
                    </div>
                </div>
                <ConfirmModal
                    showLoader={this.state.showLoader}
                    show={this.state.confirm}
                    handleClose={(e) => this.handleClose()}
                    resendText={resend_sign}
                    confirmText={confirmText}
                    handleConfirm={(e) => this.progressionChanged()}
                    error_message={this.state.error_message}
                ></ConfirmModal>
                <CopyApplicationModal
                    isOpen={this.state.copyApplicationModal.isOpen}
                    handleClose={() => this.handleCloseCopyAppModal()}
                    appData={this.state.appData}
                    handConfirm={(new_dba) =>
                        this.handleConfirmCopyApp(new_dba)
                    }
                    showLoader={this.state.showLoader}
                />
                {this.state.showProgressApprovalModel === true && (
                    <ProgressApproval
                        showProgressApprovalModel={
                            this.state.showProgressApprovalModel
                        }
                        handleCloseModel={() =>
                            this.setState({ showProgressApprovalModel: false })
                        }
                        appData={this.state.appData}
                        handleProgression={(e) => this.progressionChanged()}
                    />
                )}
            </div>
        );

        const updateOwnershipModal = (
            <ReactModal
                isOpen={this.state.showOwnerModal}
                contentLabel="Minimal Modal Example"
                className="modal-change-owrnship"
            >
                <h4 className="text-center owner-title">Change Ownership</h4>
                <div className="row">
                    <div className="col-md-12 dd-change-ownership">
                        {pci_admin && (
                            <SelectDropDown
                                isSearchable={true}
                                options={organization_options}
                                name="owner_organization"
                                placeholder="Select organization"
                                value={owner_selected_organization}
                                handleChange={(selected) => {
                                    this.handleOwnerOrganizationChange(
                                        selected.value,
                                    );
                                }}
                            />
                        )}
                        <SelectDropDown
                            isSearchable={true}
                            options={this?.props?.user?.is_ems_pc_admin ? this.state.userListForFilterApp : user_options}
                            name="owner_users"
                            placeholder="Select user"
                            value={selected_owner}
                            handleChange={(selected) => {
                                this.handleOwnerChange(selected.value);
                            }}
                        />
                    </div>
                    <div className="col-md-12 owner-button-group">
                        <button
                            className="btn btn-danger close_modal"
                            onClick={this.handleCloseOwnerModal}
                        >
                            Close
                        </button>
                        <button
                            className="btn btn-success save_modal"
                            onClick={(e) => this.handleUpdateOwner()}
                        >
                            Save
                        </button>
                    </div>
                </div>
            </ReactModal>
        );

        const hideAppInfo = () => {
            this.setState({ activeId: null });
        };

        const onPrevetApplicationStatusButtonClickHandler = (
            powerappId,
            status,
        ) => {
            this.setState({
                prevetStatusMessage: "Your application status is changing.",
            });
            const data = {
                powerappId: powerappId,
                status: status,
            };
            ChangePrevetApplicationStatus(data)
                .then((res) => {
                    this.setState({
                        prevetStatusMessage:
                            "Your application status has been changed.",
                    });
                    this.getAppData();
                    // this.getPreappData(false);
                })
                .catch((err) => {
                    this.setState({
                        prevetStatusMessage:
                            "Something went wrong. Try again later.",
                    });
                })
                .finally(() =>
                    setTimeout(() => {
                        this.setState({ prevetStatusMessage: "" });
                    }, 4000),
                );
        };
        return (
            <div className="website-wrapper application-page table-application-page ">
                {this.state.showCreatedAppModel === true && (
                    <AddApplicationModal
                        editPrevetId={this.state.editPrevetId}
                        editPrevet={this.state.editPrevet}
                        showCreatedAppModel={this.state.showCreatedAppModel}
                        handleCloseCreatedAppModel={() =>
                            this.setState({ showCreatedAppModel: false })
                        }
                        getPreappData={this.props.getPreappData}
                        fullApplicationUrl={this.state.CreateUrl}
                        user={user}
                    />
                )}
                {show_spinner ? (
                    <div className="loader-wrap">
                        <p className="loader"></p>
                    </div>
                ) : (
                    ""
                )}

                {show_info && activeId ? (
                    <MobileAppDetailHeader
                        user={loggedInUser}
                        show_info={this.state.show_info}
                        activeId={this.state.activeId}
                        onLogout={this.logout}
                        hideAppInfo={(e) => hideAppInfo(e)}
                        showBanks={this.showBanks}
                        header_user_name={header_user_name}
                        resetfilter={() =>
                            this.LeftProgressionFilter("reset_filters")
                        }
                        handleCancle={() => this.handleCancle(activeId)}
                        handlePdfRun={() => this.handlePdfRun(activeId)}
                        handleAppCopy={() => this.handleAppCopy(activeId)}
                        handleChangeOwner={() => this.handleShowOwnerModal()}
                        handleEditApplication={() =>
                            this.handleEditApplication()
                        }
                        currentRoute={this.props.currentRoute}
                        tabShowActive={(route) =>
                            this.props.tabShowActive(route)
                        }
                    />
                ) : (
                    ""
                )}
                <div className="d-flex page-bottom-wrap" id="wrapper">
                    <div id="page-content-wrapper">
                        {updateOwnershipModal}
                        <ShowDocsModal
                            isOpen={this.state.docModal}
                            close={() => this.closeDocModal()}
                            file={this.state.docModalFile}
                        />
                        {showAlert && (
                            <div>
                                <AlertForSendSignature
                                    showAlert={showAlert}
                                    heading={alertHeader}
                                    message={alertMessage}
                                    variant="success"
                                    handleDismissible={() => {
                                        this.setState({ showAlert: false });
                                    }}
                                />
                            </div>
                        )}

                        <div className="row" onClick={(e) => this.hideSearch()}>
                            <div className="col-lg-12 text-right header-actions">
                                <ul>
                                    {check.length == 1 && (
                                        <li>
                                            <a
                                                name={
                                                    appData != undefined &&
                                                        appData.progression !=
                                                        undefined &&
                                                        appData.progression
                                                            .status != "Cancelled"
                                                        ? "cancel"
                                                        : "Re-Activate"
                                                }
                                                onClick={(e) =>
                                                    this.navigate(e)
                                                }
                                                className={
                                                    appData.id == undefined
                                                        ? "is_disable"
                                                        : "is_enable"
                                                }
                                            >
                                                <i
                                                    className="fa fa-scissors"
                                                    aria-hidden="true"
                                                ></i>{" "}
                                                {appData != undefined &&
                                                    appData.progression !=
                                                    undefined &&
                                                    appData.progression.status !=
                                                    "Cancelled"
                                                    ? "Cancel Preapp"
                                                    : " Re-Activate Preapp"}
                                            </a>
                                        </li>
                                    )}
                                    {check.length == 1 && (
                                        <li>
                                            <a
                                                name="ownership"
                                                onClick={(e) =>
                                                    this.navigate(e)
                                                }
                                                className={
                                                    appData.id == undefined
                                                        ? "is_disable"
                                                        : "is_enable"
                                                }
                                            >
                                                <i
                                                    className="fa fa-exchange"
                                                    aria-hidden="true"
                                                ></i>{" "}
                                                Change Ownership
                                            </a>
                                        </li>
                                    )}
                                    {check.length == 1 && (
                                        <li>
                                            <a
                                                name="Re-run"
                                                onClick={(e) =>
                                                    this.navigate(e)
                                                }
                                                className={
                                                    appData.id == undefined
                                                        ? "is_disable"
                                                        : "is_enable"
                                                }
                                            >
                                                <i
                                                    className="fa fa-repeat"
                                                    aria-hidden="true"
                                                ></i>{" "}
                                                Re-Run Application
                                            </a>
                                        </li>
                                    )}
                                    {check.length == 1 && (
                                        <li>
                                            <a
                                                name="Copy Application"
                                                onClick={(e) =>
                                                    this.navigate(e)
                                                }
                                                className={
                                                    appData.id == undefined
                                                        ? "is_disable"
                                                        : "is_enable"
                                                }
                                            >
                                                <i
                                                    className="fa fa-copy"
                                                    aria-hidden="true"
                                                ></i>{" "}
                                                Copy Application
                                            </a>
                                        </li>
                                    )}
                                </ul>
                            </div>
                        </div>

                        <div className="container-fluid container-fluid-right">
                            <ReactTooltip
                                effect="solid"
                                place="right"
                                className="tool-tip"
                            />
                            <div className="row main-first-row resizer-divided">
                                <div
                                    className="sidebar-navb-new"
                                    id="sidebar-wrapper-new"
                                >
                                    <a
                                        className="navb-button"
                                        onClick={(e) => this.handleMenu()}
                                    >
                                        {mobileMenu && filterToggle ? (
                                            <i className="fa fa-angle-left" />
                                        ) : (
                                            <i className="fa fa-angle-right" />
                                        )}
                                    </a>

                                    <div
                                        className={
                                            filterToggle
                                                ? "list-group list-group-flush"
                                                : "list-group list-group-flush d-none"
                                        }
                                    >
                                        <nav
                                            className={
                                                mobileMenu
                                                    ? "navb show-sidemenu"
                                                    : "navb"
                                            }
                                        >
                                            {this.props.user?.channel !=
                                                "isv_channel" ? (
                                                <ul>
                                                    <li>
                                                        <a
                                                            name="reset_filters"
                                                            className={
                                                                left_progression_filter ===
                                                                    "reset_filters"
                                                                    ? "active"
                                                                    : ""
                                                            }
                                                            onClick={() =>
                                                                this.LeftProgressionFilter(
                                                                    "reset_filters",
                                                                )
                                                            }
                                                            data-tip="Reset Filters - Stratus"
                                                        >
                                                            <i
                                                                className="fa fa-circle reset_filters"
                                                                aria-hidden="true"
                                                                style={{
                                                                    color: "#000000",
                                                                }}
                                                            />
                                                        </a>
                                                    </li>
                                                    <li>
                                                        <a
                                                            name="working_lead"
                                                            className={
                                                                left_progression_filter ===
                                                                    "working_lead"
                                                                    ? "active"
                                                                    : ""
                                                            }
                                                            onClick={() =>
                                                                this.LeftProgressionFilter(
                                                                    "working_lead",
                                                                )
                                                            }
                                                            data-tip="Working Lead"
                                                        >
                                                            <i
                                                                className="fa fa-circle"
                                                                aria-hidden="true"
                                                                style={{
                                                                    color: "#b6d7a8",
                                                                }}
                                                            />
                                                        </a>
                                                    </li>
                                                    <li>
                                                        <a
                                                            name="app_in_progress"
                                                            className={
                                                                left_progression_filter ===
                                                                    "app_in_progress"
                                                                    ? "active"
                                                                    : ""
                                                            }
                                                            onClick={() =>
                                                                this.LeftProgressionFilter(
                                                                    "app_in_progress",
                                                                )
                                                            }
                                                            data-tip="App in Progress"
                                                        >
                                                            <i
                                                                className="fa fa-circle"
                                                                aria-hidden="true"
                                                                style={{
                                                                    color: "#a2c4c9",
                                                                }}
                                                            />
                                                        </a>
                                                    </li>
                                                    <li>
                                                        <a
                                                            name="sent_for_signature"
                                                            className={
                                                                left_progression_filter ===
                                                                    "sent_for_signature"
                                                                    ? "active"
                                                                    : ""
                                                            }
                                                            onClick={() =>
                                                                this.LeftProgressionFilter(
                                                                    "sent_for_signature",
                                                                )
                                                            }
                                                            data-tip="Sent For Signature"
                                                        >
                                                            <i
                                                                className="fa fa-circle"
                                                                aria-hidden="true"
                                                                style={{
                                                                    color: "#a4c2f4",
                                                                }}
                                                            />
                                                        </a>
                                                    </li>
                                                    <li>
                                                        <a
                                                            name="signed"
                                                            className={
                                                                left_progression_filter ===
                                                                    "signed"
                                                                    ? "active"
                                                                    : ""
                                                            }
                                                            onClick={() =>
                                                                this.LeftProgressionFilter(
                                                                    "signed",
                                                                )
                                                            }
                                                            data-tip="Signed"
                                                        >
                                                            <i
                                                                className="fa fa-circle"
                                                                aria-hidden="true"
                                                                style={{
                                                                    color: "#b4a7d6",
                                                                }}
                                                            />
                                                        </a>
                                                    </li>
                                                    <li>
                                                        <a
                                                            name="pending_docs"
                                                            className={
                                                                left_progression_filter ===
                                                                    "pending_docs"
                                                                    ? "active"
                                                                    : ""
                                                            }
                                                            onClick={() =>
                                                                this.LeftProgressionFilter(
                                                                    "pending_docs",
                                                                )
                                                            }
                                                            data-tip="Pending Docs"
                                                        >
                                                            <i
                                                                className="fa fa-circle"
                                                                aria-hidden="true"
                                                                style={{
                                                                    color: "#ffe599",
                                                                }}
                                                            />
                                                        </a>
                                                    </li>

                                                    <li>
                                                        <a
                                                            name="underwriting"
                                                            className={
                                                                left_progression_filter ===
                                                                    "underwriting"
                                                                    ? "active"
                                                                    : ""
                                                            }
                                                            onClick={() =>
                                                                this.LeftProgressionFilter(
                                                                    "underwriting",
                                                                )
                                                            }
                                                            data-tip="Underwriting"
                                                        >
                                                            <i
                                                                className="fa fa-circle"
                                                                aria-hidden="true"
                                                                style={{
                                                                    color: "#ffff00",
                                                                }}
                                                            />
                                                        </a>
                                                    </li>
                                                    <li>
                                                        <a
                                                            name="approved"
                                                            className={
                                                                left_progression_filter ===
                                                                    "approved"
                                                                    ? "active"
                                                                    : ""
                                                            }
                                                            onClick={() =>
                                                                this.LeftProgressionFilter(
                                                                    "approved",
                                                                )
                                                            }
                                                            data-tip="Approved"
                                                        >
                                                            <i
                                                                className="fa fa-circle"
                                                                aria-hidden="true"
                                                                style={{
                                                                    color: "#34a853",
                                                                }}
                                                            />
                                                        </a>
                                                    </li>
                                                    <li>
                                                        <a
                                                            name="declined"
                                                            className={
                                                                left_progression_filter ===
                                                                    "declined"
                                                                    ? "active"
                                                                    : ""
                                                            }
                                                            onClick={() =>
                                                                this.LeftProgressionFilter(
                                                                    "declined",
                                                                )
                                                            }
                                                            data-tip="Declined"
                                                        >
                                                            <i
                                                                className="fa fa-circle"
                                                                aria-hidden="true"
                                                                style={{
                                                                    color: "#ea4335",
                                                                }}
                                                            />
                                                        </a>
                                                    </li>
                                                    <li>
                                                        <a
                                                            name="unworkable"
                                                            className={
                                                                left_progression_filter ===
                                                                    "unworkable"
                                                                    ? "active"
                                                                    : ""
                                                            }
                                                            onClick={() =>
                                                                this.LeftProgressionFilter(
                                                                    "unworkable",
                                                                )
                                                            }
                                                            data-tip="Unworkable"
                                                        >
                                                            <i
                                                                className="fa fa-circle"
                                                                aria-hidden="true"
                                                                style={{
                                                                    color: "#ff6d01",
                                                                }}
                                                            />
                                                        </a>
                                                    </li>
                                                </ul>
                                            ) : (
                                                <ul>
                                                    <li>
                                                        <a
                                                            name="reset_filters"
                                                            className={
                                                                left_progression_filter ===
                                                                    "reset_filters"
                                                                    ? "active"
                                                                    : ""
                                                            }
                                                            onClick={() =>
                                                                this.LeftProgressionFilter(
                                                                    "reset_filters",
                                                                )
                                                            }
                                                            data-tip="Reset Filters - Stratus"
                                                        >
                                                            <i
                                                                className="fa fa-circle reset_filters"
                                                                aria-hidden="true"
                                                                style={{
                                                                    color: "#000000",
                                                                }}
                                                            />
                                                        </a>
                                                    </li>
                                                    <li>
                                                        <a
                                                            name="pending_prevet"
                                                            className={
                                                                left_progression_filter ===
                                                                    "prevet"
                                                                    ? "active"
                                                                    : ""
                                                            }
                                                            onClick={() =>
                                                                this.LeftProgressionFilter(
                                                                    "pending_prevet",
                                                                )
                                                            }
                                                            data-tip="Pending Prevet"
                                                        >
                                                            <i
                                                                className="fa fa-circle"
                                                                aria-hidden="true"
                                                                style={{
                                                                    color: "#C5C5C5",
                                                                }}
                                                            />
                                                        </a>
                                                    </li>
                                                    <li>
                                                        <a
                                                            name="prevet_approved"
                                                            className={
                                                                left_progression_filter ===
                                                                    "prevet_approved"
                                                                    ? "active"
                                                                    : ""
                                                            }
                                                            onClick={() =>
                                                                this.LeftProgressionFilter(
                                                                    "prevet_approved",
                                                                )
                                                            }
                                                            data-tip="Prevet Approved"
                                                        >
                                                            <i
                                                                className="fa fa-circle"
                                                                aria-hidden="true"
                                                                style={{
                                                                    color: "#FFFF00",
                                                                }}
                                                            />
                                                        </a>
                                                    </li>
                                                    <li>
                                                        <a
                                                            name="app_in_progress"
                                                            className={
                                                                left_progression_filter ===
                                                                    "app_in_progress"
                                                                    ? "active"
                                                                    : ""
                                                            }
                                                            onClick={() =>
                                                                this.LeftProgressionFilter(
                                                                    "app_in_progress",
                                                                )
                                                            }
                                                            data-tip="App in Progress"
                                                        >
                                                            <i
                                                                className="fa fa-circle"
                                                                aria-hidden="true"
                                                                style={{
                                                                    color: "#00008b",
                                                                }}
                                                            />
                                                        </a>
                                                    </li>
                                                    <li className="navb-submenu">
                                                        <a
                                                            name="signature"
                                                            className={
                                                                left_progression_filter ===
                                                                    "signature"
                                                                    ? "active"
                                                                    : ""
                                                            }
                                                            onClick={() =>
                                                                this.LeftProgressionFilter(
                                                                    "signature",
                                                                )
                                                            }
                                                            data-tip="Sent for Signature or PDF Requested"
                                                        >
                                                            <i
                                                                className="fa fa-circle"
                                                                aria-hidden="true"
                                                                style={{
                                                                    color: "#F0BE74",
                                                                }}
                                                            />
                                                        </a>
                                                    </li>
                                                    <li>
                                                        <a
                                                            name="signedapp_prebank"
                                                            className={
                                                                left_progression_filter ===
                                                                    "signedapp_prebank"
                                                                    ? "active"
                                                                    : ""
                                                            }
                                                            onClick={() =>
                                                                this.LeftProgressionFilter(
                                                                    "signedapp_prebank",
                                                                )
                                                            }
                                                            data-tip="Signed - PC Review"
                                                        >
                                                            <i
                                                                className="fa fa-circle"
                                                                aria-hidden="true"
                                                                style={{
                                                                    color: "#819FEC",
                                                                }}
                                                            />
                                                        </a>
                                                    </li>
                                                    <li>
                                                        <a
                                                            name="underwriting_review"
                                                            className={
                                                                left_progression_filter ===
                                                                    "underwriting_review"
                                                                    ? "active"
                                                                    : ""
                                                            }
                                                            onClick={() =>
                                                                this.LeftProgressionFilter(
                                                                    "underwriting_review",
                                                                )
                                                            }
                                                            data-tip="Underwriting Review"
                                                        >
                                                            <i
                                                                className="fa fa-circle"
                                                                aria-hidden="true"
                                                                style={{
                                                                    color: "#7FCECE",
                                                                }}
                                                            />
                                                        </a>
                                                    </li>

                                                    <li className="navb-submenu">
                                                        <a
                                                            name="underwriting_action"
                                                            className={
                                                                left_progression_filter ===
                                                                    "underwriting_action"
                                                                    ? "active"
                                                                    : ""
                                                            }
                                                            onClick={() =>
                                                                this.LeftProgressionFilter(
                                                                    "underwriting_action",
                                                                )
                                                            }
                                                            data-tip="Pended"
                                                        >
                                                            <i
                                                                className="fa fa-circle"
                                                                aria-hidden="true"
                                                                style={{
                                                                    color: "#E7B8DF",
                                                                }}
                                                            />
                                                        </a>
                                                    </li>
                                                    <li>
                                                        <a
                                                            name="awaiting_reserve"
                                                            className={
                                                                left_progression_filter ===
                                                                    "awaiting_reserve"
                                                                    ? "active"
                                                                    : ""
                                                            }
                                                            onClick={() =>
                                                                this.LeftProgressionFilter(
                                                                    "awaiting_reserve",
                                                                )
                                                            }
                                                            data-tip="Awaiting Reserve"
                                                        >
                                                            <i
                                                                className="fa fa-circle"
                                                                aria-hidden="true"
                                                                style={{
                                                                    color: "#44AE42",
                                                                }}
                                                            />
                                                        </a>
                                                    </li>
                                                    <li>
                                                        <a
                                                            name="approved"
                                                            className={
                                                                left_progression_filter ===
                                                                    "approved"
                                                                    ? "active"
                                                                    : ""
                                                            }
                                                            onClick={() =>
                                                                this.LeftProgressionFilter(
                                                                    "approved",
                                                                )
                                                            }
                                                            data-tip="Approved"
                                                        >
                                                            <i
                                                                className="fa fa-circle"
                                                                aria-hidden="true"
                                                                style={{
                                                                    color: "#44AE42",
                                                                }}
                                                            />
                                                        </a>
                                                    </li>
                                                    <li>
                                                        <a
                                                            name="declined"
                                                            className={
                                                                left_progression_filter ===
                                                                    "declined"
                                                                    ? "active"
                                                                    : ""
                                                            }
                                                            onClick={() =>
                                                                this.LeftProgressionFilter(
                                                                    "declined",
                                                                )
                                                            }
                                                            data-tip="Declined"
                                                        >
                                                            <i
                                                                className="fa fa-circle"
                                                                aria-hidden="true"
                                                                style={{
                                                                    color: "#FFA500",
                                                                }}
                                                            />
                                                        </a>
                                                    </li>

                                                    <li>
                                                        <a
                                                            name="cancelled"
                                                            className={
                                                                left_progression_filter ===
                                                                    "cancelled"
                                                                    ? "active"
                                                                    : ""
                                                            }
                                                            onClick={() =>
                                                                this.LeftProgressionFilter(
                                                                    "cancelled",
                                                                )
                                                            }
                                                            data-tip="Cancelled"
                                                        >
                                                            <i
                                                                className="fa fa-circle"
                                                                aria-hidden="true"
                                                                style={{
                                                                    color: "#660000",
                                                                }}
                                                            />
                                                        </a>
                                                    </li>

                                                    <li>
                                                        <a
                                                            name="terminated"
                                                            className={
                                                                left_progression_filter ===
                                                                    "terminated"
                                                                    ? "active"
                                                                    : ""
                                                            }
                                                            onClick={() =>
                                                                this.LeftProgressionFilter(
                                                                    "terminated",
                                                                )
                                                            }
                                                            data-tip="Terminated"
                                                        >
                                                            <i
                                                                className="fa fa-circle"
                                                                aria-hidden="true"
                                                                style={{
                                                                    color: "#FF0000",
                                                                }}
                                                            />
                                                        </a>
                                                    </li>
                                                    <li>
                                                        <a
                                                            name="support"
                                                            className={
                                                                left_progression_filter ===
                                                                    "support"
                                                                    ? "active"
                                                                    : ""
                                                            }
                                                            onClick={() =>
                                                                this.LeftProgressionFilter(
                                                                    "support",
                                                                )
                                                            }
                                                            data-tip="Support"
                                                        >
                                                            <i
                                                                className="fa fa-circle"
                                                                aria-hidden="true"
                                                                style={{
                                                                    color: "#0000FF",
                                                                }}
                                                            />
                                                        </a>
                                                    </li>
                                                </ul>
                                            )}
                                        </nav>
                                    </div>
                                </div>
                                {isMobile ? (
                                    <>
                                        {show_info &&
                                            activeId &&
                                            !showExpandedInfo ? (
                                            <>{rightContent}</>
                                        ) : (
                                            <>{leftContent}</>
                                        )}
                                    </>
                                ) : (
                                    <div className="resize-wrapper">
                                        <div className="resizer">
                                            {leftContent}
                                        </div>
                                        <ColumnResizer
                                            className="columnResizer"
                                            minWidth={0}
                                        />
                                        {this.state.showMerchantInfoLoader ===
                                            true ? (
                                            <div className="rightContentWrap">
                                                <p className="loader"></p>
                                            </div>
                                        ) : (
                                            <div className="rightContentWrap">
                                                {rightContent}
                                            </div>
                                        )}
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                    {changeBankPopUp && (
                        <AssignBankModal
                            show={changeBankPopUp}
                            onClose={() =>
                                this.setState({ changeBankPopUp: "" })
                            }
                        />
                    )}
                    {banks.length ? (
                        <BanksModal
                            show={this.state.show_banks}
                            handleClose={(e) => this.handleClose()}
                            banks={banks}
                            bankChange={(e) => this.bankChange()}
                            appId={this.state.activeId}
                            childApp={this.state.createChildApp}
                        />
                    ) : null}
                    {this.state.showOtpModel ? (
                        <EditMobileNumberModal
                            show={this.state.showOtpModel}
                            handleClose={(e) => this.handleClose()}
                            mobile={parseInt(
                                appData?.otp_phone_number
                                    ?.toString()
                                    ?.substring(2),
                            )}
                            mobile_2={
                                appData?.otp_phone_number_2 == null
                                    ? null
                                    : parseInt(appData?.otp_phone_number_2)
                            }
                            slug={appData.editslug}
                            appId={this.state.activeId}
                            mobileUpdate={(e) => this.mobileUpdate()}
                        />
                    ) : null}
                    {this.state.showEmailModel ? (
                        <EditEmailModal
                            show={this.state.showEmailModel}
                            handleClose={(e) => this.handleClose()}
                            email={appData?.otp_email}
                            email_2={appData?.email_2}
                            slug={appData.editslug}
                            appId={this.state.activeId}
                            emailUpdate={(e) => this.emailUpdate()}
                        />
                    ) : null}
                    {this.state.showGenerateModal ? (
                        <ShowGenerateModal
                            show={this.state.showGenerateModal}
                            onClose={() =>
                                this.setState({ showGenerateModal: false })
                            }
                            id={appData.id}
                            slug={appData.editslug}
                            user={user}
                        />
                    ) : null}
                    {this.state.editZohoModal && (
                        <EditZoho
                            isOpen={this.state.editZohoModal}
                            onClose={this.updateEditZohoModalState}
                            appData={this.state.appData}
                            getAppData={this.getAppData}
                            zohoIdType={this.state.zohoIdType}
                        />
                    )}
                    {this.state.editUwModal && (
                        <UwModal
                            isOpen={this.state.editUwModal}
                            onClose={this.updateEditUWModalState}
                            uwData={relationManager}
                            appData={this.state.appData}
                            getAppData={this.getAppData}
                        />
                    )}

                    {this.state.assign_pe_template ? (
                        <AssignTemplateModal
                            show={this.state.assign_pe_template}
                            handleClose={(e) =>
                                this.setState({ assign_pe_template: false })
                            }
                            slug={appData.editslug}
                            appId={this.state.activeId}
                        />
                    ) : null}

                    {this.state.assign_pricing_equipment_template ? (
                        <AddPricingEquipmentModal
                            user={user}
                            slug={appData.editslug}
                            appId={this.state.activeId}
                            isOpen={this.state.assign_pricing_equipment_template}
                            close={() =>
                                this.setState({ assign_pricing_equipment_template: false })
                            }
                        />
                    ) : null}

                    <div
                        className={
                            todo
                                ? "tasks-drawer tasks-drawer-show"
                                : "tasks-drawer"
                        }
                    >
                        <a
                            className="tasks-drawer-close"
                            onClick={(e) => this.closeDrawer()}
                        >
                            <i className="fa fa-close"></i>
                        </a>
                        <div className="tasks-drawer-in">
                            <div className="tasks-drawer-header">
                                <p>TASKS</p>
                                <h3>
                                    {user != null && user.name != undefined
                                        ? user.name + " List"
                                        : " List"}
                                </h3>
                            </div>
                            <div className="tasks-drawer-add">
                                <div className="tasks-drawer-add-top">
                                    <a onClick={(e) => this.addTasks()}>
                                        <span>+</span> <em>Add a task</em>
                                    </a>
                                    <span className="v-ellipsis-dots">
                                        <i
                                            className="fa fa-ellipsis-v"
                                            aria-hidden="true"
                                            onClick={(e) =>
                                                this.handleFilterMenu()
                                            }
                                        ></i>
                                    </span>
                                    {FilterMenu && (
                                        <div className="v-ellipsis-dots-box">
                                            <p>Filter by</p>
                                            <ul>
                                                <li>
                                                    <a
                                                        name="incompleted"
                                                        onClick={(e) =>
                                                            this.changeFilter(e)
                                                        }
                                                    >
                                                        In-Complete{" "}
                                                        {filterBy == "no" ? (
                                                            <i className="fa fa-check-circle"></i>
                                                        ) : (
                                                            ""
                                                        )}
                                                    </a>
                                                </li>
                                                <li>
                                                    <a
                                                        name="completed"
                                                        onClick={(e) =>
                                                            this.changeFilter(e)
                                                        }
                                                    >
                                                        Completed{" "}
                                                        {filterBy == "yes" ? (
                                                            <i className="fa fa-check-circle"></i>
                                                        ) : (
                                                            ""
                                                        )}
                                                    </a>
                                                </li>
                                            </ul>
                                        </div>
                                    )}
                                </div>
                                {add_todo && (
                                    <div className="tasks-drawer-add-bottom">
                                        <form>
                                            <div className="tasks-add">
                                                <input
                                                    type="text"
                                                    name="todo_text"
                                                    value={this.state.todo_text}
                                                    onChange={(e) =>
                                                        this.todoChange(e)
                                                    }
                                                ></input>
                                            </div>
                                            <button
                                                className="btn btn-primary"
                                                type="button"
                                                name="todo_text"
                                                value={this.state.todo_text}
                                                onClick={(e) =>
                                                    this.todoSubmit(e)
                                                }
                                            >
                                                Save
                                            </button>
                                        </form>
                                    </div>
                                )}
                                {todo_list && (
                                    <div className="tasks-drawer-add-bottom todo-list">
                                        {Object.entries(todo_list).map(
                                            (element, k) => (
                                                <div key={element[1].id}>
                                                    <div className="tasks-add">
                                                        <div>
                                                            <input
                                                                type="text"
                                                                onClick={(e) =>
                                                                    this.editTodo(
                                                                        element[1]
                                                                            .id,
                                                                    )
                                                                }
                                                                name="todo_text"
                                                                value={
                                                                    element[1]
                                                                        .text
                                                                }
                                                                onChange={(e) =>
                                                                    this.handleTodo(
                                                                        e,
                                                                        k,
                                                                    )
                                                                }
                                                            ></input>
                                                            <div className="tasks-drawer-checkbox">
                                                                <label
                                                                    className="checkbox-label"
                                                                    data-toggle="tooltip"
                                                                    title="click to mark as complete"
                                                                >
                                                                    <input
                                                                        type="checkbox"
                                                                        name="term_and_condition"
                                                                        onChange={(
                                                                            e,
                                                                        ) =>
                                                                            this.completeTodo(
                                                                                e,
                                                                                element[1],
                                                                            )
                                                                        }
                                                                        checked={
                                                                            element[1]
                                                                                .is_completed ==
                                                                            "yes"
                                                                        }
                                                                    ></input>
                                                                    <span className="checkmark"></span>
                                                                </label>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    {todo_id ==
                                                        element[1].id && (
                                                            <div className="action-btn">
                                                                <i
                                                                    className="fa fa-pencil-square icon-4x btn btn-primary"
                                                                    aria-hidden="true"
                                                                    onClick={(e) =>
                                                                        this.todoUpdate(
                                                                            e,
                                                                            element[1],
                                                                        )
                                                                    }
                                                                >
                                                                    {" "}
                                                                    Update
                                                                </i>
                                                                <i
                                                                    className="fa fa-trash icon-4x btn btn-danger"
                                                                    aria-hidden="true"
                                                                    onClick={(e) =>
                                                                        this.removeTodo(
                                                                            element[1]
                                                                                .id,
                                                                        )
                                                                    }
                                                                ></i>
                                                            </div>
                                                        )}
                                                </div>
                                            ),
                                        )}
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
                {showAlertApplist && (
                    <div>
                        <NotifyAlert
                            showAlert={showAlertApplist}
                            heading={alertHeader}
                            message={alertMessage}
                            variant="success"
                            handleDismissible={() => {
                                this.setState({ showAlertApplist: false });
                            }}
                        />
                    </div>
                )}
                {this.state.var_sheet_modal && (
                    <VarSheetModal
                        show={this.state.var_sheet_modal}
                        close={() => this.setState({ var_sheet_modal: false })}
                        data={appData?.power_app_submission?.var_sheet}
                        appId={appData.id}
                    />
                )}
            </div>
        );
    }
}
export default withRouter(Preapps);
